webpackJsonp([1],Array(40).concat([
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cache = { categories: {}, dataReady: undefined };
function prepareCache(instance) {
	if (cache.dataReady === undefined) {
		cache.dataReady = false;
		instance.$http.get('backend://category').then(function (result) {
			var newCategories = {};
			for (var i = 0; i < result.body.items.length; i++) {
				var item = result.body.items[i];
				newCategories[item.id] = item;
			}
			cache.categories = newCategories;
			cache.dataReady = true;
		});
	}
}
function updateCache(instance) {
	cache.dataReady = undefined;
	prepareCache(instance);
}

module.exports = {
	data: cache,
	prepare: prepareCache,
	update: updateCache
};

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(443)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(661),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cache = { sections: {}, dataReady: undefined };
function prepareCache(instance) {
	if (cache.dataReady === undefined) {
		cache.dataReady = false;
		instance.$http.get('backend://section').then(function (result) {
			var newSections = {};
			for (var i = 0; i < result.body.items.length; i++) {
				var item = result.body.items[i];
				newSections[item.id] = item;
			}
			cache.sections = newSections;
			cache.dataReady = true;
		});
	}
}
function updateCache(instance) {
	cache.dataReady = undefined;
	prepareCache(instance);
}

module.exports = {
	data: cache,
	prepare: prepareCache,
	update: updateCache
};

/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(422)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(635),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(427)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(641),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(434)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getIterator2 = __webpack_require__(49);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(106);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(68);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.$ = window.jQuery = __webpack_require__(6);
__webpack_require__(301);

window.Waves = __webpack_require__(577);
__webpack_require__(571);
delete window.Waves;

var Vue = __webpack_require__(101);
var VeeValidate = __webpack_require__(590);

var VueI18n = __webpack_require__(591);
var Toasted = __webpack_require__(679).default;

Vue.use(Toasted);
Vue.use(VueI18n);

Vue.config.common = __webpack_require__(309);
Vue.config.appcfg = __webpack_require__(308);
Vue.config.lang = Vue.config.appcfg.lang;
Vue.config.backend = Vue.config.appcfg.backend;

var locales = __webpack_require__(311);
(0, _keys2.default)(locales).forEach(function (lang) {
	Vue.locale(lang, locales[lang]);
});

Vue.use(VeeValidate, {
	errorBagName: 'errorBag',
	locale: Vue.config.lang,
	dictionary: {
		bg: __webpack_require__(312)
	}
});

Vue.component('c-avatar', __webpack_require__(603));
Vue.component('c-uavatar', __webpack_require__(604));
Vue.component('c-categories', __webpack_require__(605));
Vue.component('f-input', __webpack_require__(609));
Vue.component('f-select', __webpack_require__(613));
Vue.component('f-category', __webpack_require__(606));
Vue.component('f-textarea', __webpack_require__(614));
Vue.component('f-radio', __webpack_require__(612));
Vue.component('f-image', __webpack_require__(608));
Vue.component('f-pager', __webpack_require__(611));
Vue.component('f-modal', __webpack_require__(610));
Vue.component('f-family', __webpack_require__(602));

var VueResource = __webpack_require__(676).default;
var VueRouter = __webpack_require__(677).default;

Vue.use(VueResource);
Vue.use(VueRouter);

var routes = __webpack_require__(313);
var auth = __webpack_require__(307);

var filters = __webpack_require__(310);

Vue.filter('count', filters.count);
Vue.filter('domain', filters.domain);
Vue.filter('prettyDate', filters.prettyDate);
Vue.filter('prettyDateTime', filters.prettyDateTime);
Vue.filter('fromNowDateTime', filters.fromNowDateTime);
Vue.filter('pluralize', filters.pluralize);
Vue.filter('nl2br', filters.nl2br);

var AppView = __webpack_require__(593);

Vue.http.options.credentials = true;
Vue.http.interceptors.push(function (request, next) {
	request.url = request.url.replace(/^backend:\//, Vue.config.backend);

	next();
});

Vue.http.interceptors.push(function (request, next) {
	next(function (response) {
		if (!response.body) {
			return _promise2.default.reject(new Error(response.statusText));
		}
		if (response.body.error !== undefined) {
			var errors = [];
			errors.push(response.body.error);
			for (var err in response.body.errors) {
				errors.push('Моля, попълнете правилно поле: ' + err);
			}
			return _promise2.default.reject(new Error(errors.join('\n')));
		}
		return response;
	});
});

Vue.http.toastCatcher = function (exception) {
	if (exception instanceof Error) {
		exception = exception.text || exception.message || '';
	}
	exception = exception + '';

	var errors = exception.split('\n');

	if (errors.length === 0) {
		errors = ['Изпълнението на операцията е неуспешно. Моля, опитайте отново.'];
	}

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = (0, _getIterator3.default)(errors), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var error = _step.value;

			window.app.$toasted.show(error).goAway(1500);
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
};

Vue.http.putOrPostResource = function (url, body, options) {
	if (body.id === undefined) {
		return this.post(url, body, options);
	} else {
		url = url.replace(/\/$/, '') + '/' + encodeURIComponent(body.id);
		return this.put(url, body, options);
	}
};

var router = new VueRouter({
	routes: routes,
	mode: 'history',
	base: '/network/',
	scrollBehavior: function scrollBehavior(to, from, savedPosition) {
		return savedPosition || { x: 0, y: 0 };
	}
});

router.beforeEach(function (to, from, next) {
	var nextPath = to.fullPath;
	var p = _promise2.default.resolve();
	if (to.fullPath.match(/^\/login/)) {} else if (to.fullPath.match(/^\/logout/)) {
		auth.logout(router.app);
		nextPath = '/login';
	} else {
		p = auth.getUser(router.app).then(function (user) {
			if (user) {
				if (to.fullPath.match(/^\/moderate/) && (user.role === 'moderator' || user.role === 'admin')) {} else if (user.familyUser === undefined) {
					if (!to.fullPath.match(/^\/registration/)) {
						nextPath = '/registration';
					}
				} else {
					if (to.fullPath.match(/^\/registration|^\/moderate/)) {
						nextPath = '/';
					} else {}
				}
			} else {
				nextPath = '/login';
			}
		});
	}
	p.then(function () {
		if (to.fullPath !== nextPath) {
			next({
				path: nextPath,
				query: nextPath === '/login' && to.fullPath !== '/logout' ? { redirect: to.fullPath } : {}
			});
		} else {
			next();
		}
	});
});

Vue.mixin({
	data: function data() {
		return {
			_validationData: {}
		};
	},
	computed: {
		$validationData: function $validationData() {
			return this.$data._validationData;
		},
		$config: function $config() {
			return Vue.config.common;
		},
		$user: function $user() {
			return this.$root.user;
		}
	}
});

window.app = new Vue({
	el: '#root',
	router: router,
	data: {
		user: undefined
	},
	render: function render(h) {
		return h(AppView);
	}
});

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"paths": {
		"BG-Бл": {
			"path": "M110.72813,285.41737l2.65,-0.98l3.16,0.75l2.6,-2.03l1.29,-2.22l1.43,-7.87l1.18,-1.51l2.39,-0.09l1.32,0.9l2.86,-0.81l1.92,3.83l3.38,1.53l1.53,0.08l1,-0.81l-1.33,-2.4l0.53,-1.33l2.72,0l0,0l-1,2.41l0.27,2.57l2.21,1.33l-0.29,3.62l1.69,5.06l-0.35,2.7l2.36,1.84l-0.06,0.62l-3.88,1.71l-3.21,3.3l-0.35,1.29l2.47,17.2l2.35,2.64l6.02,2.12l10.33,6.66l7.51,7.61l5.82,4.57l0,0l1.06,2.27l-3.17,4.45l0.35,3.28l-2.46,6.06l0.13,2.87l0,0l-0.17,5.02l1.21,2.54l-2.32,1.84l-2.33,-0.17l-0.82,-1.73l-4.36,3.82l-2.86,-1.56l-1.23,-2.91l-1.73,-1.05l-0.65,2.91l-1.48,1.02l-1.22,-0.44l-2.18,0.55l-0.61,1.22l-4.95,0.44l-1.1,2.79l-2.26,2.5l-0.64,-0.79l-2.9,-0.7l-3.47,0.45l-1.97,-0.76l-2.46,1.97l-0.42,2.08l-2.81,0.43l-1.82,-0.24l-1.79,-1.66l-2.92,0.41l-2.2,-2.26l-4.02,0.76l-4.69,-0.96l-1.63,0.9l-1.67,-0.31l-6.030001,4.78l-1.99,-4.55l-3.8,-0.07l-2.49,2.34l-2.47,0.94l-0.57,1.05l0.43,2.43l-2.37,3.16l-6.63,1.48l-5.29,-0.13l-5.54,-2.64l-2.06,0.68l-6.56,-1.25l-0.38,-0.32l1.19,-1.36l1.68,-0.41l-0.34,-3.43l0.52,-1.72l-1.42,-3.08l2.61,-3.72l-1.38,-2.27l0.27,-1.42l-0.62,-0.29l-0.25,-2.31l1.02,-1.22l0.1,-1.58l-1.13,-2.54l1.13,-1.06l0.27,-2.33l-0.73,-2.28l-1.28,-1.08l0.21,-4.03l-0.63,-1.91l1.04,-1.77l2.51,-0.18l-0.28,-1.07l1.12,-2.18l3.96,-5.01l-0.19,-2.44l-2.13,-4.87l-4.44,-0.93l0.09,-1.81l-2.38,-3.83l-0.42,-3.93l-2.02,-3.79l-1.33,-0.11l-0.74,-5.09l-1.96,-2.64l0.31,-5.24l-0.17,-2.66l-0.94,-0.94l0.25,-1.44l0,0l3.92,-1.89l2.09,-9.61l1.88,-1.37l0.97,1.09l1.51,4.9l3.75,-0.17l2.25,2.94l9.47,-2.38l4.83,-4.42l1.22,-0.28l12.29,4.11l3.36,0.27l3.040001,2.19l6.68,-1.81Z",
			"name": "Благоевград",
			"offset": [0, 0]
		},

		"BG-Бс": {
			"path": "M464.82813,173.25737l5.98,-3.33l9.9,0.96l3.05,1.19l6.29,5.43l5.07,3.31l5.57,-0.69l2.35,1.6l4.41,-2.99l9.97,1.57l4.68,-0.27l2.27,0.79l-0.65,1.76l0.37,0.87l4.94,2.9l4.1,1.02l4.35,-1.54l3.56,0.21l0,0l1.76,8.65l-1.13,2.86l1.21,4.69l-0.33,1.99l-16.67,-1.01l-1.2,1.74l-0.4,2.67l1.31,1.72l1.67,0.38l-2.1,0.16l-0.85,1.67l-1.83,-0.77l-1.49,1.92l-2.85,-0.3l-1.37,2.07l-0.06,5.94l1.64,3.11l-0.69,0.2l-2.61,-1.57l-1.63,0.89l-1.63,-0.75l-2.38,1.76l-2.08,-1.1l-1.91,0.48l-2.72,3.68l-0.71,5.73l-0.89,-0.74l-0.33,0.37l-0.6,-0.28l-0.61,0.73l-0.17,-0.57l-0.79,0.98l-0.08,2.35l1.67,1.68l0.03,0.99l-0.69,0.59l0.96,1.6l0.93,-0.99l-0.85,-1.15l0.99,-2.63l3.57,4.31l1.48,-1.18l0.87,-2.51l2.17,1.34l1.74,0.13l-0.24,-1l0.85,-1.28l2.35,2.44l1.6,-0.36l0.17,-1.55l0.95,1.47l1.39,-0.32l-0.35,1.51l0.59,0.44l-0.82,1.68l1.45,1.56l1.5,0.3l1.51,-1.24l0.32,-0.88l0.45,-0.21l-0.24,0.86l0.71,0.08l0.15,1.31l2.39,-0.1l-0.45,1.41l-1.6,0.32l0.1,1.72l1.41,0.82l-1.29,0.87l0.15,1.15l2.51,4.46l1.69,0.24l0.32,-0.91l2.67,-0.25l-0.38,1.62l-0.89,0.4l2.1,1.79l-2.37,0.91l0.29,0.7l-1.7,1.04l-0.02,1.34l1.04,1.54l-1.24,0.36l0.01,1.9l2.21,0.78l0.87,0.95l-0.6,0.08l-0.02,1.17l3.84,2.45l1.15,1.8l0.98,0.08l0.39,1.67l1.53,0.94l-0.57,1l0.89,0.11l0.5,0.95l0.67,-0.34l0.26,1.53l1.86,0.86l1.53,2.09l0.31,2.06l1.28,1.1l1.88,-0.18l1.68,2.76l0.49,2.71l0.04,-0.87l2.18,0.96l-0.49,1l2.58,3.32l-0.35,0.68l2.18,3.22l0.32,1.89l-2.54,0.73l-3.04,-1.47l-1.67,1.69l-0.39,-0.68l-1.42,0.6l-0.71,-0.96l-0.4,1.01l-0.7,-0.69l-1.06,1.31l-1.1,-1.18l-0.09,-1.42l-2.1,-0.34l-1.78,-1.43l0.21,1.33l-0.6,0.56l-0.45,-1.47l-0.63,1.61l-1.35,-1l-1.17,1.54l-0.01,1.27l0.69,0.35l-0.53,1.35l1.22,0.18l0.24,1.89l-2.02,-0.8l-0.01,1.55l-1.15,-1.4l-0.92,0.67l-0.29,-0.84l-1.19,0.17l0.69,-1.47l-0.86,-0.21l-0.45,0.85l-0.54,-1.1l-2.28,-0.05l0.55,-0.54l-1.08,-0.98l-0.45,0.8l-3.36,-0.58l0.47,0.91l-1.75,-0.06l-1.3,2.07l-0.26,-0.8l-1,0.73l-0.34,-0.77l-1.31,0.85l-0.38,-0.58l-0.4,0.54l-1.15,-0.47l0.73,1.1l-1.43,1.31l-0.67,0.18l-0.25,-1.1l-1.58,2.12l-0.11,-0.71l-1.32,-0.07l-0.73,1.77l0.91,0.51l-1.32,0.59l0.95,1.19l-1.13,0.24l-2.03,-1.58l-3.03,-5.6l-0.77,0.85l-3.19,-0.81l-0.35,-1.22l-1.78,0.03l-1.62,-3.04l-1.49,0.05l-0.65,-1.36l-1.7,-0.51l-2.57,-6.67l-3.11,-0.41l-0.98,-2.76l-0.85,0.21l-0.58,-1.02l-1.15,-0.09l-0.66,-1.33l-1.66,0.05l-0.54,-0.87l-2.01,0.53l-0.93,-0.74l-1.77,0.87l-0.6,1.8l-1.68,0.71l0.3,2.56l-1.49,-0.42l-0.47,-0.95l-1.24,0.66l-1.48,-0.91l-2.12,0.64l-2.25,-2.51l-4.01,-0.91l-2.98,1.34l0,0l-2.22,-2.98l-5.12,-3l-2.7,-3.63l-0.34,-2.12l2.79,-3.29l-0.16,-1.61l-2.32,-4.6l0.03,-1.65l1.56,-3.4l-2.5,-1.87l-1.81,-3.93l-3.54,-3.03l-0.97,-4.24l1.28,-1.52l7.2,-1.23l1.84,-2.28l0.07,-2.48l-0.84,-0.85l-4.23,1.18l-1.98,-0.88l-1.34,-3.89l-2.54,-3.05l-1.6,-4.4l-3.34,-4.21l-3.86,-8.94l-3.69,-3.39l-4.53,-5.96l0,0l0.37,-3.62l-2.91,-5.52l-1.37,-1.29l-3.98,-0.45l-2.73,-3.35l-0.03,-2.96l1.13,-2.97l-1.98,-7.05l0.44,-2.58l-3.11,-0.05l0,0l1.68,-0.83l4.57,0.59l0.64,0.72l-1.05,1.86l0.92,1.36l7.6,-0.07l6.32,-4.47l4.95,0.25l3.08,-0.61l3.91,1.64l5.55,-1.09l1.23,0.32l1.8,2.89l2.01,0.57l7.24,-3.89l4.9,-0.67Z",
			"name": "Бургас",
			"offset": [0, 0]
		},

		"BG-Вн": {
			"path": "M496.33813,85.427375l2.83,1.82l2.85,3.73l0.83,5.69l0.82,0.88l2.4,-0.06l5.8,-4.72l2.08,-0.27l1.84,1.65l0.03,5.13l5.17,2.599995l5.3,-0.25l2.04,4.05l2.21,1.78l8,10l1.27,-0.47l4.47,-5.21l4.12,0.21l1.48,0.6l3.16,3.43l2.68,5.07l2.25,1.88l0,0l-1.8,6.16l-3.09,5.74l-6.11,1.22l-1.78,1.16l-0.25,2l-0.22,-1.05l-1.42,0.12l1.14,0.42l-0.82,0.84l0.64,1.58l2.9,0.2l0.19,0.56l-3.31,14.15l-2.33,3.14l0.01,5.02l1.59,9.49l-0.94,1.8l0.6,8.09l-1.28,0.4l-0.63,2.02l0,0l-3.56,-0.21l-4.35,1.54l-4.1,-1.02l-4.94,-2.9l-0.38,-0.87l0.65,-1.75l-2.27,-0.79l-4.68,0.27l-9.97,-1.57l-4.42,2.99l-2.34,-1.59l-5.57,0.69l-5.07,-3.32l-6.3,-5.43l-3.05,-1.18l-9.9,-0.96l-5.98,3.33l0,0l0.28,-3.91l-1.69,-0.94l-0.6,-2.68l-2.92,-1.11l0.18,-0.85l1.22,-0.55l1.46,-1.99l3.47,0l2.61,-1.4l7.46,-1.49l-1.56,-5.17l0,0l0,-3.58l0,0l-2.47,-2.7l1,-3.81l8.98,-5.3l-1.85,-4.07l-0.2,-3.9l-1.1,-2.44l-0.39,-3.59l0.45,-1.19l2.75,0.88l1.92,-1.72l-0.36,-4.79l-0.91,-2.71l0.26,-3.33l5.09,-7.72l-0.46,-1.77l-1.88,-0.41l1.92,-3.559995l0,-1.47l-2.65,-1.18l0.01,-3.54l0.71,-0.79l2.74,-0.23l6.08,-2.02l1.24,-0.86Z",
			"name": "Варна",
			"offset": [0, 0]
		},

		"BG-ВТ": {
			"path": "M296.43813,81.507375l6.05,-1.33l0,0l2.33,1.92l1.45,-0.05l1.08,-1.14l0.35,2.39l-1.72,2.29l-0.2,1.54l3.64,9.2l1.9,1.24l0.63,1.96l1.73,0.549995l0.9,1.14l0.09,2.38l-1.55,3.87l9.84,5.38l3,-2.41l1.48,-0.15l3.98,3.65l3.36,1.58l4.55,-0.24l5.74,2.26l4.59,-1.86l1.88,4.46l4.98,1.12l0,0l6.64,6.36l-0.95,2.9l2.32,1.9l0.25,1.38l2.32,2.37l0.42,1.34l-0.05,1.72l-3.11,2.17l-0.64,3.54l-1.28,2.61l-0.37,6.7l0.81,3.43l0.65,1.45l3.63,3.08l-0.45,1.46l-2.74,1.43l-0.53,1.93l11.15,3.91l0,0l-2.64,4.02l-11.45,6.08l-0.5,1.03l1.13,2.06l-0.32,2.51l-6.82,5.42l-1.47,0.08l-4.14,-1.55l-5.83,1.44l-5.25,-0.97l0,0l-2.72,0.28l-3.91,-0.71l-6.3,2.33l-3.09,2.03l0,0l-2.93,-2.32l-0.58,-3.38l-1.64,-2.82l1.25,-1.77l2.63,-1.79l0.34,-2.05l-2.03,-1l-0.07,-3.63l-4.23,-0.54l-2,-2.14l0.09,-4.73l4.02,-3.85l0.16,-1.4l-0.8,-1.43l-3.97,-1.05l-2.63,-2.22l-2.15,0.43l-4.11,-1.78l-3.29,0.71l-2.45,-2.11l-7.02,0.35l-0.76,-2.03l1.35,-4.23l-1.03,-1.27l-2.71,0.03l-5.01,2.29l-6.23,-1.61l-3.01,-3.93l-3.11,-2.11l-0.52,-3.9l0,0l2.14,0.3l1.28,-0.9l0.11,-3.84l2.82,-4.19l0.24,-3.46l0,0l7.19,-7.32l1.05,-3.52l-0.79,-2.11l-3.89,-0.76l0.23,-2.22l1.36,-2.89l-0.52,-1.52l-6.92,0.75l-0.95,-0.47l-0.34,-1.61l1.1,-1.82l5.47,-1.83l1.09,-1.18l1.33,-8.349995l-2.43,-4.03l1.38,-2.7l0.31,-3.68l-1.18,-4.03l1.15,-1.94l4.59,-2.86l0,0l8.07,6.88Z",
			"name": "Велико Търново",
			"offset": [0, 5]
		},

		"BG-Вд": {
			"path": "M31.778129,1.0173749l1.54,1.17l4.97,0.76l6.06,5.74l5.86,2.9900001l5.2,4.02l10.29,1.84l1.47,1.3l0.42,3.84l-3.38,5.7l-7.76,1.3l-2.5,1.02l-2.35,2.19l-3.96,13.06l1.51,4.67l2.07,1.92l6.69,1.78l2.26,1.38l8.34,2.04l0,0l-0.82,1.73l-0.99,0.47l-8.02,1.04l-0.2,2.08l0.57,0.76l8.47,3.25l0.81,1.07l0.31,2.39l-0.95,1.17l-4.54,0.82l-7.29,3.75l-1.83,2.53l-2.25,8.13l-3.54,3.55l-3.02,7.09l-3.51,1.71l-0.82,1.119995l-0.46,6.18l-2.07,4.06l-1.56,1.21l0,0l-4.96,-0.28l-0.91,-0.93l-1,-3.45l-5.93,-1.2l-2.2,-3.58l-2.42,-0.04l-1.65,-1.03l-4.58,-12.489995l0.47,-5.05l-1.38,-2.84l1.14,-2.34l-1.25,-2.3l-2.6799996,-0.9l-2.61,-2.12l-1.63,-2.46l-0.48,-3.17l-0.82,-1.22l0.63,-3.93l-2.16,-2.13l-2.11000001,-4.99l2.80000001,-7.87l0.78,-5.29l-0.56,-2.38l1.9,-1.78l0.03,-5.85l0.71,-1.31l-0.53,-1.6l2.95,-0.84l0.44,-0.91l8.3099996,-0.46l1.43,-1.86l-0.99,-2.36l2.77,-0.82l1.7,0.45l0.51,-1.17l3.59,-0.12l0.28,-1.28l-0.82,-0.73l0.47,-2.55l-0.95,-1.39l0.91,-5.6100001l0.83,0.29l0.01,-1.57l-1.45,-1.04l0.65,-1.2l0.59,0.39l0.89,-0.54l-0.77,-1.17l1.22,-0.23l-0.37,-0.6l0.96,-1.21l-0.14,-1.31l0.9,0.53l1.09,-1.32l0.49,1.08l0.38,-1.28Z",
			"name": "Видин",
			"offset": [0, 0]
		},

		"BG-Вр": {
			"path": "M153.71813,64.427375l4.72,0.28l8.32,3.31l3.05,2.41l8.29,2.55l12.77,-2.12l3.95,0.04l0,0l-2.11,9.53l-1.66,-1.06l-0.37,2.02l-1.81,-2.56l-1.74,0.11l-5.7,7.25l-3.23,-1.3l-1.37,0.8l1.62,5.45l0.15,7.48l6.95,2.939995l-1.23,2.2l-0.39,4.64l-1.43,0.31l-1.67,-0.62l-7.24,1.61l-0.87,0.75l0.23,1.28l-1.17,3.2l-10.96,0.97l-2.36,1.74l-1.82,15.25l1.31,1.9l0.76,0.11l4.04,-1.26l2,2.39l0,0l0.96,12.61l-5.43,-0.01l0.1,6.66l0,0l0.1,2.93l-1.08,1.08l-4.8,-2.44l-9.58,-0.26l-2.55,-1.89l-3.82,0.81l-5.53,3.48l-1.32,0l-3.72,-2.4l-9.78,8.62l-2.65,-1.73l-5.9,-9l-0.85,-5.12l3.77,-5.3l-0.18,-1.31l-2.4,-0.88l-6.23,-0.56l0,0l-1.06,-2.3l-0.03,-2.96l1.4,-1.72l3.7,0.05l0.6,-1.34l-0.36,-2.13l-3.32,-2.23l-6.820001,-1.42l-2.36,-1.79l-0.08,-1.43l5.310001,-5.37l3.82,-7.4l-0.59,-6.82l3.87,-6.269995l1.85,-0.89l2.84,1.13l5.48,0.6l2.69,-4.18l4.62,0l-0.66,-3.31l-4.07,-3.38l-0.72,-1.42l0.65,-2.05l3.11,-3.24l2.6,-6.19l0.32,-7.93l-1.5,-4.79l0.49,-4.46l0,0l5.09,-1.37l3.97,-0.12l2.2,0.75l1.28,1.9l4.56,1.42l3.62,2.05Z",
			"name": "Враца",
			"offset": [0, 0]
		},

		"BG-Гб": {
			"path": "M268.83813,139.70737l0.52,3.9l3.11,2.11l3.01,3.93l6.23,1.61l5.01,-2.29l2.71,-0.03l1.03,1.27l-1.35,4.23l0.76,2.03l7.02,-0.35l2.45,2.11l3.29,-0.71l4.11,1.78l2.15,-0.43l2.63,2.22l3.97,1.05l0.8,1.43l-0.16,1.4l-4.02,3.85l-0.09,4.73l2,2.14l4.23,0.54l0.07,3.63l2.03,1l-0.34,2.05l-2.63,1.79l-1.25,1.77l1.64,2.82l0.58,3.38l2.93,2.32l0,0l-0.19,1.66l-2.33,0.96l-3.23,-2.8l-2.91,2.21l-1.83,0.18l-3.55,-0.8l-2.88,-2.92l-3.14,-0.24l0.43,3.62l-1.16,1.03l-11.92,-3.3l-3.7,0.56l-6.24,-3.77l-2.84,2.19l-3.52,0.27l-4.22,2.51l-7.19,-0.91l0,0l0.52,-4.09l-2.83,-5.58l-4.52,-6.06l-3.77,-1.02l-1.17,-1.37l-1.71,-5.82l0,-3.91l1.17,-3.8l1.76,-2.52l4.47,-1.58l-0.05,-3.37l-1,-2.43l0.07,-3.92l1.03,-2.3l2.78,-1.91l-0.28,-8.95l5.69,2.06Z",
			"name": "Габрово",
			"offset": [0, 10]
		},

		"BG-Дб": {
			"path": "M547.67813,35.407375l4.28,15.68l11.54,6l12.2,5.46l10.83,0.82l9.72,2.53l13.01,-0.7l-0.54,2.02l0.48,2.54l-1.41,2.25l0.5,4.52l1,2.13l-1.01,5.1l3.99,8.02l-1.15,3.85l-4.15,8.539995l-4.11,4.68l-1.58,0.5l-2.62,3.68l-0.41,2.94l-1.83,-2.85l-3.32,-0.9l-2.69,-2.18l-5.04,-1.58l-5.82,0.39l-2.65,1.4l-4.89,0.72l-4.2,-1.08l-6.39,4.28l-3.45,8.8l0,0l-2.25,-1.88l-2.68,-5.07l-3.16,-3.43l-1.48,-0.6l-4.12,-0.21l-4.47,5.21l-1.27,0.47l-8,-10l-2.21,-1.78l-2.04,-4.05l-5.3,0.25l-5.17,-2.599995l-0.03,-5.13l-1.84,-1.65l-2.08,0.27l-5.8,4.72l-2.4,0.06l-0.82,-0.88l-0.83,-5.69l-2.85,-3.73l-2.83,-1.82l0,0l-2.59,-4.75l-1.11,0.06l-5.84,3.99l-1.5,-0.58l-4.26,-5.93l-4.52,-0.63l-2.49,-2.96l0,0l1.54,-0.23l0.37,-0.85l0.04,-1.38l-1.32,-2.67l0.21,-2.07l6.96,-7.95l5.7,-1.2l9.71,-9.15l1.19,-0.24l2.03,2.31l1.99,-0.37l3.04,-3.65l1.94,-4.91l2.46,2.64l3.05,0.38l0.01,-2.78l3.73,-5.35l2.15,-1.7l4.81,-1.66l0,0l0.64,1.59l2.42,0.73l10.65,-1.73l7.11,-5.64l2.65,3.28Z",
			"name": "Добрич",
			"offset": [0, 0]
		},

		"BG-Кж": {
			"path": "M286.83813,304.80737l-1.32,4.43l3.11,12.3l1.91,-2.17l1.42,-0.54l0.93,-2.12l1.26,-0.32l2.35,5.64l3.94,1.51l3.44,2.66l8.48,2.61l4.71,-2.02l1.21,0.27l2.21,2.78l0.9,5.92l2.07,4.14l-0.39,2.79l-0.99,1.73l1.02,2.58l2.39,-1.53l3.74,1.66l2.74,-1.83l0.8,-2.28l1.96,-0.86l5.84,0.78l1.65,5.34l-2.42,1.25l-1.77,2.02l-1.93,6.44l0.12,2.29l2.13,0.94l1.68,2.59l1.38,0.66l-0.83,3.31l0.18,3.42l8.46,8.06l1.02,1.77l0.47,4.21l0,0l-2.82,1.59l-2.36,0.4l-1.38,-1.09l0.19,-1.94l-1.75,0.08l-2.93,-2.49l-0.69,1.28l-2.65,0.54l-1.1,1.49l-1.67,-0.42l-1.53,1.17l-2.51,-0.28l-1.28,3.4l-2.28,-1.96l-2.55,-0.96l-4.39,1.28l-5.11,-1.71l-1.66,1.19l-1.32,3.99l-2.76,-1.18l-2.66,-0.19l-4.31,1.69l-0.39,1.25l-1.22,-0.17l-3.08,1.22l-1.61,-0.41l-3.11,2.39l-3.61,-0.54l-1.26,1.37l-2.03,-1.23l-3.14,-0.35l-1.08,-4.26l-1.56,-1.51l-2.17,-0.82l-0.33,-1.39l-1.04,-0.51l0,0l0.32,-2.29l-2.03,-1.06l-0.23,-3.71l-0.95,-2.04l3.75,-4.82l-0.43,-0.99l-1.92,0.27l-0.67,-0.58l1.31,-4.61l-0.7,-2.46l-0.94,-1.34l-2.79,-1.25l-5.54,2.66l-5.05,-1.88l-0.26,-3.45l-1.59,-4.69l-0.17,-1.93l1,-1.29l7.16,-2.62l2.1,-2.45l-0.27,-6.12l1.29,-4.77l-2.15,-5.88l-0.74,-3.12l0.4,-1.19l0,0l2.2,-1.07l1.8,-2.63l1.78,-0.96l1.7,-4.49l3.62,-5.09Z",
			"name": "Кърджали",
			"offset": [0, 0]
		},

		"BG-Кн": {
			"path": "M11.768129,207.05737l1.77,0.82l2.24,2.53l3.69,0.76l2.25,1.21l1.35,5.31l2.26,4.18l5.6,2.97l0.42,6.32l4.21,6.64l1.24,4.57l1.02,0.64l4.68,0.38l2.11,3.16l2.85,0l0.43,2.7l0.94,0.38l2.05,-2.08l1.31,0.32l1.64,2.15l1.21,0l1.26,-3.66l3.33,-1.14l1.03,-2.08l1.16,-0.7l1.97,0.45l1.03,1.89l3.78,1.95l3.12,-0.53l2.28,-3.75l0.8,-0.16l1.06,4.37l3.42,1.43l2.28,1.83l3.11,0.44l2.98,-2.26l0,0l2.65,1.14l3.46,-0.2l2.31,0.69l2.3,7.08l6.550001,5.31l0,1.36l-4.9,1.82l-2.480001,5.93l0.26,0.82l1.62,0.76l6.580001,-2.17l1.71,5.63l7.11,3.05l-0.21,2.4l-1.91,0.69l-1.97,3.01l0,0l-3.03,2.83l-6.68,1.81l-3.040001,-2.19l-3.36,-0.27l-12.29,-4.11l-1.22,0.28l-4.83,4.42l-9.47,2.38l-2.25,-2.94l-3.75,0.17l-1.51,-4.9l-0.97,-1.09l-1.88,1.37l-2.09,9.61l-3.92,1.89l0,0l-0.36,-0.92l-1.27,-0.48l-2.67,0.44l-2.45,-3.07l-2.26,0.99l-4.13,-1.08l-1.96,-2.75l-3.87,0.31l-4.71,-3.95l-2.66,-0.48l-1.07,-1.5l-2.14,-0.92l-1.92,-2.27l-1.63,-0.6l-1.77,-1.76l-1.03,-5.45l-3.12,-1.08l-2.0799996,-5.43l-1.53,-1.91l-0.91,0l-2.18,-3.06l-0.18,-1.35l-2.12,-2.37l-1.69000001,-0.62l0.42000001,-1.12l3.26,-0.51l0.62,-0.76l1.92,0.02l0.8,1.03l1.9,-1.32l0.9199996,-1.53l-0.29,-2.1l2.04,-2.48l-0.18,-1.82l4.03,-0.68l0.26,-2.01l1.18,-1.2l0.87,-5.27l1.45,-2.25l-1.2,-3.73l-2.41,-2.46l-2.33,-1.21l-2.7,-3.34l-3.0799996,-0.73l0.15,-2.81l2.5699996,-6.77l-1.0599996,-1.03l1.9799996,-2.87Z",
			"name": "Кюстендил",
			"offset": [0, 20]
		},

		"BG-Лч": {
			"path": "M164.74813,136.02737l1.5,-0.74l5.5,-0.58l3.19,-2.49l3.31,-0.92l6.36,1.66l6.1,-0.62l4.08,-1.94l1.8,0.12l3.37,-3.6l1.14,2.15l2.82,0.62l3.4,3.29l17.48,2.24l0.74,-1.53l-0.18,-4.48l0.55,-1.1l3.16,3.47l2.42,-4.41l4.52,-3.64l3.96,-1.69l4.58,0.24l2.62,1.84l4.66,1.66l2.84,-1.68l2.21,0l3.68,-3.59l2.49,-5.51l1.51,0.51l1.97,6.26l1.12,1.46l5.36,2.45l2.42,2.14l0,0l-0.24,3.46l-2.82,4.19l-0.11,3.84l-1.28,0.9l-2.14,-0.3l0,0l-5.82,-0.84l-5.69,-2.06l0.28,8.95l-2.78,1.91l-1.03,2.3l-0.07,3.92l1,2.43l0.05,3.37l-4.47,1.58l-1.76,2.52l-1.17,3.8l0,3.91l1.71,5.82l1.17,1.37l3.77,1.02l4.52,6.06l2.83,5.58l-0.52,4.09l0,0l-9.7,4.27l-2.19,-0.06l-4.01,-1.8l-9.18,1.52l-2.65,-0.77l-2.31,-4.37l-4.22,-3.32l-12.77,-1.51l-3.7,4.56l-9.28,0.17l0,0l-9.89,-2.85l-5.4,0.43l-6.97,-1.28l-0.21,-1.35l3.26,-2.17l0.05,-1.78l0.94,-1.54l-2.61,-1.96l-0.38,-4.74l-3.13,-2.21l0.68,-1.36l2.45,-1.8l-6.84,-3.66l-0.86,-6.28l-4.89,-2.44l-0.58,-3.54l-6.09,-0.31l0,0l-0.1,-6.66l5.43,0.01Z",
			"name": "Ловеч",
			"offset": [0, 0]
		},

		"BG-Мн": {
			"path": "M105.05813,50.287375l4.39,1.69l4.16,0.54l3.02,3.17l3.68,1.9l3.94,0.89l1.39,-0.4l0,0l-0.49,4.46l1.5,4.79l-0.32,7.93l-2.6,6.19l-3.11,3.24l-0.65,2.05l0.72,1.42l4.07,3.38l0.66,3.31l-4.62,0l-2.69,4.18l-5.48,-0.6l-2.84,-1.13l-1.85,0.89l-3.87,6.269995l0.59,6.82l-3.82,7.4l-5.310001,5.37l0.08,1.43l2.36,1.79l6.820001,1.42l3.32,2.23l0.36,2.13l-0.6,1.34l-3.7,-0.05l-1.4,1.72l0.03,2.96l1.06,2.3l0,0l-6.400001,-0.37l-2.23,1.72l-2.16,3.03l-4.14,0.1l-4.2,1.31l-11.14,-0.07l-2.3,-1.38l-3.05,-4.45l-3.94,-2.19l-2.5,-3.28l-1.87,-0.12l-2.68,1.45l0,0l-4.1,-2.93l-2.67,-4.17l-0.13,-1.28l-1.93,-1.16l-0.35,-2.9l-1.81,-4.47l-3,-1.7l-2.45,-2.76l-0.36,-1.8l-3.65,-2.05l0,0l1.56,-1.21l2.07,-4.06l0.46,-6.18l0.82,-1.119995l3.51,-1.71l3.02,-7.09l3.54,-3.55l2.25,-8.13l1.83,-2.53l7.29,-3.75l4.54,-0.82l0.95,-1.17l-0.31,-2.39l-0.81,-1.07l-8.47,-3.25l-0.57,-0.76l0.2,-2.08l8.02,-1.04l0.99,-0.47l0.82,-1.73l0,0l8.79,-1.58l7.43,-3.72l5.15,-1.54Z",
			"name": "Монтана",
			"offset": [0, 0]
		},

		"BG-Пз": {
			"path": "M139.35813,272.45737l3.37,-3.4l4.39,-2.58l5.14,-6.81l2.18,2.74l3.19,-1.71l0.28,-1.21l-1.75,-3.46l2,-6.19l1.27,-0.89l3.99,-0.45l1.89,-1.66l3.69,-7.74l-0.18,-2.32l-1.28,-0.89l-5.04,2.18l-2.08,0.06l-1.47,-1.1l-3.75,-5.94l-1.37,-7.51l0.57,-1.6l5.79,-1.28l4.21,2.76l2.18,0.19l6.04,-6.54l2.8,0.55l1.95,-0.46l1.1,-4.92l4.27,-0.38l4.57,-1.98l2.87,1.62l3.26,0.8l1.93,7.44l1.23,2.25l2.88,-1.7l2.55,2.38l0,0l0.16,2.66l-0.76,2l-3.23,3.4l-0.55,2.66l3.79,9.33l0.4,3.8l4.54,4.93l0.19,4.01l-1.87,1.53l1.57,4.68l0.15,6.19l0.37,1.73l4.4,5.71l0.48,1.77l-0.74,1.24l-2.64,-0.2l-2.43,1.23l-0.21,5.08l-1.32,3.62l0.96,5.16l-0.33,4.71l-2.54,7.92l0,0l-0.29,4.3l-1.03,2.62l-1.17,1.55l-4.72,2.03l-2.39,3.21l-0.69,4.2l0.91,4.31l-1.59,0.38l-1.35,1.9l-2.91,1.6l-5.87,-1.47l-8.86,1.21l-1.21,8l0,0l-5.82,-4.57l-7.51,-7.61l-10.33,-6.66l-6.02,-2.12l-2.35,-2.64l-2.47,-17.2l0.35,-1.29l3.21,-3.3l3.88,-1.71l0.06,-0.62l-2.36,-1.84l0.35,-2.7l-1.69,-5.06l0.29,-3.62l-2.21,-1.33l-0.27,-2.57Z",
			"name": "Пазарджик",
			"offset": [0, 0]
		},

		"BG-Пк": {
			"path": "M26.288129,178.56737l1.71,2.04l1.68,-0.62l1.67,0.85l0.6,1.22l1.61,-2.24l0.85,0.6l0.79,-0.97l2.64,0.21l1.28,-1.26l0,0l1.13,1.11l0.65,3.36l4.01,-0.28l1.44,1.4l1.74,3.81l4.77,0.75l2.89,2.64l4.26,0.77l1.98,3.14l5.34,2.3l1.35,2.13l0,0l1.12,2.25l3.22,1.76l1.98,3.4l2.31,0.82l1.68,1.62l1.17,6.44l-0.95,2.2l4.52,0.78l3.79,5.68l2.59,-0.54l0.25,1.64l0,0l-1.93,2.6l-1.92,6.58l0.24,8.17l0.9,5.17l0,0l-2.98,2.26l-3.11,-0.44l-2.28,-1.83l-3.42,-1.43l-1.06,-4.37l-0.8,0.16l-2.28,3.75l-3.12,0.53l-3.78,-1.95l-1.03,-1.89l-1.97,-0.45l-1.16,0.7l-1.03,2.08l-3.33,1.14l-1.26,3.66l-1.21,0l-1.64,-2.15l-1.31,-0.32l-2.05,2.08l-0.94,-0.38l-0.43,-2.7l-2.85,0l-2.11,-3.16l-4.68,-0.38l-1.02,-0.64l-1.24,-4.57l-4.21,-6.64l-0.42,-6.32l-5.6,-2.97l-2.26,-4.18l-1.35,-5.31l-2.25,-1.21l-3.69,-0.76l-2.24,-2.53l-1.77,-0.82l0,0l-1.4,-1.33l1.08,-0.56l1.75,-3.76l0.88,-0.15l0.29,-2.39l-3.85,-4.9l-0.4,-1.9l-1.4299996,-1.88l-0.14,-2.36l3.3399996,-1.08l3.06,-2.46l0.92,-1.05l0.36,-2.13l1.37,-0.85l3.92,2.17l-0.03,-1.73l1,-1.94Z",
			"name": "Перник",
			"offset": [0, 0]
		},

		"BG-Пл": {
			"path": "M232.91813,72.747375l2.23,-0.42l4.88,-3.07l7.8,0.54l3.84,-1.62l1.02,-1.09l2.47,-0.42l3.78,0.33l5.62,4.68l4.29,1.04l1.89,-0.18l2.13,-1.27l4.1,-0.47l7.69,2.73l0,0l-4.59,2.86l-1.15,1.94l1.18,4.03l-0.31,3.68l-1.38,2.7l2.43,4.03l-1.33,8.349995l-1.09,1.18l-5.47,1.83l-1.1,1.82l0.34,1.61l0.95,0.47l6.92,-0.75l0.52,1.52l-1.36,2.89l-0.23,2.22l3.89,0.76l0.79,2.11l-1.05,3.52l-7.19,7.32l0,0l-2.42,-2.14l-5.36,-2.45l-1.12,-1.46l-1.97,-6.26l-1.51,-0.51l-2.49,5.51l-3.68,3.59l-2.21,0l-2.84,1.68l-4.66,-1.66l-2.62,-1.84l-4.58,-0.24l-3.96,1.69l-4.52,3.64l-2.42,4.41l-3.16,-3.47l-0.55,1.1l0.18,4.48l-0.74,1.53l-17.48,-2.24l-3.4,-3.29l-2.82,-0.62l-1.14,-2.15l-3.37,3.6l-1.8,-0.12l-4.08,1.94l-6.1,0.62l-6.36,-1.66l-3.31,0.92l-3.19,2.49l-5.5,0.58l-1.5,0.74l0,0l-2,-2.39l-4.04,1.26l-0.76,-0.11l-1.31,-1.9l1.82,-15.25l2.36,-1.74l10.96,-0.97l1.17,-3.2l-0.23,-1.28l0.87,-0.75l7.24,-1.61l1.67,0.62l1.43,-0.31l0.39,-4.64l1.23,-2.2l-6.95,-2.939995l-0.15,-7.48l-1.62,-5.45l1.37,-0.8l3.23,1.3l5.7,-7.25l1.74,-0.11l1.81,2.56l0.37,-2.02l1.66,1.06l2.11,-9.53l0,0l3.24,-1.93l2.71,-3.18l10.3,-3.63l11.57,2.78l5.98,5.79Z",
			"name": "Плевен",
			"offset": [0, 0]
		},

		"BG-Пд": {
			"path": "M200.84813,194.12737l9.28,-0.17l3.7,-4.56l12.77,1.51l4.22,3.32l2.31,4.37l2.65,0.77l9.18,-1.52l4.01,1.8l2.19,0.06l9.7,-4.27l0,0l0,0l0,0l-1.02,2.35l0.45,11.76l-3.18,7.08l1.77,7.5l2.99,5.26l3.44,1.38l2.09,0l8.35,-3.57l1.42,0.67l0.9,2.86l-0.4,2.55l-4.15,4.19l0.16,1.32l2.76,3.12l-0.05,1.89l-0.82,0.36l-3.29,-1.35l-0.71,1.6l-0.01,12.2l1.08,-0.03l2.87,1.94l0.65,1.53l-7.6,2.73l-2.31,1.55l-1.06,4.98l0.44,3.58l2.27,2.16l4.81,1.79l5.07,-1.61l4.35,0.06l3.82,-2.47l2.82,4.27l4.19,3.76l0,0l-3.98,10.34l0.65,4.05l-0.23,6.41l-2.56,3.16l0,0l-9.28,5.5l-3.62,5.09l-1.7,4.49l-1.78,0.96l-1.8,2.63l-2.2,1.07l0,0l-3.36,-3.02l-1.38,-2.67l-1.18,-0.14l-1.86,1.67l-0.3,6.59l-3.77,4.37l-3.14,0.76l-3.74,-0.97l-1.82,2.9l-2.43,0.97l-1.91,3.09l-3.05,-6.58l0.06,-2.15l1.26,-2.81l-0.78,-0.34l-0.58,-2l-1.58,1.34l-1.33,-2.45l1.49,-1.9l0.92,-5.11l-0.16,-1.78l-1.92,-2.35l-1.06,-0.63l-3.74,0.48l-5.6,-1.41l-7.44,2.91l-3.96,0.29l-1.34,-0.85l-3.38,-5.29l-2.69,0.29l-4.27,-1.89l0,0l2.54,-7.92l0.33,-4.71l-0.96,-5.16l1.32,-3.62l0.21,-5.08l2.43,-1.23l2.64,0.2l0.74,-1.24l-0.48,-1.77l-4.4,-5.71l-0.37,-1.73l-0.15,-6.19l-1.57,-4.68l1.87,-1.53l-0.19,-4.01l-4.54,-4.93l-0.4,-3.8l-3.79,-9.33l0.55,-2.66l3.23,-3.4l0.76,-2l-0.16,-2.66l0,0l5.76,-1.01l2.37,-6.1l-5.07,-5.04l-6.11,-2.49l-1.7,-1.82l-0.36,-3.12Z",
			"name": "Пловдив",
			"offset": [-10, 0]
		},

		"BG-Рз": {
			"path": "M392.70813,38.267375l6.44,-0.24l2.77,0.8l2.35,3.78l6.73,-0.8l2.5,3.31l0.79,4.33l7.25,2.34l3.46,0.21l2.04,1.24l2.65,-0.6l1.27,2.22l0.76,0.2l3.55,-3.66l3.77,4.61l4.41,1.37l2.84,5.33l3.51,0.38l1.37,4.08l4.17,3.88l0,0l0.98,1.54l-0.05,3.07l-1.47,2.21l-4.29,2.12l-1.25,2.92l-1.97,1.15l-2.61,0.04l-3.1,-1.66l-0.94,4.23l-5.72,4.86l-0.44,2.11l1.18,0.34l-0.43,3.6l-3.64,2.639995l0.07,1.77l-2.47,0.94l-0.48,0.95l0.85,1.93l-0.53,1.58l3.9,2.24l0.96,1.96l-1.28,2.34l-2.97,2.02l0,0l-2.62,0.47l-1.16,-1.04l-1.5,0.99l-1.99,-1.65l-1.37,3.71l-0.88,0.7l-1.61,-0.84l-4.04,0.3l-5.4,-2.36l-4.82,2.18l-2.97,-0.53l0.33,2.08l-1.23,0.66l-2.76,4.69l-0.18,2.61l-4.14,1.99l-1.17,-1.92l1.36,-2.63l-1.29,-2.02l-3.16,-1.12l-0.71,-2.4l6.97,-4.83l2.85,-3.04l-0.27,-3.38l1.02,-1.89l-0.17,-1.06l-5.3,-1.27l-1.16,-1.63l-1.32,-4.719995l-4.04,-0.88l-2.8,-3.68l-2.46,-1.24l-1.37,-1.6l-1.48,-0.16l-1.8,0.81l-2.27,3.16l-0.99,-0.43l-6.25,0.52l-1.77,-1.2l0,0l-1.72,-4.45l-1.82,-2.48l0.94,-1.29l-0.54,-2.03l4.26,-1.58l2.36,-0.15l4.32,-5.27l3.71,0.83l7,5.33l8.58,-2.85l5.51,1.25l5.9,-0.73l3.25,-4.98l-0.01,-6.82l-1.56,-3.95l-2.03,-1.8l-3.98,-0.73l-3.66,-3.24l-1.12,-0.17l-2.08,1.71l-0.79,-1.27l-4.44,0.73l-2.49,-0.36l-2.48,-1.35l0.07,-2.99l0.78,-1.26l2.88,-1.62l2.89,-8.82l2.8,-3.06Z",
			"name": "Разград",
			"offset": [15, 0]
		},

		"BG-Рс": {
			"path": "M389.43813,25.597375l1.13,4.46l4.14,4.03l-2,4.18l0,0l-0.46,1.63l-2.8,3.06l-2.89,8.82l-2.88,1.62l-0.78,1.26l-0.07,2.99l2.48,1.35l2.49,0.36l4.44,-0.73l0.79,1.27l2.08,-1.71l1.12,0.17l3.66,3.24l3.98,0.73l2.03,1.8l1.56,3.95l0.01,6.82l-3.25,4.98l-5.9,0.73l-5.51,-1.25l-8.58,2.85l-7,-5.33l-3.71,-0.83l-4.32,5.27l-2.36,0.15l-4.26,1.58l0.54,2.03l-0.94,1.29l1.82,2.48l1.72,4.45l0,0l-6.32,3.03l-1.69,8.559995l-1.97,2.38l-1.46,3.22l-2.27,1.69l4.95,4.22l-0.44,4.86l0,0l-4.98,-1.12l-1.88,-4.46l-4.59,1.86l-5.74,-2.26l-4.55,0.24l-3.36,-1.58l-3.98,-3.65l-1.48,0.15l-3,2.41l-9.84,-5.38l1.55,-3.87l-0.09,-2.38l-0.9,-1.14l-1.73,-0.549995l-0.63,-1.96l-1.9,-1.24l-3.64,-9.2l0.2,-1.54l1.72,-2.29l-0.35,-2.39l-1.08,1.14l-1.45,0.05l-2.33,-1.92l0,0l3.82,-1.91l7.3,-0.13l9.92,-6.02l6.95,-0.23l5.11,-2.73l2.79,-4.92l3.8,-1.7l2.75,-2.69l7.33,-11.21l10.16,-6.24l2.42,-5.2l2.58,-2.9l4.02,-2.48l5.15,-0.01l10.26,-5.52Z",
			"name": "Русе",
			"offset": [0, 0]
		},

		"BG-Сс": {
			"path": "M464.02813,11.527375l3.34,-0.26l7.36,3.1l3.08,0.18l3.53,-1.26l1.35,2.45l-0.7,1.5l1.37,3.12l6.43,2.34l4.25,6.1l7.06,-1.37l13.64,1.32l3.13,-4.83l2.88,2.4l2.89,7.48l0,0l-4.81,1.66l-2.15,1.7l-3.73,5.35l-0.01,2.78l-3.05,-0.38l-2.46,-2.64l-1.94,4.91l-3.04,3.65l-1.99,0.37l-2.03,-2.31l-1.19,0.24l-9.71,9.15l-5.7,1.2l-6.96,7.95l-0.21,2.07l1.32,2.67l-0.04,1.38l-0.37,0.85l-1.54,0.23l0,0l-2.1,-0.69l-2.19,0.86l-3.53,-3.32l-1.98,-3.48l-1.04,-0.17l-5.34,2.91l-2.51,0.31l0,0l-4.17,-3.88l-1.37,-4.08l-3.51,-0.38l-2.84,-5.33l-4.41,-1.37l-3.77,-4.61l-3.55,3.66l-0.76,-0.2l-1.27,-2.22l-2.65,0.6l-2.04,-1.24l-3.46,-0.21l-7.25,-2.34l-0.79,-4.33l-2.5,-3.31l-6.73,0.8l-2.35,-3.78l-2.77,-0.8l-6.44,0.24l0,0l2,-4.18l-4.14,-4.03l-1.13,-4.46l0,0l4.84,-1.33l5.87,1.15l9.1,-2.51l6.24,0.38l5.79,-1.5l3.32,-1.69l3.17,0.45l3.21,-0.66l9.17,-5.3l5.48,-2.23l8.17,-0.23l7.13,-2.1300001Z",
			"name": "Силистра",
			"offset": [0, 0]
		},

		"BG-Сл": {
			"path": "M374.58813,170.93737l4.98,-4.25l1.97,-5.83l2.29,0.41l2.88,-1.44l0.76,0.51l-0.41,3.6l0.71,0.75l2.53,-2.39l2.27,1.96l2.55,0.93l3.29,-0.18l6.61,-1.91l10.1,1.55l0,0l-6.42,5.68l-0.55,2.82l1.2,1.45l0,0l3.11,0.06l-0.44,2.58l1.98,7.05l-1.13,2.97l0.03,2.96l2.73,3.35l3.99,0.45l1.37,1.29l2.9,5.52l-0.37,3.63l0,0l-1.95,-1.5l-0.63,0.34l-0.04,1.16l1.92,3.3l-0.03,3.99l-2.89,3.61l-1.07,-0.51l-1.03,-1.8l-2.84,4.56l-4.84,0.49l-8.77,5.48l-5.47,-0.9l-3.97,3.27l1.9,1.3l0.34,2.18l-2.54,1.88l-1.99,3.05l-4.1,0.53l-1.46,2.01l-6.76,-1.87l-1.32,0.83l0.27,5.93l-0.95,0.38l-2.02,-1.78l-1.16,-0.16l-0.06,1.85l2.28,3.07l1.89,-0.92l2.32,-2.61l0.84,1.65l-0.63,8.07l-3.41,5.73l-2.37,7.17l0,0l-10.26,-6.15l-1.82,0.31l-1.87,2.18l-0.03,-2.01l-1.79,-0.81l-1.84,-2.12l-3.58,-1.22l-1.16,-1.33l-2.81,-9.67l-3.76,-4.58l0.19,-1.77l2.21,-4.09l-3.57,-8.27l2.54,-4.15l0.49,-2.38l-3.04,-5.11l-1.18,-7.1l-4.02,-8.02l-0.38,-6.89l0,0l5.25,0.97l5.83,-1.44l4.14,1.55l1.47,-0.08l6.82,-5.42l0.32,-2.51l-1.13,-2.06l0.5,-1.03l11.45,-6.08Z",
			"name": "Сливен",
			"offset": [0, 0]
		},

		"BG-См": {
			"path": "M202.41813,305.86737l4.27,1.89l2.69,-0.29l3.38,5.29l1.34,0.85l3.96,-0.29l7.44,-2.91l5.6,1.41l3.74,-0.48l1.06,0.63l1.92,2.35l0.16,1.78l-0.92,5.11l-1.49,1.9l1.33,2.45l1.58,-1.34l0.58,2l0.78,0.34l-1.26,2.81l-0.06,2.15l3.05,6.58l1.91,-3.09l2.43,-0.97l1.82,-2.9l3.74,0.97l3.14,-0.76l3.77,-4.37l0.3,-6.59l1.86,-1.67l1.18,0.14l1.38,2.67l3.36,3.02l0,0l-0.4,1.19l0.74,3.12l2.15,5.88l-1.29,4.77l0.27,6.12l-2.1,2.45l-7.16,2.62l-1,1.29l0.17,1.93l1.59,4.69l0.26,3.45l5.05,1.88l5.54,-2.66l2.79,1.25l0.94,1.34l0.7,2.46l-1.31,4.61l0.67,0.58l1.92,-0.27l0.43,0.99l-3.75,4.82l0.95,2.04l0.23,3.71l2.03,1.06l-0.32,2.29l0,0l-3.38,-1.18l-1.87,-2.27l-1.53,0.78l-2.17,-0.91l-2.34,-3.07l-7.39,-1.41l-3.6,-1.38l-2.8,-2.79l-1.9,0.28l-1.2,1.74l-0.79,0.12l-5.4,-1.21l0.39,1.81l-0.64,4.12l-1.35,1.06l-5.52,-4.48l-1.65,-4.46l-3.42,-0.39l-1.07,-0.79l-2.41,1.01l0.41,-1.87l-0.79,-0.47l-4.33,1.13l-1.25,-1.95l-0.1,-2.99l-2.31,-1.51l-1.28,-3.49l0.26,-1.82l-1.58,-3.06l0.7,-1.3l-1,-0.94l-0.87,0.19l0.02,-1.04l-0.72,-0.48l-5.15,2.12l-1.12,1.05l-0.12,2.03l-1.09,0.82l-1.12,-0.93l-2.38,-0.11l-0.98,-1.29l-2.02,0.4l-1.8,2.51l-2.65,-1.19l-3.5,1.94l-0.66,-1.96l0.54,-1.51l-3.1,-2.62l0.43,-1.25l-1.22,-0.71l-2.1,1.33l-1.06,1.85l-1.95,-0.28l-1.87,2.5l0.23,1.4l-0.73,0.73l-1.32,-0.21l0.16,-0.69l-1.25,-0.87l-0.22,-1.01l-2.44,0.3l-0.28,-0.88l-2.34,-0.32l-0.39,-0.92l-2.48,1.11l-0.44,1.38l-1.1,0.78l0,0l-0.13,-2.87l2.46,-6.06l-0.35,-3.28l3.17,-4.45l-1.06,-2.27l0,0l1.21,-8l8.86,-1.21l5.87,1.47l2.91,-1.6l1.35,-1.9l1.59,-0.38l-0.91,-4.31l0.69,-4.2l2.39,-3.21l4.72,-2.03l1.17,-1.55l1.03,-2.62Z",
			"name": "Смолян",
			"offset": [0, 0]
		},

		"BG-СО": {
			"path": "M57.248129,137.06737l2.68,-1.45l1.87,0.12l2.5,3.28l3.94,2.19l3.05,4.45l2.3,1.38l11.14,0.07l4.2,-1.31l4.14,-0.1l2.16,-3.03l2.23,-1.72l6.400001,0.37l0,0l6.23,0.56l2.4,0.88l0.18,1.31l-3.77,5.3l0.85,5.12l5.9,9l2.65,1.73l9.78,-8.62l3.72,2.4l1.32,0l5.53,-3.48l3.82,-0.81l2.55,1.89l9.58,0.26l4.8,2.44l1.08,-1.08l-0.1,-2.93l0,0l6.09,0.31l0.58,3.54l4.89,2.44l0.86,6.28l6.84,3.66l-2.45,1.8l-0.68,1.36l3.13,2.21l0.38,4.74l2.61,1.96l-0.94,1.54l-0.05,1.78l-3.26,2.17l0.21,1.35l6.97,1.28l5.4,-0.43l9.89,2.85l0,0l-3.93,9l0.36,3.12l1.7,1.82l6.11,2.49l5.07,5.04l-2.37,6.1l-5.76,1.01l0,0l-2.55,-2.38l-2.88,1.7l-1.23,-2.25l-1.93,-7.44l-3.26,-0.8l-2.87,-1.62l-4.57,1.98l-4.27,0.38l-1.1,4.92l-1.95,0.46l-2.8,-0.55l-6.04,6.54l-2.18,-0.19l-4.21,-2.76l-5.79,1.28l-0.57,1.6l1.37,7.51l3.75,5.94l1.47,1.1l2.08,-0.06l5.04,-2.18l1.28,0.89l0.18,2.32l-3.69,7.74l-1.89,1.66l-3.99,0.45l-1.27,0.89l-2,6.19l1.75,3.46l-0.28,1.21l-3.19,1.71l-2.18,-2.74l-5.14,6.81l-4.39,2.58l-3.37,3.4l0,0l-2.72,0l-0.53,1.33l1.33,2.4l-1,0.81l-1.53,-0.08l-3.38,-1.53l-1.92,-3.83l-2.86,0.81l-1.32,-0.9l-2.39,0.09l-1.18,1.51l-1.43,7.87l-1.29,2.22l-2.6,2.03l-3.16,-0.75l-2.65,0.98l0,0l1.97,-3.01l1.91,-0.69l0.21,-2.4l-7.11,-3.05l-1.71,-5.63l-6.580001,2.17l-1.62,-0.76l-0.26,-0.82l2.480001,-5.93l4.9,-1.82l0,-1.36l-6.550001,-5.31l-2.3,-7.08l-2.31,-0.69l-3.46,0.2l-2.65,-1.14l0,0l-0.9,-5.17l-0.24,-8.17l1.92,-6.58l1.93,-2.6l0,0l1.06,1.09l4.2,1.03l1.07,1.64l2.52,1.57l4.350001,6.26l1.18,0.38l1.69,-0.99l0.45,-3.9l1.81,-5.03l2.72,0.31l0.84,0.53l2.78,6.38l0.46,2.26l-0.42,3.45l0.68,2.84l1.86,-0.71l4.57,1.72l5.96,-2.16l-2.23,-7.4l-2.45,-3.95l0.16,-1.93l-1.38,-0.79l-3.19,-5.11l0.48,-6.12l-0.85,-4.76l-0.62,-0.77l-3.23,-0.81l-0.73,-0.93l0.64,-2.44l2.2,-0.86l1.15,-3.95l3.59,-1.26l1.25,-1.24l2.82,-10.68l-1.26,-4.93l-1.59,-0.23l-1.83,1.78l-2.25,0.67l-7.86,-5.1l-11.380001,2.89l-1.81,-0.29l-1.52,-1.58l-1.53,-3.96l-2.03,-2.11l-0.87,0.09l-5.1,12.64l-0.19,2.52l-1.68,2.52l-0.07,1.19l1.52,1.17l-0.71,2.32l-2.82,-0.91l-2.33,1.33l-8.14,-0.27l-3.62,0.54l0,0l-1.35,-2.13l-5.34,-2.3l-1.98,-3.14l-4.26,-0.77l-2.89,-2.64l-4.77,-0.75l-1.74,-3.81l-1.44,-1.4l-4.01,0.28l-0.65,-3.36l-1.13,-1.11l0,0l2.52,-4.92l-0.94,-2.14l1.28,-1.48l0.09,-3.09l6.25,-2.87l1.56,-2.51l3.2,-1.68l2.35,-6.19l3.01,-1.32l3.05,-2.65l1.42,-6.12l-1.08,-1.25l1.97,-3.39l-2.98,-1.74Z",
			"name": "Софийска област",
			"offset": [20, 0]
		},

		"BG-Сф": {
			"path": "M68.678129,199.52737l3.62,-0.54l8.14,0.27l2.33,-1.33l2.82,0.91l0.71,-2.32l-1.52,-1.17l0.07,-1.19l1.68,-2.52l0.19,-2.52l5.1,-12.64l0.87,-0.09l2.03,2.11l1.53,3.96l1.52,1.58l1.81,0.29l11.380001,-2.89l7.86,5.1l2.25,-0.67l1.83,-1.78l1.59,0.23l1.26,4.93l-2.82,10.68l-1.25,1.24l-3.59,1.26l-1.15,3.95l-2.2,0.86l-0.64,2.44l0.73,0.93l3.23,0.81l0.62,0.77l0.85,4.76l-0.48,6.12l3.19,5.11l1.38,0.79l-0.16,1.93l2.45,3.95l2.23,7.4l-5.96,2.16l-4.57,-1.72l-1.86,0.71l-0.68,-2.84l0.42,-3.45l-0.46,-2.26l-2.78,-6.38l-0.84,-0.53l-2.72,-0.31l-1.81,5.03l-0.45,3.9l-1.69,0.99l-1.18,-0.38l-4.350001,-6.26l-2.52,-1.57l-1.07,-1.64l-4.2,-1.03l-1.06,-1.09l0,0l-0.25,-1.64l-2.59,0.54l-3.79,-5.68l-4.52,-0.78l0.95,-2.2l-1.17,-6.44l-1.68,-1.62l-2.31,-0.82l-1.98,-3.4l-3.22,-1.76Z",
			"name": "София",
			"offset": [0, 0]
		},

		"BG-СЗ": {
			"path": "M321.27813,194.98737l3.09,-2.03l6.3,-2.33l3.91,0.71l2.72,-0.28l0,0l0.38,6.89l4.02,8.02l1.18,7.1l3.04,5.11l-0.49,2.38l-2.54,4.15l3.57,8.27l-2.21,4.09l-0.19,1.77l3.76,4.58l2.81,9.67l1.16,1.33l3.58,1.22l1.84,2.12l1.79,0.81l0.03,2.01l1.87,-2.18l1.82,-0.31l10.26,6.15l0,0l3.6,2.24l0,0l-8.09,7.96l-0.14,2.98l1.85,4.23l1.68,8.21l-3.73,0.95l-2.21,-0.5l-3.25,3.45l-2.09,-0.59l-4.18,-8.54l-4.26,-0.53l-2.35,-2.27l-3.4,-0.1l-2.76,-2.1l-1.35,0.9l-1.53,5.76l-4.02,2.3l-2.24,0.1l-1.34,1.2l-1.99,-0.11l-1.67,-5.55l-2.39,-2.51l-1.91,-4.47l-1.83,0.05l-3.73,3.4l-1.09,0.06l-0.14,-8.79l-1.24,-2.46l-1.19,0.6l-1.67,2.68l-4.23,2.8l0.18,0.75l1.65,-0.15l-0.93,1.81l-1.64,-0.07l-2.69,-2.05l-1.3,0.3l-0.41,3.26l-3.44,4.56l-1.08,0.06l-4.71,-2.91l-2.76,-0.3l0,0l-4.19,-3.76l-2.82,-4.27l-3.82,2.47l-4.35,-0.06l-5.07,1.61l-4.81,-1.79l-2.27,-2.16l-0.44,-3.58l1.06,-4.98l2.31,-1.55l7.6,-2.73l-0.65,-1.53l-2.87,-1.94l-1.08,0.03l0.01,-12.2l0.71,-1.6l3.29,1.35l0.82,-0.36l0.05,-1.89l-2.76,-3.12l-0.16,-1.32l4.15,-4.19l0.4,-2.55l-0.9,-2.86l-1.42,-0.67l-8.35,3.57l-2.09,0l-3.44,-1.38l-2.99,-5.26l-1.77,-7.5l3.18,-7.08l-0.45,-11.76l1.02,-2.35l0,0l7.19,0.91l4.22,-2.51l3.52,-0.27l2.84,-2.19l6.24,3.77l3.7,-0.56l11.92,3.3l1.16,-1.03l-0.43,-3.62l3.14,0.24l2.88,2.92l3.55,0.8l1.83,-0.18l2.91,-2.21l3.23,2.8l2.33,-0.96Z",
			"name": "Стара Загора",
			"offset": [0, 0]
		},

		"BG-Тщ": {
			"path": "M365.71813,93.297375l1.77,1.2l6.25,-0.52l0.99,0.43l2.27,-3.16l1.8,-0.81l1.48,0.16l1.37,1.6l2.46,1.24l2.8,3.68l4.04,0.88l1.32,4.719995l1.16,1.63l5.3,1.27l0.17,1.06l-1.02,1.89l0.27,3.38l-2.85,3.04l-6.97,4.83l0.71,2.4l3.16,1.12l1.29,2.02l-1.36,2.63l1.17,1.92l4.14,-1.99l0.18,-2.61l2.76,-4.69l1.23,-0.66l-0.33,-2.08l2.97,0.53l4.82,-2.18l5.4,2.36l4.04,-0.3l1.61,0.84l0.88,-0.7l1.37,-3.71l1.99,1.65l1.5,-0.99l1.16,1.04l2.62,-0.47l0,0l-1.23,1.59l0.66,7.86l3.26,2.98l0.49,2.52l-1.47,2.2l-4.34,3.93l-0.43,2.82l-1.73,3.25l-2.25,0.87l-1.73,-0.6l0.82,3.91l1.93,4.14l-0.03,1.62l-2.01,1.21l-0.52,2.42l-2.77,1.8l-0.63,2.87l0.67,1.71l-3.21,1.6l0,0l-10.1,-1.55l-6.61,1.91l-3.29,0.18l-2.55,-0.93l-2.27,-1.96l-2.53,2.39l-0.71,-0.75l0.41,-3.6l-0.76,-0.51l-2.88,1.44l-2.29,-0.41l-1.97,5.83l-4.98,4.25l0,0l-11.15,-3.91l0.53,-1.93l2.74,-1.43l0.45,-1.46l-3.63,-3.08l-0.65,-1.45l-0.81,-3.43l0.37,-6.7l1.28,-2.61l0.64,-3.54l3.11,-2.17l0.05,-1.72l-0.42,-1.34l-2.32,-2.37l-0.25,-1.38l-2.32,-1.9l0.95,-2.9l-6.64,-6.36l0,0l0.44,-4.86l-4.95,-4.22l2.27,-1.69l1.46,-3.22l1.97,-2.38l1.69,-8.559995Z",
			"name": "Търговище",
			"offset": [0, 15]
		},

		"BG-Хс": {
			"path": "M376.57813,266.47737l3.01,2.15l4.32,0.94l3.28,2.99l2.81,0.21l3.16,1.35l2.46,-1.41l2.51,2l3.89,-0.92l1.56,2.76l3.63,-0.4l-1.05,7.49l0.6,6.27l-2.44,2.37l-0.07,2.77l1.36,0.84l0.8,2.5l1.19,1.09l0.23,2.09l3.9,4.73l0,0l2.12,2.91l-1.55,2.38l1.28,1.75l-1.41,0.74l-0.12,1.56l-1.36,1.14l-1.11,2.94l-15,0.06l-1.99,0.74l-3.58,8.68l-0.05,1.86l2.87,3.21l-2.8,-0.48l-2.17,0.86l-2.24,-0.36l-3.13,-1.4l-2.21,-2.35l-1.13,0.96l-1.77,-0.19l-1.86,-0.75l-0.87,-1.21l-4.77,2.48l-1.09,2.26l-2.61,-0.46l-1.58,0.98l-0.8,2.67l1.13,5.38l1.71,0.67l0.57,1.99l2.22,0.43l0.45,-0.94l1.36,-0.28l0.11,2.35l1.52,1.23l-0.58,6.49l2.92,0.33l0.79,4.54l-1.28,1.63l-0.17,1.69l-1.59,0.76l-0.07,0.88l0.47,1.45l1.65,0.72l2.49,3.65l-3.05,0.45l-1.12,1.5l0.55,1.66l-0.48,2.13l-1.01,1.78l-1.17,0.37l-0.59,2.56l-3.18,-0.11l-1.03,1.29l-5.09,-0.49l-2.75,0.92l-0.89,2.27l-2.85,0.93l-3.13,-0.27l0,0l-0.47,-4.21l-1.02,-1.77l-8.46,-8.06l-0.18,-3.42l0.83,-3.31l-1.38,-0.66l-1.68,-2.59l-2.13,-0.94l-0.12,-2.29l1.93,-6.44l1.77,-2.02l2.42,-1.25l-1.65,-5.34l-5.84,-0.78l-1.96,0.86l-0.8,2.28l-2.74,1.83l-3.74,-1.66l-2.39,1.53l-1.02,-2.58l0.99,-1.73l0.39,-2.79l-2.07,-4.14l-0.9,-5.92l-2.21,-2.78l-1.21,-0.27l-4.71,2.02l-8.48,-2.61l-3.44,-2.66l-3.94,-1.51l-2.35,-5.64l-1.26,0.32l-0.93,2.12l-1.42,0.54l-1.91,2.17l-3.11,-12.3l1.32,-4.43l0,0l2.56,-3.16l0.23,-6.41l-0.65,-4.05l3.98,-10.34l0,0l2.76,0.3l4.71,2.91l1.08,-0.06l3.44,-4.56l0.41,-3.26l1.3,-0.3l2.69,2.05l1.64,0.07l0.93,-1.81l-1.65,0.15l-0.18,-0.75l4.23,-2.8l1.67,-2.68l1.19,-0.6l1.24,2.46l0.14,8.79l1.09,-0.06l3.73,-3.4l1.83,-0.05l1.91,4.47l2.39,2.51l1.67,5.55l1.99,0.11l1.34,-1.2l2.24,-0.1l4.02,-2.3l1.53,-5.76l1.35,-0.9l2.76,2.1l3.4,0.1l2.35,2.27l4.26,0.53l4.18,8.54l2.09,0.59l3.25,-3.45l2.21,0.5l3.73,-0.95l-1.68,-8.21l-1.85,-4.23l0.14,-2.98Z",
			"name": "Хасково",
			"offset": [0, 0]
		},

		"BG-Шм": {
			"path": "M455.33813,71.047375l2.51,-0.31l5.34,-2.91l1.04,0.17l1.98,3.48l3.53,3.32l2.19,-0.86l2.1,0.69l0,0l2.49,2.96l4.52,0.63l4.26,5.93l1.5,0.58l5.84,-3.99l1.11,-0.06l2.59,4.75l0,0l-0.72,1.94l-1.24,0.86l-6.08,2.02l-2.74,0.23l-0.71,0.79l-0.01,3.54l2.65,1.18l0,1.47l-1.92,3.559995l1.88,0.41l0.46,1.77l-5.09,7.72l-0.26,3.33l0.91,2.71l0.36,4.79l-1.92,1.72l-2.75,-0.88l-0.45,1.19l0.39,3.59l1.1,2.44l0.2,3.9l1.85,4.07l-8.98,5.3l-1,3.81l2.47,2.7l0,0l0,3.58l0,0l1.56,5.17l-7.46,1.49l-2.61,1.4l-3.47,0l-1.46,1.99l-1.22,0.55l-0.18,0.85l2.92,1.11l0.6,2.68l1.69,0.94l-0.28,3.91l0,0l-5.02,0.58l-7.24,3.89l-2.01,-0.57l-1.8,-2.89l-1.23,-0.32l-5.55,1.09l-3.9,-1.64l-3.09,0.62l-4.95,-0.26l-6.32,4.48l-7.61,0.06l-0.92,-1.35l1.05,-1.87l-0.64,-0.72l-4.57,-0.58l-1.68,0.82l0,0l-1.2,-1.45l0.55,-2.82l6.42,-5.68l0,0l3.21,-1.6l-0.67,-1.71l0.63,-2.87l2.77,-1.8l0.52,-2.42l2.01,-1.21l0.03,-1.62l-1.93,-4.14l-0.82,-3.91l1.73,0.6l2.25,-0.87l1.73,-3.25l0.43,-2.82l4.34,-3.93l1.47,-2.2l-0.49,-2.52l-3.26,-2.98l-0.66,-7.86l1.23,-1.59l0,0l2.97,-2.02l1.28,-2.34l-0.96,-1.96l-3.9,-2.24l0.53,-1.58l-0.85,-1.93l0.48,-0.95l2.47,-0.94l-0.07,-1.77l3.64,-2.639995l0.43,-3.6l-1.18,-0.34l0.44,-2.11l5.72,-4.86l0.94,-4.23l3.1,1.66l2.61,-0.04l1.97,-1.15l1.25,-2.92l4.29,-2.12l1.47,-2.21l0.05,-3.07Z",
			"name": "Шумен",
			"offset": [0, 0]
		},

		"BG-Яб": {
			"path": "M423.51813,204.45737l4.53,5.95l3.69,3.4l3.87,8.94l3.34,4.21l1.59,4.4l2.55,3.06l1.34,3.88l1.98,0.89l4.22,-1.18l0.84,0.85l-0.06,2.48l-1.84,2.29l-7.21,1.23l-1.28,1.51l0.97,4.24l3.54,3.03l1.81,3.93l2.5,1.88l-1.56,3.4l-0.03,1.64l2.32,4.6l0.16,1.6l-2.79,3.29l0.34,2.12l2.7,3.63l5.12,3l2.22,2.98l0,0l-1.43,0.29l0.48,2.63l-1.94,2.76l-2.59,0.22l0.28,2.28l-2.18,3.06l-3.28,-0.52l-2.24,1.82l-3.48,-0.36l-1.99,1.15l-0.67,1.64l-3.03,-0.76l-2.27,-1.92l-3.04,2.85l-0.49,1.29l-3.92,-1.31l-4.62,0.32l-4.07,-1.84l-0.6,1.9l-5.57,5.09l0,0l-3.9,-4.73l-0.23,-2.09l-1.19,-1.09l-0.8,-2.5l-1.36,-0.84l0.07,-2.77l2.44,-2.37l-0.6,-6.27l1.05,-7.49l-3.63,0.4l-1.56,-2.76l-3.89,0.92l-2.51,-2l-2.46,1.41l-3.16,-1.35l-2.81,-0.21l-3.28,-2.99l-4.32,-0.94l-3.01,-2.15l0,0l-3.6,-2.24l0,0l2.37,-7.17l3.41,-5.73l0.63,-8.07l-0.84,-1.65l-2.32,2.61l-1.89,0.92l-2.28,-3.07l0.06,-1.85l1.16,0.16l2.02,1.78l0.95,-0.38l-0.27,-5.93l1.32,-0.83l6.76,1.87l1.46,-2.01l4.1,-0.53l1.99,-3.05l2.54,-1.88l-0.34,-2.18l-1.9,-1.3l3.97,-3.27l5.47,0.9l8.77,-5.48l4.84,-0.49l2.84,-4.56l1.03,1.8l1.07,0.51l2.89,-3.61l0.03,-3.99l-1.92,-3.3l0.04,-1.16l0.63,-0.34Z",
			"name": "Ямбол",
			"offset": [0, 0]
		}

	},
	"height": 400,
	"width": 615
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(106);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
	getUser: function getUser(app, force) {
		var _this = this;

		if (app.user && !force) {
			return _promise2.default.resolve(app.user);
		} else {
			return app.$http.get('backend://auth/me').then(function (result) {
				if (result.body.error) throw new Error(result.body.error);
				if (result.body.familyUser) {
					return app.$http.get('backend://family/' + result.body.familyUser.family).then(function (family) {
						app.user = result.body;
						app.user.familyUser.family = family.body;
						app.user.refresh = _this.getUser.bind(_this, app, true);
						return app.user;
					});
				} else {
					app.user = result.body;
					app.user.refresh = _this.getUser.bind(_this, app, true);
					return app.user;
				}
			}).catch(function (error) {
				app.$http.toastCatcher(error);
				return app.user;
			});
		}
	},

	loggedIn: function loggedIn(app) {
		return this.getUser(app).then(function (user) {
			return !!user;
		});
	},

	logout: function logout(app) {
		return app.$http.get('backend://auth/logout').then(function (result) {
			app.user = undefined;
			return true;
		}).catch(function (error) {
			app.$http.toastCatcher(error);
			app.user = undefined;
			return true;
		});
	}
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	lang: 'bg',
	backend: 'http://www.homeschoolingbg.com/api'
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	rpp: 20,
	basicLists: {
		dashCounters: {
			families: { title: 'Семейства', icon: 'fa-users', link: '/family/list' },
			children: { title: 'Домашни ученици', icon: 'fa-send-o', link: '/family/list' },
			discussions: { title: 'Дискусии', icon: 'fa-comments', link: '/discussion/list' }
		},

		resourceTypes: {
			books: { title: 'Книги', icon: 'fa-book', link: '/book/list' },
			materials: { title: 'Учебни материали', icon: 'fa-leanpub', link: '/material/list' },
			links: { title: 'Връзки', icon: 'fa-link', link: '/link/list' }
		},

		eventTypes: {
			'new-family': { text: 'се присъедини към Семейна образователна мрежа', icon: 'fa-users', link: '', color: 'danger' },
			'new-book': { text: 'добави нова книга', icon: 'fa-book', link: '/book/', color: 'success' },
			'new-material': { text: 'добави нов учебен материал', icon: 'fa-leanpub', link: '/material/', color: 'primary' },
			'new-link': { text: 'добави нова връзка', icon: 'fa-link', link: '/link/', color: 'warning' }
		},

		menuItems: {
			dashboard: { title: 'Начало', icon: 'fa-home', link: '/', comment: 'Начален екран с обобщена информация за семействата и ресурсите' },
			family: { title: 'Нашето семейство', icon: 'fa-user', link: '/family/me', comment: 'На този екран може да представите накратко Вашето семейство, за да могат останалите семейства да се свържат с вас.' },
			families: { title: 'Семейства', icon: 'fa-users', link: '/family/list', comment: 'Списък със семействата в Семейната образователна мрежа' },
			books: { title: 'Книги', icon: 'fa-book', link: '/book/list', comment: 'Информация за книги и учебници (печатни материали), предоставяни от различни семейства. Материалите могат да бъдат заемани от други семейства за определен срок.' },
			materials: { title: 'Учебни материали', icon: 'fa-tasks', link: '/material/list', comment: 'Онлайн учебни материали (Google документи/файлове), споделяни или създавани от семействата в мрежата. Достъпът до тези материали е ограничен и всяко семейство решава на кого да разреши достъп до тях.' },
			links: { title: 'Връзки', icon: 'fa-link', link: '/link/list', comment: 'В тази секция публикуваме връзки към полезни сайтове, които сме използвали. Моля, не публикувайте връзки към сайтове, които са ви харесали, но не използвате реално.' },
			discussions: { title: 'Дискусии', icon: 'fa-comments', link: '/discussion/list', comment: 'Дискусии по различни теми.' },
			events: { title: 'История', icon: 'fa-clock-o', link: '/events', comment: 'Списък на последните събития в мрежата.' }
		}
	},

	lists: {
		languages: {
			'BG': { text: 'Български' },
			'EN': { text: 'English' },
			'RU': { text: 'Русский' },
			'ES': { text: 'Espaniol' },
			'FR': { text: 'Français' },
			'GE': { text: 'Deutsche' }
		},
		bookStatuses: {
			'available': { text: 'Налична', style: 'success', selectable: true },
			'requested': { text: 'Поискана', style: 'warning', selectable: false },
			'taken': { text: 'Заета', style: 'danger', selectable: true },
			'unavailable': { text: 'Не e налична', style: 'unavailable', selectable: true }
		},

		familyRoles: {
			'father': { text: 'Баща', placeholder: 'Иван' },
			'mother': { text: 'Майка', placeholder: 'Мария' }
		},

		childRoles: {
			'son': { text: 'Син' },
			'daughter': { text: 'Дъщеря' }
		},

		countries: {
			'BG': { text: 'България' }
		},

		states: {
			'1': { text: 'Благоевград', code: 'Бл' },
			'2': { text: 'Бургас', code: 'Бс' },
			'3': { text: 'Варна', code: 'Вн' },
			'4': { text: 'Велико Търново', code: 'ВТ' },
			'5': { text: 'Видин', code: 'Вд' },
			'6': { text: 'Враца', code: 'Вр' },
			'7': { text: 'Габрово', code: 'Гб' },
			'8': { text: 'Добрич', code: 'Дб' },
			'9': { text: 'Кърджали', code: 'Кж' },
			'10': { text: 'Кюстендил', code: 'Кн' },
			'11': { text: 'Ловеч', code: 'Лч' },
			'12': { text: 'Монтана', code: 'Мн' },
			'13': { text: 'Пазарджик', code: 'Пз' },
			'14': { text: 'Перник', code: 'Пк' },
			'15': { text: 'Плевен', code: 'Пл' },
			'16': { text: 'Пловдив', code: 'Пд' },
			'17': { text: 'Разград', code: 'Рз' },
			'18': { text: 'Русе', code: 'Рс' },
			'19': { text: 'Силистра', code: 'Сс' },
			'20': { text: 'Сливен', code: 'Сл' },
			'21': { text: 'Смолян', code: 'См' },
			'22': { text: 'Софийска област', code: 'СО' },
			'23': { text: 'София', code: 'Сф' },
			'24': { text: 'Стара Загора', code: 'СЗ' },
			'25': { text: 'Търговище', code: 'Тщ' },
			'26': { text: 'Хасково', code: 'Хс' },
			'27': { text: 'Шумен', code: 'Шм' },
			'28': { text: 'Ямбол', code: 'Яб' }
		},
		socialNetworks: {
			'blog': { text: 'Blog' },
			'facebook': { text: 'Facebook' },
			'twitter': { text: 'Twitter' },
			'linkedin': { text: 'LinkedIn' },
			'googleplus': { text: 'Google+' },
			'youtube': { text: 'YouTube' },
			'instagram': { text: 'Instagram' },
			'pinterest': { text: 'Pinterest' },
			'tumblr': { text: 'Tumblr' },
			'reddit': { text: 'Reddit' },
			'flickr': { text: 'Flickr' }
		},
		hsmethods: {
			'traditional': { name: 'Традиционен метод', desc: 'Най-много наподобява училищния подход. Използва се готова учебна програма, като родителите я променят според темпото, с което детето учи.' },
			'trivium': { name: 'Класически метод (Тривиум)', desc: 'Три етапа: Граматика (6-10 г., запомнят информация, разбират и запомнят правила), Логика (10-12 г., учат се да мислят логично в различните области на познанието), Риторика (гимназиална възраст, учат се да изразяват себе си писмено и устно).' },
			'unit_studies': { name: 'Тематични уроци (Unit Studies)', desc: 'Дадена тема се разглежда чрез различни учебни предмети и дисциплини. По този начин информацията не се представя на децата дефрагментирано, а като едно цяло.' },
			'unschooling': { name: 'Неучилищен метод (ънскулинг)', desc: 'Естествено, водено от децата и техните интереси образование. Децата не следват предварително зададена училищна програма или формални уроци.' },
			'charlotte_mason': { name: 'Метод на Шарлот Мейсън', desc: 'Шарлот Мейсън (1842-1923 г.) препоръчва изучаването на история, география и литература да става чрез четене на „живи книги“, чийто автор има истински интерес към темата и пише увлекателно, за разлика от един учебник, който дава безлична и фрагментирана информация по много теми. Живите книги представят вдъхновяваши истории и герои, които вълнуват умовете на деца. Методът на Мейсън препоръчва разходки сред природата, вдъхновяващи занимания с изкуството и музиката.' },
			'eclectic': { name: 'Избирателен метод (Eclectic)', desc: 'Комбиниране на различни методи на обучение по различните предмети.' },
			'distance_school': { name: 'Дистанционно училище', desc: 'Учене по програма, предоставена от дистанционно училище.' }
		},

		categoryScopes: {
			'all': { text: 'по всички екрани' },
			'forum': { text: 'само във Форуми' },
			'lesson': { text: 'само в Учебни материали' }
		},

		sectionColors: {
			'#6add2c': { text: 'Зелен' },
			'#e3412b': { text: 'Червен' },
			'#3552eb': { text: 'Син' },
			'#e9e344': { text: 'Жълт' },
			'#b93dde': { text: 'Лилав' },
			'#36dddd': { text: 'Светлосин' },
			'#212421': { text: 'Черен' },
			'#8a8889': { text: 'Сив' },
			'#e5e6e4': { text: 'Бял' }
		},

		borrowPeriods: [{ value: 3, label: '3 месеца' }, { value: 6, label: '6 месеца' }, { value: 9, label: '9 месеца' }, { value: 12, label: '12 месеца' }]
	}
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moment = __webpack_require__(0);
moment.locale('bg');

var urlParser = document.createElement('a');

module.exports = {
	domain: function domain(url) {
		urlParser.href = url;
		return urlParser.hostname;
	},
	count: function count(arr) {
		return arr.length;
	},
	prettyDate: function prettyDate(date) {
		return moment(date).format('DD.MM.YYYY');
	},
	prettyDateTime: function prettyDateTime(utc) {
		return moment(utc).format('DD.MM.YYYY HH:mm');
	},
	fromNowDateTime: function fromNowDateTime(utc) {
		return moment(utc).fromNow();
	},
	pluralize: function pluralize(time, label) {
		if (time === 1) {
			return time + label;
		}

		return time + label + 's';
	},
	nl2br: function nl2br(text) {
		return text.replace(/(?:\r\n|\r|\n)/g, '<br />');
	}
};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	bg: {
		app: {
			title: 'Семейна образователна мрежа'
		},
		label: {
			first_name: 'Име',
			fathername: 'Баща',
			mothername: 'Майка',
			email: 'Email',
			book_title: 'Заглавие',
			book_description: 'Описание',
			book_categories: 'Категории',
			book_language: 'Език',
			book_author: 'Автор',
			book_publisher: 'Издателство',
			book_status: 'Статус',
			book_taker_internal: 'При семейство от мрежата',
			book_taker_external: 'При семейство, което не е в мрежата',
			link_title: 'Заглавие',
			link_description: 'Описание',
			link_categories: 'Категории',
			link_language: 'Език',
			link_link: 'Връзка',
			topic_title: 'Заглавие',
			topic_section: 'Секция',
			topic_categories: 'Категории',
			topic_text: 'Съобщение',
			category_name: 'Име',
			category_scope: 'Използване',
			category_parent: 'Над-категория',
			section_name: 'Име',
			section_description: 'Описание',
			section_color: 'Цвят',
			section_paid: 'Платена',
			family_name: 'Име на семейството',
			family_people: 'Членове на семейството',
			family_parents: 'Родители',
			family_children: 'Деца',
			person_name: 'Име',
			person_interests: 'Интереси',
			person_photo: 'Снимка',
			person_sex: 'Пол',
			person_birth_year: 'Година на раждане',
			person_add: 'Добавяне',
			family_location: 'Контакт',
			family_country: 'Страна',
			family_state: 'Област',
			family_city: 'Град/село',
			family_social: 'Контакти в социалните мрежи',
			family_about_us: 'Домашно образование',
			family_experience: 'Опит (години)',
			family_methods: 'Методи',
			family_admin_note: 'Бележка за модератора',
			family_interests: 'Интереси (разделени със запетая)',
			family_about: 'Информация',
			family_social_network: 'Социална мрежа',
			family_social_url: 'Адрес (URL)',
			invited_by: 'Поканени сте от',
			accept: 'Приеми',
			decline: 'Откажи',
			forum_reply: 'Отговор',
			forum_edit: 'Редакция'
		},
		title: {
			dashboard: 'Начало',
			events: 'История',
			familyProfile: 'Семеен профил',
			familyProfileEdit: 'Семеен профил: Редактиране',
			familyList: 'Семейства',
			books: 'Книги',
			bookNew: 'Нова Книга',
			bookEdit: 'Книга: Редактиране',
			bookView: 'Книга',
			materials: 'Учебни материали',
			materialView: 'Учебен Материал',
			materialNew: 'Нов Учебен Материал',
			materialEdit: 'Редактиране на Учебен Материал',
			links: 'Връзки',
			linkNew: 'Нова Връзкa',
			linkView: 'Връзка',
			linkEdit: 'Редактиране на Връзкa',
			discussionNew: 'Нова Тема',
			registration: 'Регистрация на семеен профил',
			invitation: 'Покана за приесъединяване към мрежата',
			calendar: 'Календар',
			plans: 'Планове на уроци',
			planEdit: 'Планове на уроци: Редактиране',
			planNew: 'Нов план на уроци',
			categoryList: 'Категории',
			categoryNew: 'Категория: Нова',
			categoryEdit: 'Категория: Редактиране',
			categoryView: 'Категория',
			sectionList: 'Секции',
			sectionNew: 'Нова Секция',
			sectionEdit: 'Редактиране на Секция',
			familyRequests: 'Регистрации',
			familyRequest: 'Регистрация',
			discussions: 'Дискусии',
			theme: 'Тема'
		},
		status: {
			error: 'Грешка',
			book_undefined: 'Грешка',
			book_available: 'Налична',
			book_unavailable: 'Не e налична',
			book_requested: 'Поискана',
			book_taken: 'Заета',
			family_new: 'Ново',
			family_edited: 'Променено',
			family_rejected: 'Неодобренo'
		}
	}
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray2 = __webpack_require__(367);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
	bg: {
		messages: {
			_default: function _default(field) {
				return 'Полето не е валидно.';
			},
			after: function after(field, _ref) {
				var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
				    target = _ref2[0],
				    inclusion = _ref2[1];

				return 'The ' + field + ' must be after ' + (inclusion ? 'or equal to ' : '') + target + '.';
			},
			alpha_dash: function alpha_dash(field) {
				return 'Полето може да съдържа букви, цифри, тирета и подчертавки.';
			},
			alpha_num: function alpha_num(field) {
				return 'Полето може да съдържа букви и цифри.';
			},
			alpha_spaces: function alpha_spaces(field) {
				return 'Полето може да съдържа само букви и интервали.';
			},
			alpha: function alpha(field) {
				return 'Полето трябва да съдържа само букви.';
			},
			before: function before(field, _ref3) {
				var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
				    target = _ref4[0],
				    inclusion = _ref4[1];

				return 'The ' + field + ' must be before ' + (inclusion ? 'or equal to ' : '') + target + '.';
			},
			between: function between(field, _ref5) {
				var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
				    min = _ref6[0],
				    max = _ref6[1];

				return '\u041F\u043E\u043B\u0435\u0442\u043E \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0438\u043C\u0430 \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442 \u043C\u0435\u0436\u0434\u0443 ' + min + ' \u0438 ' + max + '.';
			},
			confirmed: function confirmed(field) {
				return 'Полето за потвърждение не съвпада.';
			},
			credit_card: function credit_card(field) {
				return 'Полето не е валидно.';
			},
			date_between: function date_between(field, _ref7) {
				var _ref8 = (0, _slicedToArray3.default)(_ref7, 2),
				    min = _ref8[0],
				    max = _ref8[1];

				return '\u041F\u043E\u043B\u0435\u0442\u043E \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0435 \u043C\u0435\u0436\u0434\u0443 ' + min + ' \u0438 ' + max + '.';
			},
			date_format: function date_format(field, _ref9) {
				var _ref10 = (0, _slicedToArray3.default)(_ref9, 1),
				    format = _ref10[0];

				return '\u041F\u043E\u043B\u0435\u0442\u043E \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0435 \u0432\u044A\u0432 \u0444\u043E\u0440\u043C\u0430\u0442 ' + format + '.';
			},
			decimal: function decimal(field) {
				var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['*'],
				    _ref12 = (0, _slicedToArray3.default)(_ref11, 1),
				    decimals = _ref12[0];

				return 'The ' + field + ' must be numeric and may contain ' + (decimals === '*' ? '' : decimals) + ' decimal points.';
			},
			digits: function digits(field, _ref13) {
				var _ref14 = (0, _slicedToArray3.default)(_ref13, 1),
				    length = _ref14[0];

				return '\u041F\u043E\u043B\u0435\u0442\u043E \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430 \u0441\u0430\u043C\u043E ' + length + ' \u043D\u0430 \u0431\u0440\u043E\u0439 \u0446\u0438\u0444\u0440\u0438.';
			},
			dimensions: function dimensions(field, _ref15) {
				var _ref16 = (0, _slicedToArray3.default)(_ref15, 2),
				    width = _ref16[0],
				    height = _ref16[1];

				return 'The ' + field + ' must be ' + width + ' pixels by ' + height + ' pixels.';
			},
			email: function email(field) {
				return 'Моля, въведете валиден email адрес.';
			},
			ext: function ext(field) {
				return 'The ' + field + ' must be a valid file.';
			},
			image: function image(field) {
				return 'The ' + field + ' must be an image.';
			},
			in: function _in(field) {
				return 'The ' + field + ' must be a valid value.';
			},
			ip: function ip(field) {
				return 'Полето трябва да е валиден IP адрес.';
			},
			max: function max(field, _ref17) {
				var _ref18 = (0, _slicedToArray3.default)(_ref17, 1),
				    length = _ref18[0];

				return 'The ' + field + ' may not be greater than ' + length + ' characters.';
			},
			max_value: function max_value(field, _ref19) {
				var _ref20 = (0, _slicedToArray3.default)(_ref19, 1),
				    max = _ref20[0];

				return 'The ' + field + ' must be ' + max + ' or less.';
			},
			mimes: function mimes(field) {
				return 'The ' + field + ' must have a valid file type.';
			},
			min: function min(field, _ref21) {
				var _ref22 = (0, _slicedToArray3.default)(_ref21, 1),
				    length = _ref22[0];

				return 'The ' + field + ' must be at least ' + length + ' characters.';
			},
			min_value: function min_value(field, _ref23) {
				var _ref24 = (0, _slicedToArray3.default)(_ref23, 1),
				    min = _ref24[0];

				return 'The ' + field + ' must be ' + min + ' or more.';
			},
			not_in: function not_in(field) {
				return 'The ' + field + ' must be a valid value.';
			},
			numeric: function numeric(field) {
				return 'Полето трябва да съдържа само цифри.';
			},
			regex: function regex(field) {
				return 'The ' + field + ' format is invalid.';
			},
			required: function required(field) {
				return 'Полето е задължително.';
			},
			size: function size(field, _ref25) {
				var _ref26 = (0, _slicedToArray3.default)(_ref25, 1),
				    _size = _ref26[0];

				return 'The ' + field + ' must be less than ' + _size + ' KB.';
			},
			url: function url(field) {
				return 'The ' + field + ' is not a valid URL.';
			}
		}
	}
};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AfterLoginView = __webpack_require__(594);
var NoSideMenuView = __webpack_require__(596);
var NotFoundView = __webpack_require__(592);

var routes = [{
	path: '/login',
	component: __webpack_require__(595)
}, {
	path: '/registration',
	component: NoSideMenuView,

	children: [{
		path: '',
		component: __webpack_require__(618),
		name: 'title.registration'
	}, {
		path: 'invite/:family/:token',
		component: __webpack_require__(617),
		name: 'title.invitation'
	}]
}, {
	path: '/',
	component: AfterLoginView,
	children: [{
		path: '',
		component: __webpack_require__(615),
		name: 'title.dashboard'
	}, {
		path: '/events',
		component: __webpack_require__(616),
		name: 'title.events'
	}, {
		path: '/family/list',
		component: __webpack_require__(620),
		name: 'title.familyList'
	}, {
		path: '/family/:id',
		component: __webpack_require__(621),
		name: 'title.familyProfile'
	}, {
		path: '/family/:id/edit',
		component: __webpack_require__(622),
		name: 'title.familyProfileEdit'
	}, {
		path: '/family/:id/calendar',
		component: __webpack_require__(619),
		name: 'title.calendar'
	}, {
		path: '/discussion/list',
		component: __webpack_require__(625),
		name: 'title.discussions'
	}, {
		path: '/discussion/new',
		component: __webpack_require__(624),
		name: 'title.discussionNew'
	}, {
		path: '/discussion/:id',
		component: __webpack_require__(623),
		name: 'title.theme'
	}, {
		path: '/book/list',
		component: __webpack_require__(627),
		name: 'title.books'
	}, {
		path: '/book/new',
		component: __webpack_require__(291),
		name: 'title.bookNew'
	}, {
		path: '/book/:id',
		component: __webpack_require__(626),
		name: 'title.bookView'
	}, {
		path: '/book/:id/edit',
		component: __webpack_require__(291),
		name: 'title.bookEdit'
	}, {
		path: '/material/list',
		component: __webpack_require__(631),
		name: 'title.materials'
	}, {
		path: '/material/new',
		component: __webpack_require__(67),
		name: 'title.materialNew',
		props: { resource: 'material' }
	}, {
		path: '/material/:id',
		component: __webpack_require__(630),
		name: 'title.materialView'
	}, {
		path: '/material/:id/edit',
		component: __webpack_require__(67),
		name: 'title.materialEdit',
		props: { resource: 'material' }
	}, {
		path: '/link/list',
		component: __webpack_require__(629),
		name: 'title.links'
	}, {
		path: '/link/new',
		component: __webpack_require__(67),
		name: 'title.linkNew',
		props: { resource: 'link' }
	}, {
		path: '/link/:id',
		component: __webpack_require__(628),
		name: 'title.linkView'
	}, {
		path: '/link/:id/edit',
		component: __webpack_require__(67),
		name: 'title.linkEdit',
		props: { resource: 'link' }
	}, {
		path: '/moderate/category/list',
		component: __webpack_require__(597),
		name: 'title.categoryList'
	}, {
		path: '/moderate/category/new',
		component: __webpack_require__(289),
		name: 'title.categoryNew'
	}, {
		path: '/moderate/category/:id/edit',
		component: __webpack_require__(289),
		name: 'title.categoryEdit'
	}, {
		path: '/moderate/section/list',
		component: __webpack_require__(601),
		name: 'title.sectionList'
	}, {
		path: '/moderate/section/new',
		component: __webpack_require__(290),
		name: 'title.sectionNew'
	}, {
		path: '/moderate/section/:id/edit',
		component: __webpack_require__(290),
		name: 'title.sectionEdit'
	}, {
		path: '/moderate/registration/list',
		component: __webpack_require__(599),
		name: 'title.familyRequests'
	}, {
		path: '/moderate/registration/:id',
		component: __webpack_require__(600),
		name: 'title.familyRequest'
	}]
}, {
	path: '*',
	component: NotFoundView
}];

module.exports = routes;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	name: 'NotFound'
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	name: 'App',
	data: function data() {
		return {
			locale: 'en'
		};
	},
	methods: {}
};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(6);
module.exports = {
	name: 'Dash',
	data: function data() {
		return {
			section: 'Dash',
			me: '',
			error: '',
			api: {
				servers: {
					url: '',
					result: []
				}
			}
		};
	},
	computed: {
		state: function state() {
			return {
				userInfo: {
					tasks: [],
					messages: [],
					notifications: []
				}
			};
		},
		callAPI: function callAPI() {
			return this.$parent.callAPI;
		},
		year: function year() {
			var y = new Date();
			return y.getFullYear();
		}
	},
	methods: {
		toggleMenu: function toggleMenu(event) {
			$('li.pageLink').removeClass('active');

			event.toElement.parentElement.className = 'pageLink active';
		}
	},
	mounted: function mounted() {}
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Vue = __webpack_require__(101);

module.exports = {
	name: 'Login',
	data: function data(router) {
		return {
			section: 'Login',
			response: ''
		};
	},
	methods: {
		login: function login(method) {
			var _this = this;

			setTimeout(function () {
				location.href = Vue.config.backend + '/auth/' + method + '?redirect=' + encodeURIComponent(_this.$route.query.redirect || '/');
			});
		}
	}
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(6);
module.exports = {
	name: 'NoSideMenuView',
	data: function data() {
		return {
			section: 'Dash',
			me: '',
			error: '',
			api: {
				servers: {
					url: '',
					result: []
				}
			}
		};
	},
	computed: {
		state: function state() {
			return {
				userInfo: {
					tasks: [],
					messages: [],
					notifications: []
				}
			};
		},
		callAPI: function callAPI() {
			return this.$parent.callAPI;
		},
		year: function year() {
			var y = new Date();
			return y.getFullYear();
		}
	},
	methods: {
		toggleMenu: function toggleMenu(event) {
			$('li.pageLink').removeClass('active');

			event.toElement.parentElement.className = 'pageLink active';
		}
	},
	mounted: function mounted() {}
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cache = __webpack_require__(40);
module.exports = {
	data: function data() {
		return {
			category: {},
			dataReady: false
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			if (!this.$route.params.id) {
				this.dataReady = true;
				this.category = {
					name: '',
					scope: undefined,
					parent: ''
				};
				return;
			}

			this.$http.get('backend://category/' + this.$route.params.id).then(function (response) {
				_this.category = response.body;
				if (_this.category.parent !== undefined) {
					_this.category.parent = _this.category.parent + '';
				}
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		onSubmit: function onSubmit() {
			var _this2 = this;

			if (this.category.parent === '') {
				this.category.parent = undefined;
			}
			this.$validator.validateAll().then(function (result) {
				if (!result) {
					_this2.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				_this2.$http.putOrPostResource('backend://category/', _this2.category).then(function (response) {
					cache.update(_this2);
					_this2.$router.push('/moderate/category/list');
				}).catch(_this2.$http.toastCatcher);
			});
		}
	}
};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			items: [],
			total: 0,
			dataReady: false
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			this.$http.get('backend://category').then(function (response) {
				_this.items = response.body.items;
				_this.total = response.body.total;
				_this.pages = Math.ceil(_this.total / _this.rpp);
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},

		remove: function remove(id) {
			var _this2 = this;

			this.$http.delete('backend://category/' + id).then(function (result) {
				_this2.fetchData();
			}).catch(this.$http.toastCatcher);
		}
	},
	components: {
		'category-tree': __webpack_require__(598)
	}
};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cache = __webpack_require__(40);
var selfComponent = module.exports = {
	name: 'category-tree',
	props: ['categoryId'],
	data: function data() {
		return {
			cache: cache.data,
			expanded: true
		};
	},
	computed: {
		childCategories: function childCategories() {
			var children = [];
			for (var childCategoryId in this.cache.categories) {
				var childCategory = this.cache.categories[childCategoryId];
				if (childCategory.parent === this.categoryId || !childCategory.parent && !this.categoryId) {
					children.push(childCategory);
				}
			}
			return children;
		}
	},
	created: function created() {
		cache.prepare(this);
	},

	methods: {
		remove: function remove(id) {
			var _this = this;

			this.$http.delete('backend://category/' + id).then(function (result) {
				cache.update(_this);
			}).catch(this.$http.toastCatcher);
		}
	},
	components: {
		'category-tree': selfComponent
	}
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			records: [],
			dataReady: false
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData(pageNum) {
			var _this = this;

			pageNum = pageNum || 1;
			this.$http.get('backend://registration?limit=' + this.$config.rpp + '&page=' + pageNum).then(function (response) {
				_this.records = response.body;
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		pageClick: function pageClick(pageNum) {
			this.fetchData(pageNum);
		},
		getChildAge: function getChildAge(child) {
			var currentYear = new Date().getFullYear();
			return currentYear - child.birthYear;
		}
	}
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			registration: {},
			role: 'father',
			fatherInfo: {},
			motherInfo: {},
			familyChildren: [],
			dataReady: false
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		getChildAge: function getChildAge(child) {
			var currentYear = new Date().getFullYear();
			return currentYear - child.birthYear + ' год.';
		},
		goBack: function goBack() {
			this.$router.push('/family');
		},
		fetchData: function fetchData() {
			var _this = this;

			var familyUserId = 0;
			var familyId = 0;
			if (this.$route.params.id === 'me') {
				familyUserId = this.$root.user.familyUser.id;
				familyId = this.$root.user.familyUser.family.id;
			} else {
				familyId = this.$route.params.id;
			}
			this.$http.get('backend://registration/' + familyId).then(function (response) {
				_this.registration = response.body;

				_this.fatherInfo = { name: '', role: 'father', interests: '', birthYear: 0, id: 0 };
				_this.motherInfo = { name: '', role: 'mother', interests: '', birthYear: 0, id: 0 };

				for (var i = 0; i < _this.registration.users.length; i++) {
					var oMember = _this.registration.users[i];
					if (oMember.user === familyUserId) {
						_this.role = oMember.role;
					}
					if (oMember.role === 'father') {
						_this.fatherInfo = oMember;
					} else if (oMember.role === 'mother') {
						_this.motherInfo = oMember;
					} else {
						_this.familyChildren.push(oMember);
					}
				}
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		rejectRegistration: function rejectRegistration() {
			var _this2 = this;

			if (!confirm('Сигурни ли сте че не искате да одобрите това семейство?')) {
				return;
			}
			var comment = prompt('Моля, дайте причина за вашето неодобрение:');

			this.$http.post('backend://registration/' + this.registration.id + '/reject', { statusComment: comment }).then(function (response) {
				_this2.fetchData();
			}).catch(this.$http.toastCatcher);
		},
		approveRegistration: function approveRegistration(status) {
			var _this3 = this;

			if (!confirm('Сигурни ли сте че искате да одобрите това семейство?')) {
				return;
			}

			this.$http.post('backend://registration/' + this.registration.id + '/approve').then(function (response) {
				_this3.$router.push('/family/' + response.body.id);
			}).catch(this.$http.toastCatcher);
		}
	}
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			section: {},
			dataReady: false
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			if (!this.$route.params.id) {
				this.dataReady = true;
				this.section = {
					name: '',
					description: '',
					color: '',
					paid: ''
				};
				return;
			}

			this.$http.get('backend://section/' + this.$route.params.id).then(function (response) {
				_this.section = response.body;
				if (_this.section.parent !== undefined) {
					_this.section.parent = _this.section.parent + '';
				}
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		onSubmit: function onSubmit() {
			var _this2 = this;

			this.$validator.validateAll().then(function (result) {
				if (!result) {
					_this2.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				_this2.$http.putOrPostResource('backend://section/', _this2.section).then(function (response) {
					_this2.$router.push('/moderate/section/list');
				}).catch(_this2.$http.toastCatcher);
			});
		}
	}
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			items: [],
			total: 0,
			dataReady: false
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			this.$http.get('backend://section').then(function (response) {
				_this.items = response.body.items;
				_this.total = response.body.total;
				_this.pages = Math.ceil(_this.total / _this.rpp);
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},

		remove: function remove(id) {
			var _this2 = this;

			this.$http.delete('backend://section/' + id).then(function (result) {
				_this2.fetchData();
			}).catch(this.$http.toastCatcher);
		}
	}
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	name: 'f-family',
	props: {
		value: { type: null, default: undefined },
		name: { type: String },
		hideName: { type: null, default: false },
		cplaceholder: { type: String, default: '' },
		crequired: { type: Boolean, default: false },
		csingle: { type: Boolean, default: false },
		errors: { type: Array, default: function _default() {
				return [];
			} }
	},
	data: function data() {
		return {
			uniqueId: 'input-' + Math.random().toString(16).slice(2),
			cache: {
				fetchedFor: '',
				results: [],
				requestRunning: false
			},
			cacheResults: 10,
			autocompleteStub: '',
			autocompleting: false
		};
	},
	methods: {
		fetchResults: function fetchResults() {
			var _this = this;

			if (this.autocompleteStub === '') {
				this.cache.results = this.value && !this.autocompleting ? [this.value] : [];
				this.fetchedFor = this.autocompleteStub;
				return;
			}
			if (this.cache.requestRunning) return;
			var searchingFor = this.autocompleteStub;
			this.cache.requestRunning = true;
			this.$http.get('backend://family?limit=' + this.cacheResults + '&name=' + searchingFor).then(function (response) {
				_this.cache.requestRunning = false;
				_this.cache.results = response.body.items;
				_this.fetchedFor = searchingFor;
			}).catch(this.$http.toastCatcher);
		}
	},
	watch: {
		autocompleteStub: function autocompleteStub() {
			this.fetchResults();
		},
		autocompleting: function autocompleting() {
			this.fetchResults();
		}
	},
	computed: {
		inputFieldValue: {
			get: function get() {
				return this.autocompleting ? this.autocompleteStub : this.value ? this.value.name : '';
			},
			set: function set(value) {
				this.autocompleteStub = value;
				this.autocompleting = true;
			}
		},
		internalValue: {
			get: function get() {
				return this.value;
			},
			set: function set(value) {
				this.autocompleteStub = '';
				this.autocompleting = false;
				this.$emit('input', value);
			}
		},
		filteredResults: function filteredResults() {
			var _this2 = this;

			if (this.autocompleteStub.toLowerCase().indexOf(this.cache.fetchedFor.toLowerCase()) === -1) {
				this.fetchResults();
				return [];
			} else {
				return this.cache.results.filter(function (x) {
					return x.name.toLowerCase().indexOf(_this2.autocompleteStub.toLowerCase()) !== -1;
				});
			}
		}
	}
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	name: 'c-avatar',
	props: ['family', 'image', 'showName', 'link']
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	name: 'c-uavatar',
	props: ['familyuser', 'image', 'showName']
};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cache = __webpack_require__(40);
module.exports = {
	name: 'c-categories',
	cache: cache.data,
	props: ['value'],
	data: function data() {
		return {
			cache: cache.data
		};
	},
	computed: {
		categories: function categories() {
			return this.cache.categories;
		},
		valueArray: function valueArray() {
			return (this.value + '').split(',');
		}
	},
	created: function created() {
		cache.prepare(this);
	}
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(68);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(364);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getIterator2 = __webpack_require__(49);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = __webpack_require__(40);
module.exports = {
	name: 'f-category',
	props: {
		value: { type: String, default: '' },
		name: { type: String },
		hideName: { type: null, default: false },
		cplaceholder: { type: String, default: '' },
		crequired: { type: Boolean, default: false },
		csingle: { type: Boolean, default: false },
		errors: { type: Array, default: function _default() {
				return [];
			} }
	},
	data: function data() {
		return {
			selection: {},
			uniqueId: 'input-' + Math.random().toString(16).slice(2),
			cache: cache.data,
			autocompleteStub: '',
			expanded: false
		};
	},
	computed: {
		categories: function categories() {
			return this.cache.categories;
		},
		filteredCategories: function filteredCategories() {
			var filtered = [];
			for (var categoryId in this.cache.categories) {
				var category = this.cache.categories[categoryId];
				if (this.autocompleteStub !== '' && category.name.toLowerCase().indexOf(this.autocompleteStub.toLowerCase()) !== -1) {
					filtered.push(category.id);
				}
			}
			return filtered;
		}
	},
	watch: {
		value: function value(_value) {
			var values = [];
			if (_value + '' !== '') {
				values = (_value + '').split(',');
			}
			var selection = {};
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = (0, _getIterator3.default)(values), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var categoryId = _step.value;

					selection[categoryId] = true;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			this.selection = selection;
		}
	},
	created: function created() {
		cache.prepare(this);
		this.$options.watch.value.call(this, this.value);
	},

	methods: {
		setCategory: function setCategory(id, value) {
			if (id && !!this.selection[id] !== !!value) {
				if (value) {
					if (this.csingle) {
						this.selection = (0, _defineProperty3.default)({}, id, true);
					} else {
						this.$set(this.selection, id, true);
					}
				} else {
					this.$delete(this.selection, id);
				}
				this.$emit('input', (0, _keys2.default)(this.selection).join(','));
			}
		}
	},
	components: {
		'category-recursive': __webpack_require__(607)
	}
};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cache = __webpack_require__(40);
var selfComponent = module.exports = {
	name: 'category-recursive',
	props: ['categoryId', 'filteredIds', 'onlyFiltered', 'selection'],
	data: function data() {
		return {
			cache: cache.data,
			expanded: true
		};
	},
	computed: {
		childCategories: function childCategories() {
			var children = [];
			for (var childCategoryId in this.cache.categories) {
				var childCategory = this.cache.categories[childCategoryId];
				if (childCategory.parent === this.categoryId || !childCategory.parent && !this.categoryId) {
					children.push(childCategory);
				}
			}
			return children;
		},
		filteredChildren: function filteredChildren() {
			if (!Array.isArray(this.filteredIds)) return [];
			var childrenSet = {};
			for (var i = 0; i < this.filteredIds.length; i++) {
				var _id = this.filteredIds[i];
				var category = this.cache.categories[_id];
				var iterations = 20;

				while (iterations > 0 && category && !(category.parent === this.categoryId || !category.parent && !this.categoryId)) {
					iterations--;
					category = this.cache.categories[category.parent];
				}
				if (iterations > 0 && category) {
					childrenSet[category.id] = true;
				}
			}

			var children = [];
			for (var id in childrenSet) {
				children.push(this.cache.categories[id]);
			}
			return children;
		},
		childrenToShow: function childrenToShow() {
			if (!this.onlyFiltered) {
				return this.childCategories;
			} else {
				return this.filteredChildren;
			}
		}
	},
	created: function created() {
		cache.prepare(this);
	},

	components: {
		'category-recursive': selfComponent
	}
};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	name: 'f-image',
	props: {
		value: String,
		srcDefault: { type: String, default: '' },
		width: { type: Number, default: 40 },
		height: { type: Number, default: 40 },
		avatar: { type: Boolean, default: true },
		uploadEndpoint: { type: String, default: '' }
	},
	data: function data() {
		return {
			selected: ''
		};
	},
	computed: {
		preview: function preview() {
			return this.selected || this.value;
		}
	},
	methods: {
		imageChanged: function imageChanged(event) {
			var _this = this;

			var input = event.target;

			if (input.files && input.files[0]) {
				var reader = new FileReader();

				reader.onload = function (e) {
					var resizeImg = document.createElement('img');
					var resizeCanvas = _this.$el.querySelector('canvas');
					var resizeContext = resizeCanvas.getContext('2d');

					resizeImg.onload = function () {
						var width = _this.width || _this.height * resizeImg.width / resizeImg.height;
						var height = _this.height || _this.width * resizeImg.height / resizeImg.width;
						resizeCanvas.width = width;
						resizeCanvas.height = height;
						resizeContext.fillColor = '#000';
						resizeContext.rect(0, 0, width, height);
						resizeContext.fill();
						resizeContext.drawImage(resizeImg, 0, 0, width, height);

						_this.selected = resizeCanvas.toDataURL('image/png');
						if (_this.uploadEndpoint) {
							resizeCanvas.toBlob(function (blob) {
								var data = new FormData();
								data.append('image', blob, 'image.png');
								_this.$http.put(_this.uploadEndpoint, data).then(function (result) {
									_this.$emit('input', 'upload');
								}).catch(_this.$http.toastCatcher);
							}, 'image/png');
						} else {
							_this.$emit('input', _this.selected);
						}
					};

					resizeImg.src = e.target.result;
				};

				reader.readAsDataURL(input.files[0]);
			} else {
				this.selected = '';
				this.$emit('input', this.selected);
			}
		}
	}
};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	name: 'f-input',
	props: {
		value: { type: [Number, String], default: '' },
		name: { type: String },
		hideName: { type: null, default: false },
		cplaceholder: { type: String, default: '' },
		crequired: { type: Boolean, default: false },
		errors: { type: Array, default: function _default() {
				return [];
			} }
	},
	data: function data() {
		return {
			uniqueId: 'input-' + Math.random().toString(16).slice(2)
		};
	}
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	props: {
		okText: {
			type: String,
			default: 'OK'
		},
		cancelText: {
			type: String,
			default: 'Cancel'
		},
		title: {
			type: String,
			default: ''
		},
		large: {
			type: Boolean,
			default: false
		},
		small: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		onOK: function onOK() {
			this.$emit('ok');
		}
	}
};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Vue = __webpack_require__(101);
var Paginate = __webpack_require__(681);
Vue.component('paginate', Paginate);

module.exports = {
	name: 'f-pager',
	props: ['total', 'clickhandler'],
	data: function data() {
		return {
			page: 1
		};
	},
	computed: {
		pageCount: function pageCount() {
			return Math.ceil(this.total / this.$config.rpp);
		},
		fromItem: function fromItem() {
			return Math.min((this.page - 1) * this.$config.rpp + 1, this.total);
		},
		toItem: function toItem() {
			return Math.min(this.page * this.$config.rpp, this.total);
		}
	},
	methods: {
		onClick: function onClick(p) {
			this.page = p;
			this.clickhandler(p);
		}
	}
};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	props: {
		value: { type: [String, Number], default: '' },
		name: { type: String },
		radios: { type: Array, default: function _default() {
				return [];
			} },
		label: { type: String, default: '' },
		disabled: { type: Boolean, default: false },
		errors: { type: Array, default: function _default() {
				return [];
			} }
	},
	data: function data() {
		return {
			selectedItem: this.value
		};
	},
	methods: {
		onChange: function onChange(event) {
			this.$emit('input', this.selectedItem);
		}
	}
};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	name: 'f-select',
	props: {
		value: { type: null, default: undefined },
		name: { type: String },
		allowOther: { type: Boolean, default: false },
		allowNone: { type: Boolean, default: false },
		hideName: { type: null, default: false },
		values: { type: Object, default: function _default() {
				return {};
			} },
		cdefault: { type: null, default: undefined },
		crequired: { type: Boolean, default: false },
		cplaceholder: { type: String, default: '-- Изберете --' },
		errors: { type: Array, default: function _default() {
				return [];
			} }
	},
	data: function data() {
		return {
			uniqueId: 'input-' + Math.random().toString(16).slice(2)
		};
	}
};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	name: 'f-textarea',
	props: {
		value: { type: String, default: '' },
		name: { type: String },
		placeholder: { type: String, default: '' },
		hideName: { type: null, default: false },
		crows: { type: Number, default: 10 },
		crequired: { type: Boolean, default: false },
		errors: { type: Array, default: function _default() {
				return [];
			} }
	},
	data: function data() {
		return {
			uniqueId: 'input-' + Math.random().toString(16).slice(2),
			internalValue: this.value
		};
	},

	computed: {
		computedRows: function computedRows() {
			if (this.crows > 0) {
				return this.crows;
			} else {
				return Math.max(Math.abs(this.crows), this.internalValue.split('\n').length);
			}
		}
	},
	watch: {
		value: function value() {
			this.internalValue = this.value;
		},
		internalValue: function internalValue() {
			this.$emit('input', this.internalValue);
		}
	}
};

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var jQuery = __webpack_require__(6);
__webpack_require__(496);
var mapBgBg = __webpack_require__(306);
jQuery.fn.vectorMap('addMap', 'bg_bg', mapBgBg);

module.exports = {
	data: function data() {
		return {
			report: '',
			history_records: [],
			dataReady: false,
			dataHistoryReady: false
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	beforeDestroy: function beforeDestroy() {
		jQuery(this.$el).find('.jvectormap-container').each(function (i, el) {
			return jQuery(el).data('mapObject').remove();
		});
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			this.$http.get('backend://report/total').then(function (result) {
				_this.report = result.body;
				_this.dataReady = true;

				var mapData = {};
				for (var state in _this.$config.lists.states) {
					var oState = _this.$config.lists.states[state];
					if (_this.report.cnt_by_state[state]) {
						mapData['BG-' + oState.code] = _this.report.cnt_by_state[state];
					}
				}
				setTimeout(function () {
					return _this.showMap('bgMap', mapData);
				}, 0);
			}).catch(this.$http.toastCatcher);

			this.$http.get('backend://history?limit=5').then(function (result) {
				_this.history_records = result.body;
				_this.dataHistoryReady = true;
			}).catch(this.$http.toastCatcher);
		},
		showMap: function showMap(mapID, mapData) {
			var mapName = 'bg_bg';
			jQuery('#' + mapID).vectorMap({
				map: mapName,
				backgroundColor: 'transparent',
				regionLabelStyle: {
					initial: {
						'font-family': 'Roboto',
						'font-weight': 'normal'
					}
				},
				regionStyle: {
					initial: {
						'fill': '#ffffff',
						'fill-opacity': 1,
						'stroke-width': 1,
						'stroke': '#7d8286'
					}
				},
				series: {
					regions: [{
						values: mapData,
						scale: ['#a9d7a9', '#5cb85c'],
						normalizeFunction: 'polynomial'
					}]
				},
				labels: {
					regions: {
						render: function render(code) {
							return code.split('-')[1];
						},

						offsets: function offsets(code) {
							var map = mapBgBg;
							return map.paths[code] ? map.paths[code].offset : undefined;
						}
					}
				},
				onRegionTipShow: function onRegionTipShow(e, tip, code) {
					var num = '0';
					if (typeof mapData[code] !== 'undefined') {
						num = mapData[code];
					}
					tip.text(tip.text() + ': ' + num);
				},

				zoomAnimate: true
			});
		}
	}
};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			records: {},
			dataReady: false
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData(pageNum) {
			var _this = this;

			pageNum = pageNum || 1;
			this.$http.get('backend://history?limit=' + this.$config.rpp + '&page=' + pageNum).then(function (result) {
				_this.records = result.body;
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		pageClick: function pageClick(pageNum) {
			this.fetchData(pageNum);
		}
	}
};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			invitation: {},
			dataReady: false
		};
	},
	computed: {
		usersByRole: function usersByRole() {
			var roles = {
				child: [],
				mother: [],
				father: [],
				son: [],
				daughter: []
			};
			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[i];
				if (member.role === 'son' || member.role === 'daughter') {
					roles.child.push(member);
				}
				roles[member.role].push(member);
			}
			return roles;
		}
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			this.$http.get('backend://family/' + this.$route.params.family + '/invite/' + this.$route.params.token).then(function (result) {
				_this.invitation = result.body;
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		acceptInvitation: function acceptInvitation() {
			var _this2 = this;

			this.$http.post('backend://family/' + this.$route.params.family + '/invite/' + this.$route.params.token, {}).then(function (response) {
				_this2.$user.refresh().then(function () {
					_this2.$router.push('/');
				});
			}).catch(this.$http.toastCatcher);
		},
		declineInvitation: function declineInvitation() {
			var _this3 = this;

			this.$http.delete('backend://family/' + this.$route.params.family + '/invite/' + this.$route.params.token).then(function (response) {
				_this3.$toasted.show('Успешно отказахте поканата.').goAway(1500);
				_this3.$router.push('/registration');
			}).catch(this.$http.toastCatcher);
		}
	}
};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			family: {
				role: '',
				name: '',
				users: [],
				country: undefined,
				state: undefined,
				city: '',
				info: {
					about: '',
					interests: '',
					hsExperience: 0,
					hsMethods: []
				},
				note: ''
			},
			dataReady: false,
			isPending: false
		};
	},
	computed: {
		usersByRole: function usersByRole() {
			var roles = {
				child: [],
				mother: [],
				father: [],
				son: [],
				daughter: []
			};
			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[i];
				if (member.role === 'son' || member.role === 'daughter') {
					roles.child.push(member);
				}
				roles[member.role].push(member);
			}
			return roles;
		}
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			if (!this.$user.registration) {
				this.dataReady = true;
				this.isPending = false;
			} else {
				this.$http.get('backend://registration/' + this.$user.registration).then(function (result) {
					_this.family = result.body;
					_this.dataReady = true;
					_this.isPending = true;
				}).catch(this.$http.toastCatcher);
			}
		},
		onSubmit: function onSubmit() {
			var _this2 = this;

			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[i];
				if (member.name === '') {
					this.family.users.splice(i, 1);
					i--;
				}
			}
			if (this.usersByRole.mother.length === 0 && this.usersByRole.father.length === 0) {
				this.$toasted.show('Моля, попълнете името на поне един родител').goAway(1500);
				return;
			}

			this.$validator.validateAll().then(function (result) {
				if (!result) {
					_this2.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				_this2.$http.putOrPostResource('backend://registration/', _this2.family).then(function (response) {
					_this2.$user.refresh().then(function () {
						window.scrollTo(0, 0);
						_this2.$toasted.show('Записването на информацията е успешно! Регистрацията Ви изчаква одобрение.').goAway(1500);
						_this2.fetchData();
					});
				}).catch(_this2.$http.toastCatcher);
			});
		},
		addChild: function addChild() {
			this.family.users.push({ name: '', role: 'son', birthYear: 2000, id: 0 });
		},
		addParent: function addParent(role) {
			this.family.users.push({ name: '', role: role, interests: '', id: 0 });
			this.family.role = this.family.role || role;
		},
		removeChild: function removeChild(childIndex) {
			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[i];
				if (member.role === 'son' || member.role === 'daughter') {
					if (childIndex === 0) {
						this.family.users.splice(i, 1);
						return;
					}
					childIndex--;
				}
			}
		}
	}
};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			generateRandomNumbers: function generateRandomNumbers(numbers, max, min) {
				var a = [];
				for (var i = 0; i < numbers; i++) {
					a.push(Math.floor(Math.random() * (max - min + 1)) + max);
				}
				return a;
			}
		};
	},
	computed: {
		coPilotNumbers: function coPilotNumbers() {
			return this.generateRandomNumbers(12, 1000000, 10000);
		},
		personalNumbers: function personalNumbers() {
			return this.generateRandomNumbers(12, 1000000, 10000);
		},
		isMobile: function isMobile() {
			return window.innerWidth <= 800 && window.innerHeight <= 600;
		}
	}
};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			records: [],
			dataReady: false
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData(pageNum) {
			var _this = this;

			pageNum = pageNum || 1;
			this.$http.get('backend://family?limit=' + this.$config.rpp + '&page=' + pageNum).then(function (response) {
				_this.records = response.body;
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		pageClick: function pageClick(pageNum) {
			this.fetchData(pageNum);
		},
		getChildAge: function getChildAge(child) {
			var currentYear = new Date().getFullYear();
			return currentYear - child.birthYear;
		}
	}
};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			family: {},
			role: '',
			dataReady: false,
			invitedUser: {}
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	computed: {
		usersByRole: function usersByRole() {
			var roles = {
				child: [],
				mother: [],
				father: [],
				son: [],
				daughter: []
			};
			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[i];
				if (member.role === 'son' || member.role === 'daughter') {
					roles.child.push(member);
				}
				roles[member.role].push(member);
			}
			return roles;
		}
	},
	methods: {
		getChildAge: function getChildAge(child) {
			var currentYear = new Date().getFullYear();
			return currentYear - child.birthYear + ' год.';
		},
		fetchData: function fetchData() {
			var _this = this;

			var familyId = 0;
			if (this.$route.params.id === 'me') {
				familyId = this.$root.user.familyUser.family.id;
			} else {
				familyId = this.$route.params.id;
			}
			this.$http.get('backend://family/' + familyId).then(function (response) {
				_this.family = response.body;
				if (_this.family.id === _this.$user.familyUser.family.id) {
					_this.role = _this.$user.familyUser.role;
				}
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		inviteUser: function inviteUser(familyUser) {
			if (familyUser.invitationLink) {
				this.invitedUser = familyUser;
			} else {
				this.invitedUser = undefined;
				this.$http.post('backend://family/' + this.family.id + '/invite', { familyUser: familyUser.id }).then(function (response) {
					this.invitedUser = familyUser;
					this.invitedUser.invitationLink = response.body.invite;
				}).catch(this.$http.toastCatcher);
			}
		}
	}
};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Dropzone = __webpack_require__(680);

module.exports = {
	data: function data() {
		return {
			family: {
				name: '',
				users: [],
				country: undefined,
				state: undefined,
				city: '',
				info: {
					about: '',
					interests: '',
					hsExperience: 0,
					hsMethods: [],
					social: []
				}
			},
			dataReady: false
		};
	},
	components: {
		Dropzone: Dropzone
	},
	computed: {
		usersByRole: function usersByRole() {
			var roles = {
				child: [],
				mother: [],
				father: [],
				son: [],
				daughter: []
			};
			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[i];
				if (member.role === 'son' || member.role === 'daughter') {
					roles.child.push(member);
				}
				roles[member.role].push(member);
			}
			return roles;
		}
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		goBack: function goBack() {
			this.$router.push('/family/me');
		},
		fetchData: function fetchData() {
			var _this = this;

			var familyId = 0;
			if (this.$route.params.id === 'me') {
				familyId = this.$root.user.familyUser.family.id;
			} else {
				familyId = this.$route.params.id;
			}
			this.$http.get('backend://family/' + familyId).then(function (response) {
				_this.family = response.body;
				if (_this.family.info.social === undefined) {
					_this.family.info.social = [];
					_this.addSocial();
				}
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		addParent: function addParent(role) {
			this.family.users.push({ name: '', role: role, interests: '', id: 0 });
			this.family.role = this.family.role || role;
		},
		addChild: function addChild() {
			this.family.users.push({ name: '', role: 'son', birthYear: 2000, id: 0 });
		},
		removeChild: function removeChild(childIndex) {
			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[i];
				if (member.role === 'son' || member.role === 'daughter') {
					if (childIndex === 0) {
						this.family.users.splice(i, 1);
						return;
					}
					childIndex--;
				}
			}
		},
		addSocial: function addSocial() {
			this.family.info.social.push({ name: '', url: '' });
		},
		removeSocial: function removeSocial(currentIndex) {
			this.family.info.social.splice(currentIndex, 1);
		},
		onSubmit: function onSubmit() {
			var _this2 = this;

			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[i];
				if (member.name === '') {
					this.family.users.splice(i, 1);
					i--;
				}
			}
			if (this.usersByRole.mother.length === 0 && this.usersByRole.father.length === 0) {
				this.$toasted.show('Моля, попълнете името на поне един родител').goAway(1500);
				return;
			}
			for (var _i = 0; _i < this.family.info.social.length; _i++) {
				var socialContact = this.family.info.social[_i];
				if (socialContact.name === '') {
					this.family.info.social.splice(_i, 1);
					_i--;
				}
			}

			this.$validator.validateAll().then(function (result) {
				if (!result) {
					_this2.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				_this2.$http.put('backend://family/' + _this2.family.id, _this2.family).then(function (response) {
					this.$router.push('/family/me');
				}).catch(_this2.$http.toastCatcher);
			});
		}
	}
};

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var VueMarkdown = __webpack_require__(292).default;

module.exports = {
	data: function data() {
		return {
			topic: {},
			dataReady: false,
			pending: {
				text: ''
			},
			error: false
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			this.$http.get('backend://topic/' + this.$route.params.id).then(function (result) {
				_this.topic = result.body;
				_this.dataReady = true;
				_this.error = false;
			}).catch(function () {
				_this.dataReady = false;
				_this.error = true;
			});
		},
		sendReply: function sendReply() {
			var _this2 = this;

			this.$validator.validateAll().then(function (result) {
				if (!result) {
					_this2.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				_this2.$http.post('backend://topic/' + _this2.$route.params.id, _this2.pending).then(function (result) {
					_this2.fetchData();
					_this2.pending.text = '';
					process.nextTick(function () {
						return _this2.errorBag.clear();
					});
				}).catch(_this2.$http.toastCatcher);
			});
		},
		sendEdit: function sendEdit(item) {
			var _this3 = this;

			this.$http.post('backend://topic/' + this.$route.params.id + '/' + item.id, item).then(function (result) {
				_this3.$toasted.show('Успешен запис!').goAway(1500);
				item.editing = false;
				_this3.fetchData();
				process.nextTick(function () {
					return _this3.errorBag.clear();
				});
			}).catch(this.$http.toastCatcher);
		},
		deletePost: function deletePost(item) {
			var _this4 = this;

			if (!confirm('Сигурни ли сте че искате да изтриете този пост?')) {
				return;
			}
			this.$http.delete('backend://topic/' + this.$route.params.id + '/' + item.id).then(function (result) {
				_this4.$toasted.show('Успешно изтриване!').goAway(1500);
				_this4.fetchData();
			}).catch(this.$http.toastCatcher);
		},
		deleteTopic: function deleteTopic(item) {
			var _this5 = this;

			if (!confirm('Сигурни ли сте че искате да изтриете тази тема?')) {
				return;
			}
			this.$http.delete('backend://topic/' + this.$route.params.id).then(function (result) {
				_this5.$toasted.show('Успешно изтриване на темата!').goAway(1500);
				_this5.$router.go(-1);
			}).catch(this.$http.toastCatcher);
		},
		canDeleteTopic: function canDeleteTopic() {
			return this.$user.role === 'admin' || this.$user.role === 'moderator';
		},
		canDelete: function canDelete(item) {
			return this.$user.role === 'admin' || this.$user.role === 'moderator';
		},
		canEdit: function canEdit(item) {
			return item.author + '' === this.$user.familyUser.id + '' || this.$user.role === 'admin' || this.$user.role === 'moderator';
		},
		toggleEdit: function toggleEdit(item) {
			if (!item.editing) {
				this.$set(item, 'editing', true);
				this.$set(item, 'originalText', item.text);
			} else {
				item.editing = false;
				item.text = item.originalText;
				item.originalText = '';
			}
		},
		addQuote: function addQuote(item) {
			this.pending.text += ('\n' + item.text.trim()).replace(/\n/g, '\n> ');
		}
	},
	components: {
		'vue-markdown': VueMarkdown
	}

};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(285)))

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var VueMarkdown = __webpack_require__(292).default;
var cache = __webpack_require__(103);
module.exports = {
	data: function data() {
		return {
			cache: cache.data,
			dataReady: true,
			topic: undefined
		};
	},
	created: function created() {
		this.fetchData();
		cache.prepare(this);
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			if (!this.$route.params.id) {
				this.topic = {
					title: '',
					text: '',
					section: ''
				};
				this.dataReady = true;
			} else {
				this.$http.get('backend://topic/' + this.$route.params.id).then(function (result) {
					_this.topic = result.body;
					_this.dataReady = true;
				}).catch(this.$http.toastCatcher);
			}
		},
		onSubmit: function onSubmit() {
			var _this2 = this;

			this.$validator.validateAll().then(function (result) {
				if (!result) {
					_this2.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				_this2.$http.putOrPostResource('backend://topic/', _this2.topic).then(function (response) {
					_this2.$router.replace('/discussion/' + response.body.id);
				}).catch(_this2.$http.toastCatcher);
			});
		}
	},
	computed: {
		sectionValues: function sectionValues() {
			if (!this.cache.dataReady) return {};
			var result = {};
			for (var i in this.cache.sections) {
				if ((this.cache.sections[i].paid || 0) <= (this.$user.familyUser.family.paid || 0)) {
					result[i] = { text: this.cache.sections[i].name };
				}
			}
			return result;
		}
	},
	components: {
		'vue-markdown': VueMarkdown
	}
};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cache = __webpack_require__(103);

module.exports = {
	data: function data() {
		return {
			dataReady: false,
			cache: cache.data,
			page: 0,
			records: {},
			filter: {
				search: '',
				section: ''
			}
		};
	},
	created: function created() {
		this.fetchData();
		cache.prepare(this);
	},
	watch: {
		$route: 'fetchData'
	},
	computed: {
		sectionValues: function sectionValues() {
			if (!this.cache.dataReady) return {};
			var result = {};
			for (var i in this.cache.sections) {
				result[i] = { text: this.cache.sections[i].name, color: this.cache.sections[i].color };
			}
			return result;
		}
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			var query = [];
			for (var key in this.filter) {
				if (this.filter[key]) {
					query.push(encodeURIComponent(key) + '=' + encodeURIComponent(this.filter[key]));
				}
			}

			query.push('page=' + this.page);
			query.push('limit=' + this.$config.rpp);

			this.$http.get('backend://topic?' + query.join('&')).then(function (result) {
				_this.records = result.body;
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		pageClick: function pageClick(page) {
			this.page = page;
			this.fetchData();
		}
	}
};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	properties: ['id'],
	data: function data() {
		return {
			dataReady: true,
			book: {}
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			if (!this.$route.params.id) {
				this.book = {
					title: '',
					description: '',
					categories: '',
					language: 'BG',
					author: '',
					publisher: '',
					image: '',
					status: 'available'
				};
				this.dataReady = true;
			} else {
				this.$http.get('backend://book/' + this.$route.params.id).then(function (result) {
					_this.book = result.body;
					_this.dataReady = true;
				}).catch(this.$http.toastCatcher);
			}
		},
		onSubmit: function onSubmit() {
			var _this2 = this;

			this.$validator.validateAll().then(function (result) {
				if (!result) {
					_this2.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				_this2.$http.putOrPostResource('backend://book/', _this2.book).then(function (response) {
					_this2.$router.push('/book/list');
				}).catch(_this2.$http.toastCatcher);
			});
		}
	}
};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			dataReady: false,
			borrowPeriod: 3,
			takerType: 1,
			takerTypes: [{ value: 1, label: 'при семейство от Семейна образователна мрежа' }, { value: 2, label: 'при семейство извън мрежата' }],
			takerExternal: '',
			takerInternal: undefined,
			bookStatus: '',
			book: {}
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	computed: {
		isOwner: function isOwner() {
			if (!this.book.family) return false;
			return this.book.family.id + '' === this.$user.familyUser.family.id + '';
		},
		canBorrow: function canBorrow() {
			if (!this.book.family) return false;
			return this.book.family.id + '' !== this.$user.familyUser.family.id + '' && this.book.status === 'available';
		},
		isRequested: function isRequested() {
			return this.isOwner && this.book.status === 'requested';
		},
		isStatusChangeable: function isStatusChangeable() {
			return this.isOwner && this.book.status !== 'requested';
		}
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			this.$http.get('backend://book/' + this.$route.params.id).then(function (result) {
				if (!result.body.error) {
					_this.book = result.body;
					_this.bookStatus = _this.book.status;
					if (_this.book.status === 'taken') {
						if (_this.book.takerExternal !== undefined) {
							_this.takerExternal = _this.book.takerExternal;
							_this.takerType = 2;
						} else {
							_this.takerInternal = _this.book.taker;
							_this.takerType = 1;
						}
					}
					_this.dataReady = true;
				}
			}).catch(this.$http.toastCatcher);
		},
		onBorrowBook: function onBorrowBook() {
			var _this2 = this;

			this.book.borrowPeriod = this.borrowPeriod;
			this.$http.post('backend://book/' + this.book.id + '/request', this.book).then(function (response) {
				if (response.body.ok) {
					_this2.$toasted.show('Заявката е изпратена успешно!').goAway(3000);
					_this2.book.status = 'requested';
				}
			}).catch(this.$http.toastCatcher);
		},
		onChangeStatus: function onChangeStatus() {
			var _this3 = this;

			var payload = {
				status: this.bookStatus
			};
			if (this.bookStatus === 'taken') {
				if (this.takerType === 1) {
					if (this.takerInternal === undefined || this.takerInternal.id === 0) {
						alert('Моля, въведете семейството, което ще заеме книгата!');
						return;
					} else {
						payload.takerInternal = this.takerInternal.id;
					}
				} else {
					if (this.takerExternal === '') {
						alert('Моля, въведете семейството, което ще заеме книгата!');
						return;
					} else {
						payload.takerExternal = this.takerExternal;
					}
				}
				payload.borrowPeriod = this.borrowPeriod;
			}
			this.$http.put('backend://book/' + this.book.id + '/status', payload).then(function (response) {
				_this3.$toasted.show('Заявката е изпратена успешно!').goAway(3000);
				_this3.fetchData();
			}).catch(this.$http.toastCatcher);
		},
		onApproveRequest: function onApproveRequest(status) {
			var _this4 = this;

			if (!confirm('Сигурни ли сте че искате да дадете тази книга?')) {
				return;
			}

			this.$http.post('backend://book/' + this.book.id + '/request/accept').then(function (response) {
				_this4.$toasted.show('Заявката е изпратена успешно!').goAway(3000);
				_this4.book.status = 'taken';
			}).catch(this.$http.toastCatcher);
		},
		onRejectRequest: function onRejectRequest() {
			var _this5 = this;

			if (!confirm('Сигурни ли сте че не одобрявате даването на тази книга?')) {
				return;
			}
			var comment = prompt('Моля, дайте причина за вашето неодобрение:');

			this.$http.post('backend://book/' + this.book.id + '/request/reject', { statusComment: comment }).then(function (response) {
				_this5.$toasted.show('Заявката е изпратена успешно!').goAway(3000);
				_this5.book.status = 'available';
			}).catch(this.$http.toastCatcher);
		}
	}
};

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(104);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
	data: function data() {
		return {
			dataReady: false,
			records: {},
			search: '',
			filter: {
				categories: '',
				status: '',
				family: undefined
			},
			page: 1
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			var query = [];
			var filter = (0, _assign2.default)({}, this.filter, {
				family: this.filter.family && this.filter.family.id
			});
			for (var key in filter) {
				if (this.filter[key]) {
					query.push(encodeURIComponent(key) + '=' + encodeURIComponent(filter[key]));
				}
			}

			if (this.search) {
				query.push('search=' + encodeURIComponent(this.search));
			}

			query.push('page=' + this.page);
			query.push('limit=' + this.$config.rpp);
			this.$http.get('backend://book?' + query.join('&')).then(function (result) {
				_this.records = result.body;
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		remove: function remove(id) {
			var _this2 = this;

			if (!confirm('Сигурни ли сте че искате да изтриете този ресурс?')) {
				return;
			}
			this.$http.delete('backend://book/' + id).then(function (result) {
				_this2.fetchData();
			}).catch(this.$http.toastCatcher);
		},
		canEdit: function canEdit(resource) {
			return resource.family.id + '' === this.$user.familyUser.family.id + '';
		},
		pageClick: function pageClick(page) {
			this.page = page;
			this.fetchData();
		}
	}
};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	props: ['resource'],
	data: function data() {
		return {
			dataReady: true,
			link: {}
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			if (!this.$route.params.id) {
				this.link = {
					title: '',
					description: '',
					categories: '',
					language: 'BG',
					link: ''
				};
				this.dataReady = true;
			} else {
				this.$http.get('backend://' + this.resource + '/' + this.$route.params.id).then(function (result) {
					_this.link = result.body;
					_this.dataReady = true;
				}).catch(this.$http.toastCatcher);
			}
		},
		onSubmit: function onSubmit() {
			var _this2 = this;

			this.$validator.validateAll().then(function (result) {
				if (!result) {
					_this2.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				_this2.$http.putOrPostResource('backend://' + _this2.resource + '/', _this2.link).then(function (response) {
					_this2.$router.push('/' + _this2.resource + '/' + response.body.id);
				}).catch(_this2.$http.toastCatcher);
			});
		}
	}
};

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			dataReady: false,
			link: {}
		};
	},
	created: function created() {
		this.fetchData();
	},
	computed: {
		canEdit: function canEdit() {
			if (!this.link.families) return false;
			for (var i = 0; i < this.link.families.length; i++) {
				if (this.link.families[i].id + '' === this.$user.familyUser.family.id + '') {
					return true;
				}
			}
			return false;
		}
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			this.$http.get('backend://link/' + this.$route.params.id).then(function (result) {
				_this.link = result.body;
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		}
	}
};

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			dataReady: false,
			records: [],
			search: '',
			filter: {
				categories: ''
			},
			page: 1
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			var query = [];
			for (var key in this.filter) {
				if (this.filter[key]) {
					query.push(encodeURIComponent(key) + '=' + encodeURIComponent(this.filter[key]));
				}
			}
			if (this.search) {
				query.push('search=' + encodeURIComponent(this.search));
			}
			query.push('page=' + this.page);
			query.push('limit=' + this.$config.rpp);
			this.$http.get('backend://link?' + query.join('&')).then(function (result) {
				_this.records = result.body;
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		remove: function remove(id) {
			var _this2 = this;

			if (!confirm('Сигурни ли сте че искате да изтриете този ресурс?')) {
				return;
			}
			this.$http.delete('backend://link/' + id).then(function (result) {
				_this2.fetchData();
			}).catch(this.$http.toastCatcher);
		},
		canEdit: function canEdit(resource) {
			for (var i = 0; i < resource.families.length; i++) {
				if (resource.families[i].id + '' === this.$user.familyUser.family.id + '') {
					return true;
				}
			}
			return false;
		},
		pageClick: function pageClick(page) {
			this.page = page;
			this.fetchData();
		}
	}
};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			dataReady: false,
			material: {}
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	computed: {
		canEdit: function canEdit() {
			if (!this.material.families) return false;
			for (var i = 0; i < this.material.families.length; i++) {
				if (this.material.families[i].id + '' === this.$user.familyUser.family.id + '') {
					return true;
				}
			}
			return false;
		}
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			this.$http.get('backend://material/' + this.$route.params.id).then(function (result) {
				if (!result.body.error) {
					_this.material = result.body;
					_this.dataReady = true;
				}
			}).catch(this.$http.toastCatcher);
		}
	}
};

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	data: function data() {
		return {
			dataReady: false,
			records: [],
			search: '',
			filter: {
				categories: ''
			},
			page: 1
		};
	},
	created: function created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			var query = [];
			for (var key in this.filter) {
				if (this.filter[key]) {
					query.push(encodeURIComponent(key) + '=' + encodeURIComponent(this.filter[key]));
				}
			}
			if (this.search) {
				query.push('search=' + encodeURIComponent(this.search));
			}
			query.push('page=' + this.page);
			query.push('limit=' + this.$config.rpp);
			this.$http.get('backend://material?' + query.join('&')).then(function (result) {
				_this.records = result.body;
				_this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		remove: function remove(id) {
			var _this2 = this;

			if (!confirm('Сигурни ли сте че искате да изтриете този ресурс?')) {
				return;
			}
			this.$http.delete('backend://material/' + id).then(function (response) {
				_this2.fetchData();
			}).catch(this.$http.toastCatcher);
		},
		canEdit: function canEdit(material) {
			for (var i = 0; i < material.families.length; i++) {
				if (material.families[i].id + '' === this.$user.familyUser.family.id + '') {
					return true;
				}
			}
			return false;
		},
		pageClick: function pageClick(page) {
			this.page = page;
			this.fetchData();
		}
	}
};

/***/ }),
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */
/***/ (function(module, exports) {

module.exports = {"100":"💯","1234":"🔢","grinning":"😀","smiley":"😃","smile":"😄","grin":"😁","laughing":"😆","satisfied":"😆","sweat_smile":"😅","joy":"😂","rofl":"🤣","relaxed":"☺️","blush":"😊","innocent":"😇","slightly_smiling_face":"🙂","upside_down_face":"🙃","wink":"😉","relieved":"😌","heart_eyes":"😍","kissing_heart":"😘","kissing":"😗","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","yum":"😋","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","money_mouth_face":"🤑","hugs":"🤗","nerd_face":"🤓","sunglasses":"😎","clown_face":"🤡","cowboy_hat_face":"🤠","smirk":"😏","unamused":"😒","disappointed":"😞","pensive":"😔","worried":"😟","confused":"😕","slightly_frowning_face":"🙁","frowning_face":"☹️","persevere":"😣","confounded":"😖","tired_face":"😫","weary":"😩","triumph":"😤","angry":"😠","rage":"😡","pout":"😡","no_mouth":"😶","neutral_face":"😐","expressionless":"😑","hushed":"😯","frowning":"😦","anguished":"😧","open_mouth":"😮","astonished":"😲","dizzy_face":"😵","flushed":"😳","scream":"😱","fearful":"😨","cold_sweat":"😰","cry":"😢","disappointed_relieved":"😥","drooling_face":"🤤","sob":"😭","sweat":"😓","sleepy":"😪","sleeping":"😴","roll_eyes":"🙄","thinking":"🤔","lying_face":"🤥","grimacing":"😬","zipper_mouth_face":"🤐","nauseated_face":"🤢","sneezing_face":"🤧","mask":"😷","face_with_thermometer":"🤒","face_with_head_bandage":"🤕","smiling_imp":"😈","imp":"👿","japanese_ogre":"👹","japanese_goblin":"👺","hankey":"💩","poop":"💩","shit":"💩","ghost":"👻","skull":"💀","skull_and_crossbones":"☠️","alien":"👽","space_invader":"👾","robot":"🤖","jack_o_lantern":"🎃","smiley_cat":"😺","smile_cat":"😸","joy_cat":"😹","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","scream_cat":"🙀","crying_cat_face":"😿","pouting_cat":"😾","open_hands":"👐","raised_hands":"🙌","clap":"👏","pray":"🙏","handshake":"🤝","+1":"👍","thumbsup":"👍","-1":"👎","thumbsdown":"👎","fist_oncoming":"👊","facepunch":"👊","punch":"👊","fist_raised":"✊","fist":"✊","fist_left":"🤛","fist_right":"🤜","crossed_fingers":"🤞","v":"✌️","metal":"🤘","ok_hand":"👌","point_left":"👈","point_right":"👉","point_up_2":"👆","point_down":"👇","point_up":"☝️","hand":"✋","raised_hand":"✋","raised_back_of_hand":"🤚","raised_hand_with_fingers_splayed":"🖐","vulcan_salute":"🖖","wave":"👋","call_me_hand":"🤙","muscle":"💪","middle_finger":"🖕","fu":"🖕","writing_hand":"✍️","selfie":"🤳","nail_care":"💅","ring":"💍","lipstick":"💄","kiss":"💋","lips":"👄","tongue":"👅","ear":"👂","nose":"👃","footprints":"👣","eye":"👁","eyes":"👀","speaking_head":"🗣","bust_in_silhouette":"👤","busts_in_silhouette":"👥","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","blonde_woman":"👱‍♀","blonde_man":"👱","person_with_blond_hair":"👱","older_man":"👴","older_woman":"👵","man_with_gua_pi_mao":"👲","woman_with_turban":"👳‍♀","man_with_turban":"👳","policewoman":"👮‍♀","policeman":"👮","cop":"👮","construction_worker_woman":"👷‍♀","construction_worker_man":"👷","construction_worker":"👷","guardswoman":"💂‍♀","guardsman":"💂","female_detective":"🕵️‍♀️","male_detective":"🕵","detective":"🕵","woman_health_worker":"👩‍⚕","man_health_worker":"👨‍⚕","woman_farmer":"👩‍🌾","man_farmer":"👨‍🌾","woman_cook":"👩‍🍳","man_cook":"👨‍🍳","woman_student":"👩‍🎓","man_student":"👨‍🎓","woman_singer":"👩‍🎤","man_singer":"👨‍🎤","woman_teacher":"👩‍🏫","man_teacher":"👨‍🏫","woman_factory_worker":"👩‍🏭","man_factory_worker":"👨‍🏭","woman_technologist":"👩‍💻","man_technologist":"👨‍💻","woman_office_worker":"👩‍💼","man_office_worker":"👨‍💼","woman_mechanic":"👩‍🔧","man_mechanic":"👨‍🔧","woman_scientist":"👩‍🔬","man_scientist":"👨‍🔬","woman_artist":"👩‍🎨","man_artist":"👨‍🎨","woman_firefighter":"👩‍🚒","man_firefighter":"👨‍🚒","woman_pilot":"👩‍✈","man_pilot":"👨‍✈","woman_astronaut":"👩‍🚀","man_astronaut":"👨‍🚀","woman_judge":"👩‍⚖","man_judge":"👨‍⚖","mrs_claus":"🤶","santa":"🎅","princess":"👸","prince":"🤴","bride_with_veil":"👰","man_in_tuxedo":"🤵","angel":"👼","pregnant_woman":"🤰","bowing_woman":"🙇‍♀","bowing_man":"🙇","bow":"🙇","tipping_hand_woman":"💁","information_desk_person":"💁","sassy_woman":"💁","tipping_hand_man":"💁‍♂","sassy_man":"💁‍♂","no_good_woman":"🙅","no_good":"🙅","ng_woman":"🙅","no_good_man":"🙅‍♂","ng_man":"🙅‍♂","ok_woman":"🙆","ok_man":"🙆‍♂","raising_hand_woman":"🙋","raising_hand":"🙋","raising_hand_man":"🙋‍♂","woman_facepalming":"🤦‍♀","man_facepalming":"🤦‍♂","woman_shrugging":"🤷‍♀","man_shrugging":"🤷‍♂","pouting_woman":"🙎","person_with_pouting_face":"🙎","pouting_man":"🙎‍♂","frowning_woman":"🙍","person_frowning":"🙍","frowning_man":"🙍‍♂","haircut_woman":"💇","haircut":"💇","haircut_man":"💇‍♂","massage_woman":"💆","massage":"💆","massage_man":"💆‍♂","business_suit_levitating":"🕴","dancer":"💃","man_dancing":"🕺","dancing_women":"👯","dancers":"👯","dancing_men":"👯‍♂","walking_woman":"🚶‍♀","walking_man":"🚶","walking":"🚶","running_woman":"🏃‍♀","running_man":"🏃","runner":"🏃","running":"🏃","couple":"👫","two_women_holding_hands":"👭","two_men_holding_hands":"👬","couple_with_heart_woman_man":"💑","couple_with_heart":"💑","couple_with_heart_woman_woman":"👩‍❤️‍👩","couple_with_heart_man_man":"👨‍❤️‍👨","couplekiss_man_woman":"💏","couplekiss_woman_woman":"👩‍❤️‍💋‍👩","couplekiss_man_man":"👨‍❤️‍💋‍👨","family_man_woman_boy":"👪","family":"👪","family_man_woman_girl":"👨‍👩‍👧","family_man_woman_girl_boy":"👨‍👩‍👧‍👦","family_man_woman_boy_boy":"👨‍👩‍👦‍👦","family_man_woman_girl_girl":"👨‍👩‍👧‍👧","family_woman_woman_boy":"👩‍👩‍👦","family_woman_woman_girl":"👩‍👩‍👧","family_woman_woman_girl_boy":"👩‍👩‍👧‍👦","family_woman_woman_boy_boy":"👩‍👩‍👦‍👦","family_woman_woman_girl_girl":"👩‍👩‍👧‍👧","family_man_man_boy":"👨‍👨‍👦","family_man_man_girl":"👨‍👨‍👧","family_man_man_girl_boy":"👨‍👨‍👧‍👦","family_man_man_boy_boy":"👨‍👨‍👦‍👦","family_man_man_girl_girl":"👨‍👨‍👧‍👧","family_woman_boy":"👩‍👦","family_woman_girl":"👩‍👧","family_woman_girl_boy":"👩‍👧‍👦","family_woman_boy_boy":"👩‍👦‍👦","family_woman_girl_girl":"👩‍👧‍👧","family_man_boy":"👨‍👦","family_man_girl":"👨‍👧","family_man_girl_boy":"👨‍👧‍👦","family_man_boy_boy":"👨‍👦‍👦","family_man_girl_girl":"👨‍👧‍👧","womans_clothes":"👚","shirt":"👕","tshirt":"👕","jeans":"👖","necktie":"👔","dress":"👗","bikini":"👙","kimono":"👘","high_heel":"👠","sandal":"👡","boot":"👢","mans_shoe":"👞","shoe":"👞","athletic_shoe":"👟","womans_hat":"👒","tophat":"🎩","mortar_board":"🎓","crown":"👑","rescue_worker_helmet":"⛑","school_satchel":"🎒","pouch":"👝","purse":"👛","handbag":"👜","briefcase":"💼","eyeglasses":"👓","dark_sunglasses":"🕶","closed_umbrella":"🌂","open_umbrella":"☂️","dog":"🐶","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","fox_face":"🦊","bear":"🐻","panda_face":"🐼","koala":"🐨","tiger":"🐯","lion":"🦁","cow":"🐮","pig":"🐷","pig_nose":"🐽","frog":"🐸","monkey_face":"🐵","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","monkey":"🐒","chicken":"🐔","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatching_chick":"🐣","hatched_chick":"🐥","duck":"🦆","eagle":"🦅","owl":"🦉","bat":"🦇","wolf":"🐺","boar":"🐗","horse":"🐴","unicorn":"🦄","bee":"🐝","honeybee":"🐝","bug":"🐛","butterfly":"🦋","snail":"🐌","shell":"🐚","beetle":"🐞","ant":"🐜","spider":"🕷","spider_web":"🕸","turtle":"🐢","snake":"🐍","lizard":"🦎","scorpion":"🦂","crab":"🦀","squid":"🦑","octopus":"🐙","shrimp":"🦐","tropical_fish":"🐠","fish":"🐟","blowfish":"🐡","dolphin":"🐬","flipper":"🐬","shark":"🦈","whale":"🐳","whale2":"🐋","crocodile":"🐊","leopard":"🐆","tiger2":"🐅","water_buffalo":"🐃","ox":"🐂","cow2":"🐄","deer":"🦌","dromedary_camel":"🐪","camel":"🐫","elephant":"🐘","rhinoceros":"🦏","gorilla":"🦍","racehorse":"🐎","pig2":"🐖","goat":"🐐","ram":"🐏","sheep":"🐑","dog2":"🐕","poodle":"🐩","cat2":"🐈","rooster":"🐓","turkey":"🦃","dove":"🕊","rabbit2":"🐇","mouse2":"🐁","rat":"🐀","chipmunk":"🐿","feet":"🐾","paw_prints":"🐾","dragon":"🐉","dragon_face":"🐲","cactus":"🌵","christmas_tree":"🎄","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","seedling":"🌱","herb":"🌿","shamrock":"☘️","four_leaf_clover":"🍀","bamboo":"🎍","tanabata_tree":"🎋","leaves":"🍃","fallen_leaf":"🍂","maple_leaf":"🍁","mushroom":"🍄","ear_of_rice":"🌾","bouquet":"💐","tulip":"🌷","rose":"🌹","wilted_flower":"🥀","sunflower":"🌻","blossom":"🌼","cherry_blossom":"🌸","hibiscus":"🌺","earth_americas":"🌎","earth_africa":"🌍","earth_asia":"🌏","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","moon":"🌔","waxing_gibbous_moon":"🌔","new_moon_with_face":"🌚","full_moon_with_face":"🌝","sun_with_face":"🌞","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","crescent_moon":"🌙","dizzy":"💫","star":"⭐️","star2":"🌟","sparkles":"✨","zap":"⚡️","fire":"🔥","boom":"💥","collision":"💥","comet":"☄","sunny":"☀️","sun_behind_small_cloud":"🌤","partly_sunny":"⛅️","sun_behind_large_cloud":"🌥","sun_behind_rain_cloud":"🌦","rainbow":"🌈","cloud":"☁️","cloud_with_rain":"🌧","cloud_with_lightning_and_rain":"⛈","cloud_with_lightning":"🌩","cloud_with_snow":"🌨","snowman_with_snow":"☃️","snowman":"⛄️","snowflake":"❄️","wind_face":"🌬","dash":"💨","tornado":"🌪","fog":"🌫","ocean":"🌊","droplet":"💧","sweat_drops":"💦","umbrella":"☔️","green_apple":"🍏","apple":"🍎","pear":"🍐","tangerine":"🍊","orange":"🍊","mandarin":"🍊","lemon":"🍋","banana":"🍌","watermelon":"🍉","grapes":"🍇","strawberry":"🍓","melon":"🍈","cherries":"🍒","peach":"🍑","pineapple":"🍍","kiwi_fruit":"🥝","avocado":"🥑","tomato":"🍅","eggplant":"🍆","cucumber":"🥒","carrot":"🥕","corn":"🌽","hot_pepper":"🌶","potato":"🥔","sweet_potato":"🍠","chestnut":"🌰","peanuts":"🥜","honey_pot":"🍯","croissant":"🥐","bread":"🍞","baguette_bread":"🥖","cheese":"🧀","egg":"🥚","fried_egg":"🍳","bacon":"🥓","pancakes":"🥞","fried_shrimp":"🍤","poultry_leg":"🍗","meat_on_bone":"🍖","pizza":"🍕","hotdog":"🌭","hamburger":"🍔","fries":"🍟","stuffed_flatbread":"🥙","taco":"🌮","burrito":"🌯","green_salad":"🥗","shallow_pan_of_food":"🥘","spaghetti":"🍝","ramen":"🍜","stew":"🍲","fish_cake":"🍥","sushi":"🍣","bento":"🍱","curry":"🍛","rice":"🍚","rice_ball":"🍙","rice_cracker":"🍘","oden":"🍢","dango":"🍡","shaved_ice":"🍧","ice_cream":"🍨","icecream":"🍦","cake":"🍰","birthday":"🎂","custard":"🍮","lollipop":"🍭","candy":"🍬","chocolate_bar":"🍫","popcorn":"🍿","doughnut":"🍩","cookie":"🍪","milk_glass":"🥛","baby_bottle":"🍼","coffee":"☕️","tea":"🍵","sake":"🍶","beer":"🍺","beers":"🍻","clinking_glasses":"🥂","wine_glass":"🍷","tumbler_glass":"🥃","cocktail":"🍸","tropical_drink":"🍹","champagne":"🍾","spoon":"🥄","fork_and_knife":"🍴","plate_with_cutlery":"🍽","soccer":"⚽️","basketball":"🏀","football":"🏈","baseball":"⚾️","tennis":"🎾","volleyball":"🏐","rugby_football":"🏉","8ball":"🎱","ping_pong":"🏓","badminton":"🏸","goal_net":"🥅","ice_hockey":"🏒","field_hockey":"🏑","cricket":"🏏","golf":"⛳️","bow_and_arrow":"🏹","fishing_pole_and_fish":"🎣","boxing_glove":"🥊","martial_arts_uniform":"🥋","ice_skate":"⛸","ski":"🎿","skier":"⛷","snowboarder":"🏂","weight_lifting_woman":"🏋️‍♀️","weight_lifting_man":"🏋","person_fencing":"🤺","women_wrestling":"🤼‍♀","men_wrestling":"🤼‍♂","woman_cartwheeling":"🤸‍♀","man_cartwheeling":"🤸‍♂","basketball_woman":"⛹️‍♀️","basketball_man":"⛹","woman_playing_handball":"🤾‍♀","man_playing_handball":"🤾‍♂","golfing_woman":"🏌️‍♀️","golfing_man":"🏌","surfing_woman":"🏄‍♀","surfing_man":"🏄","surfer":"🏄","swimming_woman":"🏊‍♀","swimming_man":"🏊","swimmer":"🏊","woman_playing_water_polo":"🤽‍♀","man_playing_water_polo":"🤽‍♂","rowing_woman":"🚣‍♀","rowing_man":"🚣","rowboat":"🚣","horse_racing":"🏇","biking_woman":"🚴‍♀","biking_man":"🚴","bicyclist":"🚴","mountain_biking_woman":"🚵‍♀","mountain_biking_man":"🚵","mountain_bicyclist":"🚵","running_shirt_with_sash":"🎽","medal_sports":"🏅","medal_military":"🎖","1st_place_medal":"🥇","2nd_place_medal":"🥈","3rd_place_medal":"🥉","trophy":"🏆","rosette":"🏵","reminder_ribbon":"🎗","ticket":"🎫","tickets":"🎟","circus_tent":"🎪","woman_juggling":"🤹‍♀","man_juggling":"🤹‍♂","performing_arts":"🎭","art":"🎨","clapper":"🎬","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_keyboard":"🎹","drum":"🥁","saxophone":"🎷","trumpet":"🎺","guitar":"🎸","violin":"🎻","game_die":"🎲","dart":"🎯","bowling":"🎳","video_game":"🎮","slot_machine":"🎰","car":"🚗","red_car":"🚗","taxi":"🚕","blue_car":"🚙","bus":"🚌","trolleybus":"🚎","racing_car":"🏎","police_car":"🚓","ambulance":"🚑","fire_engine":"🚒","minibus":"🚐","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","kick_scooter":"🛴","bike":"🚲","motor_scooter":"🛵","motorcycle":"🏍","rotating_light":"🚨","oncoming_police_car":"🚔","oncoming_bus":"🚍","oncoming_automobile":"🚘","oncoming_taxi":"🚖","aerial_tramway":"🚡","mountain_cableway":"🚠","suspension_railway":"🚟","railway_car":"🚃","train":"🚋","mountain_railway":"🚞","monorail":"🚝","bullettrain_side":"🚄","bullettrain_front":"🚅","light_rail":"🚈","steam_locomotive":"🚂","train2":"🚆","metro":"🚇","tram":"🚊","station":"🚉","helicopter":"🚁","small_airplane":"🛩","airplane":"✈️","flight_departure":"🛫","flight_arrival":"🛬","rocket":"🚀","artificial_satellite":"🛰","seat":"💺","canoe":"🛶","boat":"⛵️","sailboat":"⛵️","motor_boat":"🛥","speedboat":"🚤","passenger_ship":"🛳","ferry":"⛴","ship":"🚢","anchor":"⚓️","construction":"🚧","fuelpump":"⛽️","busstop":"🚏","vertical_traffic_light":"🚦","traffic_light":"🚥","world_map":"🗺","moyai":"🗿","statue_of_liberty":"🗽","fountain":"⛲️","tokyo_tower":"🗼","european_castle":"🏰","japanese_castle":"🏯","stadium":"🏟","ferris_wheel":"🎡","roller_coaster":"🎢","carousel_horse":"🎠","parasol_on_ground":"⛱","beach_umbrella":"🏖","desert_island":"🏝","mountain":"⛰","mountain_snow":"🏔","mount_fuji":"🗻","volcano":"🌋","desert":"🏜","camping":"🏕","tent":"⛺️","railway_track":"🛤","motorway":"🛣","building_construction":"🏗","factory":"🏭","house":"🏠","house_with_garden":"🏡","houses":"🏘","derelict_house":"🏚","office":"🏢","department_store":"🏬","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","hotel":"🏨","convenience_store":"🏪","school":"🏫","love_hotel":"🏩","wedding":"💒","classical_building":"🏛","church":"⛪️","mosque":"🕌","synagogue":"🕍","kaaba":"🕋","shinto_shrine":"⛩","japan":"🗾","rice_scene":"🎑","national_park":"🏞","sunrise":"🌅","sunrise_over_mountains":"🌄","stars":"🌠","sparkler":"🎇","fireworks":"🎆","city_sunrise":"🌇","city_sunset":"🌆","cityscape":"🏙","night_with_stars":"🌃","milky_way":"🌌","bridge_at_night":"🌉","foggy":"🌁","watch":"⌚️","iphone":"📱","calling":"📲","computer":"💻","keyboard":"⌨️","desktop_computer":"🖥","printer":"🖨","computer_mouse":"🖱","trackball":"🖲","joystick":"🕹","clamp":"🗜","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","vhs":"📼","camera":"📷","camera_flash":"📸","video_camera":"📹","movie_camera":"🎥","film_projector":"📽","film_strip":"🎞","telephone_receiver":"📞","phone":"☎️","telephone":"☎️","pager":"📟","fax":"📠","tv":"📺","radio":"📻","studio_microphone":"🎙","level_slider":"🎚","control_knobs":"🎛","stopwatch":"⏱","timer_clock":"⏲","alarm_clock":"⏰","mantelpiece_clock":"🕰","hourglass":"⌛️","hourglass_flowing_sand":"⏳","satellite":"📡","battery":"🔋","electric_plug":"🔌","bulb":"💡","flashlight":"🔦","candle":"🕯","wastebasket":"🗑","oil_drum":"🛢","money_with_wings":"💸","dollar":"💵","yen":"💴","euro":"💶","pound":"💷","moneybag":"💰","credit_card":"💳","gem":"💎","balance_scale":"⚖️","wrench":"🔧","hammer":"🔨","hammer_and_pick":"⚒","hammer_and_wrench":"🛠","pick":"⛏","nut_and_bolt":"🔩","gear":"⚙️","chains":"⛓","gun":"🔫","bomb":"💣","hocho":"🔪","knife":"🔪","dagger":"🗡","crossed_swords":"⚔️","shield":"🛡","smoking":"🚬","coffin":"⚰️","funeral_urn":"⚱️","amphora":"🏺","crystal_ball":"🔮","prayer_beads":"📿","barber":"💈","alembic":"⚗️","telescope":"🔭","microscope":"🔬","hole":"🕳","pill":"💊","syringe":"💉","thermometer":"🌡","toilet":"🚽","potable_water":"🚰","shower":"🚿","bathtub":"🛁","bath":"🛀","bellhop_bell":"🛎","key":"🔑","old_key":"🗝","door":"🚪","couch_and_lamp":"🛋","bed":"🛏","sleeping_bed":"🛌","framed_picture":"🖼","shopping":"🛍","shopping_cart":"🛒","gift":"🎁","balloon":"🎈","flags":"🎏","ribbon":"🎀","confetti_ball":"🎊","tada":"🎉","dolls":"🎎","izakaya_lantern":"🏮","lantern":"🏮","wind_chime":"🎐","email":"✉️","envelope":"✉️","envelope_with_arrow":"📩","incoming_envelope":"📨","e-mail":"📧","love_letter":"💌","inbox_tray":"📥","outbox_tray":"📤","package":"📦","label":"🏷","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","postbox":"📮","postal_horn":"📯","scroll":"📜","page_with_curl":"📃","page_facing_up":"📄","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","spiral_notepad":"🗒","spiral_calendar":"🗓","calendar":"📆","date":"📅","card_index":"📇","card_file_box":"🗃","ballot_box":"🗳","file_cabinet":"🗄","clipboard":"📋","file_folder":"📁","open_file_folder":"📂","card_index_dividers":"🗂","newspaper_roll":"🗞","newspaper":"📰","notebook":"📓","notebook_with_decorative_cover":"📔","ledger":"📒","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","books":"📚","book":"📖","open_book":"📖","bookmark":"🔖","link":"🔗","paperclip":"📎","paperclips":"🖇","triangular_ruler":"📐","straight_ruler":"📏","pushpin":"📌","round_pushpin":"📍","scissors":"✂️","pen":"🖊","fountain_pen":"🖋","black_nib":"✒️","paintbrush":"🖌","crayon":"🖍","memo":"📝","pencil":"📝","pencil2":"✏️","mag":"🔍","mag_right":"🔎","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","lock":"🔒","unlock":"🔓","heart":"❤️","yellow_heart":"💛","green_heart":"💚","blue_heart":"💙","purple_heart":"💜","black_heart":"🖤","broken_heart":"💔","heavy_heart_exclamation":"❣️","two_hearts":"💕","revolving_hearts":"💞","heartbeat":"💓","heartpulse":"💗","sparkling_heart":"💖","cupid":"💘","gift_heart":"💝","heart_decoration":"💟","peace_symbol":"☮️","latin_cross":"✝️","star_and_crescent":"☪️","om":"🕉","wheel_of_dharma":"☸️","star_of_david":"✡️","six_pointed_star":"🔯","menorah":"🕎","yin_yang":"☯️","orthodox_cross":"☦️","place_of_worship":"🛐","ophiuchus":"⛎","aries":"♈️","taurus":"♉️","gemini":"♊️","cancer":"♋️","leo":"♌️","virgo":"♍️","libra":"♎️","scorpius":"♏️","sagittarius":"♐️","capricorn":"♑️","aquarius":"♒️","pisces":"♓️","id":"🆔","atom_symbol":"⚛️","accept":"🉑","radioactive":"☢️","biohazard":"☣️","mobile_phone_off":"📴","vibration_mode":"📳","eight_pointed_black_star":"✴️","vs":"🆚","white_flower":"💮","ideograph_advantage":"🉐","secret":"㊙️","congratulations":"㊗️","u6e80":"🈵","a":"🅰️","b":"🅱️","ab":"🆎","cl":"🆑","o2":"🅾️","sos":"🆘","x":"❌","o":"⭕️","stop_sign":"🛑","no_entry":"⛔️","name_badge":"📛","no_entry_sign":"🚫","anger":"💢","hotsprings":"♨️","no_pedestrians":"🚷","do_not_litter":"🚯","no_bicycles":"🚳","non-potable_water":"🚱","underage":"🔞","no_mobile_phones":"📵","no_smoking":"🚭","exclamation":"❗️","heavy_exclamation_mark":"❗️","grey_exclamation":"❕","question":"❓","grey_question":"❔","bangbang":"‼️","interrobang":"⁉️","low_brightness":"🔅","high_brightness":"🔆","part_alternation_mark":"〽️","warning":"⚠️","children_crossing":"🚸","trident":"🔱","fleur_de_lis":"⚜️","beginner":"🔰","recycle":"♻️","white_check_mark":"✅","chart":"💹","sparkle":"❇️","eight_spoked_asterisk":"✳️","negative_squared_cross_mark":"❎","globe_with_meridians":"🌐","diamond_shape_with_a_dot_inside":"💠","m":"Ⓜ️","cyclone":"🌀","zzz":"💤","atm":"🏧","wc":"🚾","wheelchair":"♿️","parking":"🅿️","sa":"🈂️","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","mens":"🚹","womens":"🚺","baby_symbol":"🚼","restroom":"🚻","put_litter_in_its_place":"🚮","cinema":"🎦","signal_strength":"📶","koko":"🈁","symbols":"🔣","information_source":"ℹ️","abc":"🔤","abcd":"🔡","capital_abcd":"🔠","ng":"🆖","ok":"🆗","up":"🆙","cool":"🆒","new":"🆕","free":"🆓","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","keycap_ten":"🔟","hash":"#️⃣","asterisk":"*️⃣","arrow_forward":"▶️","pause_button":"⏸","play_or_pause_button":"⏯","stop_button":"⏹","record_button":"⏺","next_track_button":"⏭","previous_track_button":"⏮","fast_forward":"⏩","rewind":"⏪","arrow_double_up":"⏫","arrow_double_down":"⏬","arrow_backward":"◀️","arrow_up_small":"🔼","arrow_down_small":"🔽","arrow_right":"➡️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","arrow_upper_left":"↖️","arrow_up_down":"↕️","left_right_arrow":"↔️","arrow_right_hook":"↪️","leftwards_arrow_with_hook":"↩️","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrows_counterclockwise":"🔄","arrows_clockwise":"🔃","musical_note":"🎵","notes":"🎶","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","heavy_multiplication_x":"✖️","heavy_dollar_sign":"💲","currency_exchange":"💱","tm":"™️","copyright":"©️","registered":"®️","wavy_dash":"〰️","curly_loop":"➰","loop":"➿","end":"🔚","back":"🔙","on":"🔛","top":"🔝","soon":"🔜","heavy_check_mark":"✔️","ballot_box_with_check":"☑️","radio_button":"🔘","white_circle":"⚪️","black_circle":"⚫️","red_circle":"🔴","large_blue_circle":"🔵","small_red_triangle":"🔺","small_red_triangle_down":"🔻","small_orange_diamond":"🔸","small_blue_diamond":"🔹","large_orange_diamond":"🔶","large_blue_diamond":"🔷","white_square_button":"🔳","black_square_button":"🔲","black_small_square":"▪️","white_small_square":"▫️","black_medium_small_square":"◾️","white_medium_small_square":"◽️","black_medium_square":"◼️","white_medium_square":"◻️","black_large_square":"⬛️","white_large_square":"⬜️","speaker":"🔈","mute":"🔇","sound":"🔉","loud_sound":"🔊","bell":"🔔","no_bell":"🔕","mega":"📣","loudspeaker":"📢","eye_speech_bubble":"👁‍🗨","speech_balloon":"💬","thought_balloon":"💭","right_anger_bubble":"🗯","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","black_joker":"🃏","flower_playing_cards":"🎴","mahjong":"🀄️","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","white_flag":"🏳️","black_flag":"🏴","checkered_flag":"🏁","triangular_flag_on_post":"🚩","rainbow_flag":"🏳️‍🌈","afghanistan":"🇦🇫","aland_islands":"🇦🇽","albania":"🇦🇱","algeria":"🇩🇿","american_samoa":"🇦🇸","andorra":"🇦🇩","angola":"🇦🇴","anguilla":"🇦🇮","antarctica":"🇦🇶","antigua_barbuda":"🇦🇬","argentina":"🇦🇷","armenia":"🇦🇲","aruba":"🇦🇼","australia":"🇦🇺","austria":"🇦🇹","azerbaijan":"🇦🇿","bahamas":"🇧🇸","bahrain":"🇧🇭","bangladesh":"🇧🇩","barbados":"🇧🇧","belarus":"🇧🇾","belgium":"🇧🇪","belize":"🇧🇿","benin":"🇧🇯","bermuda":"🇧🇲","bhutan":"🇧🇹","bolivia":"🇧🇴","caribbean_netherlands":"🇧🇶","bosnia_herzegovina":"🇧🇦","botswana":"🇧🇼","brazil":"🇧🇷","british_indian_ocean_territory":"🇮🇴","british_virgin_islands":"🇻🇬","brunei":"🇧🇳","bulgaria":"🇧🇬","burkina_faso":"🇧🇫","burundi":"🇧🇮","cape_verde":"🇨🇻","cambodia":"🇰🇭","cameroon":"🇨🇲","canada":"🇨🇦","canary_islands":"🇮🇨","cayman_islands":"🇰🇾","central_african_republic":"🇨🇫","chad":"🇹🇩","chile":"🇨🇱","cn":"🇨🇳","christmas_island":"🇨🇽","cocos_islands":"🇨🇨","colombia":"🇨🇴","comoros":"🇰🇲","congo_brazzaville":"🇨🇬","congo_kinshasa":"🇨🇩","cook_islands":"🇨🇰","costa_rica":"🇨🇷","cote_divoire":"🇨🇮","croatia":"🇭🇷","cuba":"🇨🇺","curacao":"🇨🇼","cyprus":"🇨🇾","czech_republic":"🇨🇿","denmark":"🇩🇰","djibouti":"🇩🇯","dominica":"🇩🇲","dominican_republic":"🇩🇴","ecuador":"🇪🇨","egypt":"🇪🇬","el_salvador":"🇸🇻","equatorial_guinea":"🇬🇶","eritrea":"🇪🇷","estonia":"🇪🇪","ethiopia":"🇪🇹","eu":"🇪🇺","european_union":"🇪🇺","falkland_islands":"🇫🇰","faroe_islands":"🇫🇴","fiji":"🇫🇯","finland":"🇫🇮","fr":"🇫🇷","french_guiana":"🇬🇫","french_polynesia":"🇵🇫","french_southern_territories":"🇹🇫","gabon":"🇬🇦","gambia":"🇬🇲","georgia":"🇬🇪","de":"🇩🇪","ghana":"🇬🇭","gibraltar":"🇬🇮","greece":"🇬🇷","greenland":"🇬🇱","grenada":"🇬🇩","guadeloupe":"🇬🇵","guam":"🇬🇺","guatemala":"🇬🇹","guernsey":"🇬🇬","guinea":"🇬🇳","guinea_bissau":"🇬🇼","guyana":"🇬🇾","haiti":"🇭🇹","honduras":"🇭🇳","hong_kong":"🇭🇰","hungary":"🇭🇺","iceland":"🇮🇸","india":"🇮🇳","indonesia":"🇮🇩","iran":"🇮🇷","iraq":"🇮🇶","ireland":"🇮🇪","isle_of_man":"🇮🇲","israel":"🇮🇱","it":"🇮🇹","jamaica":"🇯🇲","jp":"🇯🇵","crossed_flags":"🎌","jersey":"🇯🇪","jordan":"🇯🇴","kazakhstan":"🇰🇿","kenya":"🇰🇪","kiribati":"🇰🇮","kosovo":"🇽🇰","kuwait":"🇰🇼","kyrgyzstan":"🇰🇬","laos":"🇱🇦","latvia":"🇱🇻","lebanon":"🇱🇧","lesotho":"🇱🇸","liberia":"🇱🇷","libya":"🇱🇾","liechtenstein":"🇱🇮","lithuania":"🇱🇹","luxembourg":"🇱🇺","macau":"🇲🇴","macedonia":"🇲🇰","madagascar":"🇲🇬","malawi":"🇲🇼","malaysia":"🇲🇾","maldives":"🇲🇻","mali":"🇲🇱","malta":"🇲🇹","marshall_islands":"🇲🇭","martinique":"🇲🇶","mauritania":"🇲🇷","mauritius":"🇲🇺","mayotte":"🇾🇹","mexico":"🇲🇽","micronesia":"🇫🇲","moldova":"🇲🇩","monaco":"🇲🇨","mongolia":"🇲🇳","montenegro":"🇲🇪","montserrat":"🇲🇸","morocco":"🇲🇦","mozambique":"🇲🇿","myanmar":"🇲🇲","namibia":"🇳🇦","nauru":"🇳🇷","nepal":"🇳🇵","netherlands":"🇳🇱","new_caledonia":"🇳🇨","new_zealand":"🇳🇿","nicaragua":"🇳🇮","niger":"🇳🇪","nigeria":"🇳🇬","niue":"🇳🇺","norfolk_island":"🇳🇫","northern_mariana_islands":"🇲🇵","north_korea":"🇰🇵","norway":"🇳🇴","oman":"🇴🇲","pakistan":"🇵🇰","palau":"🇵🇼","palestinian_territories":"🇵🇸","panama":"🇵🇦","papua_new_guinea":"🇵🇬","paraguay":"🇵🇾","peru":"🇵🇪","philippines":"🇵🇭","pitcairn_islands":"🇵🇳","poland":"🇵🇱","portugal":"🇵🇹","puerto_rico":"🇵🇷","qatar":"🇶🇦","reunion":"🇷🇪","romania":"🇷🇴","ru":"🇷🇺","rwanda":"🇷🇼","st_barthelemy":"🇧🇱","st_helena":"🇸🇭","st_kitts_nevis":"🇰🇳","st_lucia":"🇱🇨","st_pierre_miquelon":"🇵🇲","st_vincent_grenadines":"🇻🇨","samoa":"🇼🇸","san_marino":"🇸🇲","sao_tome_principe":"🇸🇹","saudi_arabia":"🇸🇦","senegal":"🇸🇳","serbia":"🇷🇸","seychelles":"🇸🇨","sierra_leone":"🇸🇱","singapore":"🇸🇬","sint_maarten":"🇸🇽","slovakia":"🇸🇰","slovenia":"🇸🇮","solomon_islands":"🇸🇧","somalia":"🇸🇴","south_africa":"🇿🇦","south_georgia_south_sandwich_islands":"🇬🇸","kr":"🇰🇷","south_sudan":"🇸🇸","es":"🇪🇸","sri_lanka":"🇱🇰","sudan":"🇸🇩","suriname":"🇸🇷","swaziland":"🇸🇿","sweden":"🇸🇪","switzerland":"🇨🇭","syria":"🇸🇾","taiwan":"🇹🇼","tajikistan":"🇹🇯","tanzania":"🇹🇿","thailand":"🇹🇭","timor_leste":"🇹🇱","togo":"🇹🇬","tokelau":"🇹🇰","tonga":"🇹🇴","trinidad_tobago":"🇹🇹","tunisia":"🇹🇳","tr":"🇹🇷","turkmenistan":"🇹🇲","turks_caicos_islands":"🇹🇨","tuvalu":"🇹🇻","uganda":"🇺🇬","ukraine":"🇺🇦","united_arab_emirates":"🇦🇪","gb":"🇬🇧","uk":"🇬🇧","us":"🇺🇸","us_virgin_islands":"🇻🇮","uruguay":"🇺🇾","uzbekistan":"🇺🇿","vanuatu":"🇻🇺","vatican_city":"🇻🇦","venezuela":"🇻🇪","vietnam":"🇻🇳","wallis_futuna":"🇼🇫","western_sahara":"🇪🇭","yemen":"🇾🇪","zambia":"🇿🇲","zimbabwe":"🇿🇼"}

/***/ }),
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 160,
	"./af.js": 160,
	"./ar": 167,
	"./ar-dz": 161,
	"./ar-dz.js": 161,
	"./ar-kw": 162,
	"./ar-kw.js": 162,
	"./ar-ly": 163,
	"./ar-ly.js": 163,
	"./ar-ma": 164,
	"./ar-ma.js": 164,
	"./ar-sa": 165,
	"./ar-sa.js": 165,
	"./ar-tn": 166,
	"./ar-tn.js": 166,
	"./ar.js": 167,
	"./az": 168,
	"./az.js": 168,
	"./be": 169,
	"./be.js": 169,
	"./bg": 170,
	"./bg.js": 170,
	"./bm": 171,
	"./bm.js": 171,
	"./bn": 172,
	"./bn.js": 172,
	"./bo": 173,
	"./bo.js": 173,
	"./br": 174,
	"./br.js": 174,
	"./bs": 175,
	"./bs.js": 175,
	"./ca": 176,
	"./ca.js": 176,
	"./cs": 177,
	"./cs.js": 177,
	"./cv": 178,
	"./cv.js": 178,
	"./cy": 179,
	"./cy.js": 179,
	"./da": 180,
	"./da.js": 180,
	"./de": 183,
	"./de-at": 181,
	"./de-at.js": 181,
	"./de-ch": 182,
	"./de-ch.js": 182,
	"./de.js": 183,
	"./dv": 184,
	"./dv.js": 184,
	"./el": 185,
	"./el.js": 185,
	"./en-au": 186,
	"./en-au.js": 186,
	"./en-ca": 187,
	"./en-ca.js": 187,
	"./en-gb": 188,
	"./en-gb.js": 188,
	"./en-ie": 189,
	"./en-ie.js": 189,
	"./en-il": 190,
	"./en-il.js": 190,
	"./en-nz": 191,
	"./en-nz.js": 191,
	"./eo": 192,
	"./eo.js": 192,
	"./es": 195,
	"./es-do": 193,
	"./es-do.js": 193,
	"./es-us": 194,
	"./es-us.js": 194,
	"./es.js": 195,
	"./et": 196,
	"./et.js": 196,
	"./eu": 197,
	"./eu.js": 197,
	"./fa": 198,
	"./fa.js": 198,
	"./fi": 199,
	"./fi.js": 199,
	"./fo": 200,
	"./fo.js": 200,
	"./fr": 203,
	"./fr-ca": 201,
	"./fr-ca.js": 201,
	"./fr-ch": 202,
	"./fr-ch.js": 202,
	"./fr.js": 203,
	"./fy": 204,
	"./fy.js": 204,
	"./gd": 205,
	"./gd.js": 205,
	"./gl": 206,
	"./gl.js": 206,
	"./gom-latn": 207,
	"./gom-latn.js": 207,
	"./gu": 208,
	"./gu.js": 208,
	"./he": 209,
	"./he.js": 209,
	"./hi": 210,
	"./hi.js": 210,
	"./hr": 211,
	"./hr.js": 211,
	"./hu": 212,
	"./hu.js": 212,
	"./hy-am": 213,
	"./hy-am.js": 213,
	"./id": 214,
	"./id.js": 214,
	"./is": 215,
	"./is.js": 215,
	"./it": 216,
	"./it.js": 216,
	"./ja": 217,
	"./ja.js": 217,
	"./jv": 218,
	"./jv.js": 218,
	"./ka": 219,
	"./ka.js": 219,
	"./kk": 220,
	"./kk.js": 220,
	"./km": 221,
	"./km.js": 221,
	"./kn": 222,
	"./kn.js": 222,
	"./ko": 223,
	"./ko.js": 223,
	"./ku": 224,
	"./ku.js": 224,
	"./ky": 225,
	"./ky.js": 225,
	"./lb": 226,
	"./lb.js": 226,
	"./lo": 227,
	"./lo.js": 227,
	"./lt": 228,
	"./lt.js": 228,
	"./lv": 229,
	"./lv.js": 229,
	"./me": 230,
	"./me.js": 230,
	"./mi": 231,
	"./mi.js": 231,
	"./mk": 232,
	"./mk.js": 232,
	"./ml": 233,
	"./ml.js": 233,
	"./mn": 234,
	"./mn.js": 234,
	"./mr": 235,
	"./mr.js": 235,
	"./ms": 237,
	"./ms-my": 236,
	"./ms-my.js": 236,
	"./ms.js": 237,
	"./mt": 238,
	"./mt.js": 238,
	"./my": 239,
	"./my.js": 239,
	"./nb": 240,
	"./nb.js": 240,
	"./ne": 241,
	"./ne.js": 241,
	"./nl": 243,
	"./nl-be": 242,
	"./nl-be.js": 242,
	"./nl.js": 243,
	"./nn": 244,
	"./nn.js": 244,
	"./pa-in": 245,
	"./pa-in.js": 245,
	"./pl": 246,
	"./pl.js": 246,
	"./pt": 248,
	"./pt-br": 247,
	"./pt-br.js": 247,
	"./pt.js": 248,
	"./ro": 249,
	"./ro.js": 249,
	"./ru": 250,
	"./ru.js": 250,
	"./sd": 251,
	"./sd.js": 251,
	"./se": 252,
	"./se.js": 252,
	"./si": 253,
	"./si.js": 253,
	"./sk": 254,
	"./sk.js": 254,
	"./sl": 255,
	"./sl.js": 255,
	"./sq": 256,
	"./sq.js": 256,
	"./sr": 258,
	"./sr-cyrl": 257,
	"./sr-cyrl.js": 257,
	"./sr.js": 258,
	"./ss": 259,
	"./ss.js": 259,
	"./sv": 260,
	"./sv.js": 260,
	"./sw": 261,
	"./sw.js": 261,
	"./ta": 262,
	"./ta.js": 262,
	"./te": 263,
	"./te.js": 263,
	"./tet": 264,
	"./tet.js": 264,
	"./tg": 265,
	"./tg.js": 265,
	"./th": 266,
	"./th.js": 266,
	"./tl-ph": 267,
	"./tl-ph.js": 267,
	"./tlh": 268,
	"./tlh.js": 268,
	"./tr": 269,
	"./tr.js": 269,
	"./tzl": 270,
	"./tzl.js": 270,
	"./tzm": 272,
	"./tzm-latn": 271,
	"./tzm-latn.js": 271,
	"./tzm.js": 272,
	"./ug-cn": 273,
	"./ug-cn.js": 273,
	"./uk": 274,
	"./uk.js": 274,
	"./ur": 275,
	"./ur.js": 275,
	"./uz": 277,
	"./uz-latn": 276,
	"./uz-latn.js": 276,
	"./uz.js": 277,
	"./vi": 278,
	"./vi.js": 278,
	"./x-pseudo": 279,
	"./x-pseudo.js": 279,
	"./yo": 280,
	"./yo.js": 280,
	"./zh-cn": 281,
	"./zh-cn.js": 281,
	"./zh-hk": 282,
	"./zh-hk.js": 282,
	"./zh-tw": 283,
	"./zh-tw.js": 283
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 576;

/***/ }),
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(442)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(660),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(675),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(431)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(645),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(452)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(670),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(432)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(648),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(424)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(637),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(423)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(636),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(428)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(642),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(426)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(640),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(433)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(441)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(659),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(647),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(672),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(638),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(435)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(651),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(451)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(669),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(445)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(663),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(657),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(447)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(665),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(646),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(448)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(666),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(632),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(654),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(438)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(655),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(671),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(437)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(653),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(440)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(658),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(430)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(644),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(444)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(662),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(454)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(674),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(436)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(652),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(446)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(664),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(421)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(634),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(450)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(668),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(429)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(643),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(449)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(667),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(420)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(633),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(439)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(656),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(425)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(453)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(673),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.name && _vm.hideName === false) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.uniqueId
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('label.' + _vm.name)) + " "), (_vm.crequired) ? _c('small', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('select', {
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.length > 0
    },
    attrs: {
      "id": _vm.uniqueId
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  }, [(_vm.value === null || _vm.value === '') ? _c('option', {
    staticClass: "text-muted",
    domProps: {
      "value": _vm.value
    }
  }, [_vm._v(_vm._s(_vm.cplaceholder))]) : (_vm.allowNone) ? _c('option', {
    staticClass: "text-muted",
    domProps: {
      "value": ''
    }
  }, [_vm._v("-- Изчистване --")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.values), function(option, key) {
    return (option.selectable !== false) ? _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(option.text) + "\n\t\t\t")]) : _vm._e()
  }), _vm._v(" "), (_vm.allowOther && _vm.values[_vm.value] === undefined) ? _c('option', {
    domProps: {
      "value": _vm.value
    }
  }, [_vm._v(_vm._s(_vm.value))]) : _vm._e()], 2), _vm._v(" "), _vm._l((_vm.errors), function(error) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.length > 0),
        expression: "errors.length > 0"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Назад",
      "to": "/link/list"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v(" "), (_vm.canEdit) ? _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Редактирай",
      "to": '/link/' + _vm.link.id + '/edit'
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header clearfix"
  }, [_c('h4', {
    staticClass: "card-title pull-left"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.link.title) + "\n\t\t\t\t")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-icon pull-right",
    attrs: {
      "href": _vm.link.link,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" Отвори")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_c('strong', [_vm._v("Описание:")]), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.link.description) + "\n\t\t\t\t")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(0), _c('div', {
    staticClass: "clearfix"
  }, _vm._l((_vm.link.families), function(family) {
    return _c('c-avatar', {
      staticClass: "float-left",
      attrs: {
        "family": family
      }
    })
  })), _vm._v(" "), _c('p')])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Предоставен от:")])])
}]}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Отказ"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Публикувай"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "topic_title",
      "errors": _vm.errorBag.collect('topic_title')
    },
    model: {
      value: (_vm.topic.title),
      callback: function($$v) {
        _vm.$set(_vm.topic, "title", $$v)
      },
      expression: "topic.title"
    }
  }), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "topic_section",
      "values": _vm.sectionValues,
      "errors": _vm.errorBag.collect('topic_section')
    },
    model: {
      value: (_vm.topic.section),
      callback: function($$v) {
        _vm.$set(_vm.topic, "section", $$v)
      },
      expression: "topic.section"
    }
  }), _vm._v(" "), (_vm.topic.text !== undefined) ? _c('div', {
    staticClass: "row"
  }, [_c('f-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "name": "topic_text",
      "errors": _vm.errorBag.collect('topic_text'),
      "crows": 10
    },
    model: {
      value: (_vm.topic.text),
      callback: function($$v) {
        _vm.$set(_vm.topic, "text", $$v)
      },
      expression: "topic.text"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Преглед")]), _vm._v(" "), _c('vue-markdown', {
    attrs: {
      "source": _vm.topic.text
    }
  })], 1), _vm._v(" "), _vm._m(0)], 1) : _vm._e()], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6"
  }, [_vm._v("\n\t\t\t\t\t\tМоже да форматирате съобщението си като използвате "), _c('a', {
    attrs: {
      "href": "http://commonmark.org/help/",
      "target": "_blank"
    }
  }, [_vm._v("markdown")]), _vm._v(".\n\t\t\t\t\t")])
}]}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Отказ",
      "to": "/moderate/category/list"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Запис"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])], 1)])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "category_name",
      "errors": _vm.errorBag.collect('category_name'),
      "cplaceholder": '(пример: Четене)'
    },
    model: {
      value: (_vm.category.name),
      callback: function($$v) {
        _vm.$set(_vm.category, "name", $$v)
      },
      expression: "category.name"
    }
  }), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "category_scope",
      "errors": _vm.errorBag.collect('category_scope'),
      "values": _vm.$config.lists.categoryScopes
    },
    model: {
      value: (_vm.category.scope),
      callback: function($$v) {
        _vm.$set(_vm.category, "scope", $$v)
      },
      expression: "category.scope"
    }
  }), _vm._v(" "), _c('f-category', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "name": "category_parent",
      "errors": _vm.errorBag.collect('category_parent'),
      "csingle": true
    },
    model: {
      value: (_vm.category.parent),
      callback: function($$v) {
        _vm.$set(_vm.category, "parent", $$v)
      },
      expression: "category.parent"
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'pl-4': _vm.cache.categories[_vm.categoryId] && _vm.cache.categories[_vm.categoryId].parent
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [(_vm.childCategories.length && _vm.cache.categories[_vm.categoryId]) ? _c('div', {
    staticClass: "pull-left"
  }, [_c('button', {
    staticClass: "btn btn-small btn-link btn-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.expanded = !_vm.expanded
      }
    }
  }, [_c('i', {
    class: 'fa-fw fa fa-chevron-' + (_vm.expanded ? 'down' : 'right') + ' text-muted'
  })])]) : _vm._e(), _vm._v(" "), (!_vm.childCategories.length && _vm.cache.categories[_vm.categoryId]) ? _c('div', {
    staticClass: "my-1 mx-3 pull-left"
  }) : _vm._e(), _vm._v(" "), (_vm.cache.categories[_vm.categoryId]) ? _c('div', {
    staticClass: "pull-left p-1 my-2"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_vm._v(_vm._s(_vm.cache.categories[_vm.categoryId].name))])]) : _vm._e(), _vm._v(" "), (_vm.cache.categories[_vm.categoryId]) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-small btn-warning btn-icon edit",
    attrs: {
      "to": '/moderate/category/' + _vm.categoryId + '/edit'
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-small btn-danger btn-icon remove",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.remove(_vm.categoryId)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])], 1) : _vm._e()]), _vm._v(" "), _vm._l((_vm.childCategories), function(category) {
    return (_vm.expanded) ? [_c('category-tree', {
      attrs: {
        "category-id": category.id
      }
    })] : _vm._e()
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Добави",
      "to": "/moderate/category/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('category-tree', {
    attrs: {
      "category-id": 0
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', _vm._l((_vm.valueArray), function(tag, i) {
    return _c('span', {
      staticClass: "badge badge-primary tag"
    }, [_vm._v("\n\t\t" + _vm._s(_vm.categories[tag] ? _vm.categories[tag].name : _vm.$t('status.error')) + "\n\t")])
  }))
},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Назад",
      "to": "/material/list"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v(" "), (_vm.canEdit) ? _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Редактирай",
      "to": '/material/' + _vm.material.id + '/edit'
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header clearfix"
  }, [_c('h4', {
    staticClass: "card-title pull-left"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.material.title) + "\n\t\t\t\t")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-icon pull-right",
    attrs: {
      "href": _vm.material.link,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" Отвори")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_c('strong', [_vm._v("Описание:")]), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.material.description) + "\n\t\t\t\t")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(0), _c('div', {
    staticClass: "clearfix"
  }, _vm._l((_vm.material.families), function(family) {
    return _c('c-avatar', {
      staticClass: "float-left",
      attrs: {
        "family": family
      }
    })
  })), _vm._v(" "), _c('p')])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Предоставен от:")])])
}]}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataReady) ? _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header my-2"
  }, [_c('h1', [_vm._v("\n\t\t\t\t\tСемейство: " + _vm._s(_vm.registration.name) + "\n\t\t\t\t\t"), (_vm.registration.status !== 'approved') ? _c('span', {
    class: 'badge badge-' + {
      new: 'info',
      edited: 'success',
      rejected: 'danger'
    }[_vm.registration.status]
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('status.family_' + _vm.registration.status)) + "\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), (_vm.registration.status === 'new' || _vm.registration.status === 'edited') ? _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Одобрявам"
    },
    on: {
      "click": function($event) {
        _vm.approveRegistration()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Не одобрявам"
    },
    on: {
      "click": function($event) {
        _vm.rejectRegistration()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]) : _vm._e(), _vm._v(" "), (_vm.registration.status !== 'approved' && _vm.registration.statusComment) ? _c('p', [_vm._v("\n\t\t\t\t\tТова семейство е " + _vm._s(_vm.$t('status.family_' + _vm.registration.status).toLowerCase()) + " с причина: "), _c('strong', [_vm._v("\"" + _vm._s(_vm.registration.statusComment) + "\"")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Бележка към администратора: ")]), _vm._v(" "), _c('p', {
    staticClass: "about-text"
  }, [_vm._v(_vm._s(_vm.registration.note))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "basic"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "p-10"
  }, [_c('h4', [_vm._v("Родители")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fatherInfo.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fatherInfo.interests))])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.motherInfo.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.motherInfo.interests))])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Деца")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', _vm._l((_vm.familyChildren), function(child, key) {
    return _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$config.lists.childRoles[_vm.familyChildren[key].role].text))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.familyChildren[key].name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getChildAge(_vm.familyChildren[key])))])])
  }))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-10"
  }, [_c('h4', [_vm._v("Контакт")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$config.lists.countries[_vm.registration.country].text) + " / " + _vm._s(_vm.$config.lists.states[_vm.registration.state].text) + " / " + _vm._s(_vm.registration.city))])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.registration.user.email
    }
  }, [_vm._v(_vm._s(_vm.registration.user.email))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "card-img"
  }, [_c('img', {
    staticClass: "img-thumbnail family-photo",
    attrs: {
      "src": _vm.registration.photo || '/network/static/img/default_family_photo.jpg'
    }
  })]), _vm._v(" "), (_vm.registration.info.interests) ? _c('div', {
    staticClass: "mt-1"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Интереси")]), _vm._v(" "), _vm._l((_vm.registration.info.interests.split(',')), function(interest) {
    return _c('button', {
      staticClass: "btn btn-light-green btn-tag"
    }, [_vm._v(_vm._s(interest))])
  })], 2) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Накратко за нашето семейство")]), _vm._v(" "), _c('div', {
    staticClass: "p-10 about-text"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(this.registration.info.about) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Опит")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.registration.info.hsExperience) + " години")]), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Методи")]), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive"
  }, [_c('tbody', _vm._l((_vm.registration.info.hsMethods), function(method) {
    return _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$config.lists.hsmethods[method].name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$config.lists.hsmethods[method].desc))])])
  }))])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-pills md-pills",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-toggle": "tab",
      "role": "tab",
      "href": "#basic"
    }
  }, [_vm._v("Профил")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "role": "tab",
      "href": "#about"
    }
  }, [_vm._v("За нас")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Баща")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Майка")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Адрес")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("E-mail")])])
}]}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Отказ",
      "to": "/moderate/section/list"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Запис"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])], 1)])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "section_name",
      "errors": _vm.errorBag.collect('category_name'),
      "cplaceholder": '(пример: Четене)'
    },
    model: {
      value: (_vm.section.name),
      callback: function($$v) {
        _vm.$set(_vm.section, "name", $$v)
      },
      expression: "section.name"
    }
  }), _vm._v(" "), _c('f-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "name": "section_description",
      "errors": _vm.errorBag.collect('category_parent')
    },
    model: {
      value: (_vm.section.description),
      callback: function($$v) {
        _vm.$set(_vm.section, "description", $$v)
      },
      expression: "section.description"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "cat-badge",
    staticStyle: {
      "position": "absolute",
      "width": "40px",
      "height": "100%"
    },
    style: ({
      'background-color': _vm.section.color
    })
  }), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "name": "section_color",
      "errors": _vm.errorBag.collect('section_color'),
      "values": _vm.$config.lists.sectionColors,
      "allow-other": true
    },
    model: {
      value: (_vm.section.color),
      callback: function($$v) {
        _vm.$set(_vm.section, "color", $$v)
      },
      expression: "section.color"
    }
  })], 1), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "name": "section_paid",
      "errors": _vm.errorBag.collect('section_paid'),
      "values": {
        '0': {
          text: 'Не'
        },
        '1': {
          text: 'Да'
        }
      }
    },
    model: {
      value: (_vm.section.paid),
      callback: function($$v) {
        _vm.$set(_vm.section, "paid", $$v)
      },
      expression: "section.paid"
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))])])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block row"
  }, [_c('table', {
    staticClass: "table table-striped table-no-bordered table-hover table-responsive",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "datatables",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.records.items), function(registration) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('router-link', {
      attrs: {
        "to": '/moderate/registration/' + registration.id
      }
    }, [_vm._v(_vm._s(registration.name))])], 1), _vm._v(" "), _c('td', [_c('span', {
      class: 'badge badge-' + {
        new: 'info',
        edited: 'success',
        rejected: 'danger'
      }[registration.status]
    }, [_vm._v(_vm._s(_vm.$t('status.family_' + registration.status)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$config.lists.countries[registration.country].text) + " / " + _vm._s(_vm.$config.lists.states[registration.state].text))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('router-link', {
      staticClass: "btn btn-small btn-primary btn-icon edit",
      attrs: {
        "to": '/moderate/registration/' + registration.id
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })])], 1)])
  }))])])])]) : _vm._e(), _vm._v(" "), _c('f-pager', {
    attrs: {
      "total": _vm.records.total,
      "clickhandler": _vm.pageClick
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "sorting_asc",
    staticStyle: {
      "width": "143px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Име")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "215px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Статус")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "107px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Град")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "10px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Действия")])])])
}]}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(_vm.canBorrow) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#borrowModal",
      "title": "Заеми"
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v("Заеми\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Назад",
      "to": "/book/list"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v(" "), (_vm.isOwner) ? _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Редактирай",
      "to": '/book/' + _vm.book.id + '/edit'
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header clearfix"
  }, [_c('h4', {
    staticClass: "card-title pull-left"
  }, [_c('img', {
    staticStyle: {
      "width": "40px",
      "margin-right": "1rem"
    },
    attrs: {
      "src": _vm.book.image || '/network/static/img/default.jpg'
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.book.title) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w-25"
  }, [_vm._v("Автор:")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.book.author) + "\n\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Издателство:")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.book.publisher) + "\n\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Описание:")]), _vm._v(" "), _c('td', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.nl2br(_vm.book.description))
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Език:")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$config.lists.languages[_vm.book.language].text) + "\n\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Статус:")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "float-left",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$config.lists.bookStatuses[_vm.book.status].text))]), _vm._v(" "), (_vm.isStatusChangeable) ? _c('div', [_vm._m(0)]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Принадлежи на семейство:")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "clearfix"
  }, [_c('c-avatar', {
    staticClass: "float-left",
    attrs: {
      "family": _vm.book.family,
      "show-name": true
    }
  })], 1)])]), _vm._v(" "), (_vm.book.status == 'requested' && _vm.book.taker) ? _c('tr', [_c('td', [_vm._v("Поискана от семейство:"), _c('br'), _c('span', [_vm._v("(до " + _vm._s(_vm._f("prettyDate")(_vm.book.takerDueDate)) + ")")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "clearfix"
  }, [_c('c-avatar', {
    staticClass: "float-left",
    attrs: {
      "family": _vm.book.taker,
      "show-name": true
    }
  }), _vm._v(" "), (_vm.isRequested) ? _c('div', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Одобрявам"
    },
    on: {
      "click": function($event) {
        _vm.onApproveRequest()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Одобрявам")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Не одобрявам"
    },
    on: {
      "click": function($event) {
        _vm.onRejectRequest()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Не одобрявам")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.book.status == 'taken') ? _c('tr', [_c('td', [_vm._v("Дадена на семейство:"), _c('br'), _c('span', [_vm._v("(до " + _vm._s(_vm._f("prettyDate")(_vm.book.takerDueDate)) + ")")])]), _vm._v(" "), _c('td', [(_vm.book.taker) ? _c('div', {
    staticClass: "clearfix"
  }, [_c('c-avatar', {
    staticClass: "float-left",
    attrs: {
      "family": _vm.book.taker,
      "show-name": true
    }
  })], 1) : _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.book.takerExternal) + "\n\t\t\t\t\t\t\t\t\t\t")])])]) : _vm._e()])])])])]), _vm._v(" "), _c('f-modal', {
    attrs: {
      "id": "borrowModal",
      "large": true,
      "cancel-text": "Отказ"
    },
    on: {
      "ok": _vm.onBorrowBook
    }
  }, [_c('h5', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Поискване на книга")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v("Период, за който искате да използвате тази книга:")]), _vm._v(" "), _c('div', [_c('f-radio', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "borrowPeriod",
      "radios": _vm.$config.lists.borrowPeriods
    },
    model: {
      value: (_vm.borrowPeriod),
      callback: function($$v) {
        _vm.borrowPeriod = $$v
      },
      expression: "borrowPeriod"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("Семейството, което притежава книгата може да одобри или отхвърли заявката."), _c('br'), _vm._v("При одобрение двете семейства трябва да се разберат допълнително за самото изпращане на книгата.")])])])])]), _vm._v(" "), _c('f-modal', {
    attrs: {
      "id": "changeModal",
      "large": true,
      "cancel-text": "Отказ"
    },
    on: {
      "ok": _vm.onChangeStatus
    }
  }, [_c('h5', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Промяна на статуса на книгата")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "book_status",
      "errors": _vm.errorBag.collect('book_status'),
      "values": _vm.$config.lists.bookStatuses
    },
    model: {
      value: (_vm.bookStatus),
      callback: function($$v) {
        _vm.bookStatus = $$v
      },
      expression: "bookStatus"
    }
  })], 1)])]), _vm._v(" "), (_vm.bookStatus === 'taken') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('f-radio', {
    attrs: {
      "name": "takerType",
      "radios": _vm.takerTypes
    },
    model: {
      value: (_vm.takerType),
      callback: function($$v) {
        _vm.takerType = $$v
      },
      expression: "takerType"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.takerType == 1) ? _c('div', [_c('f-family', {
    attrs: {
      "cplaceholder": "Въведете име на семейство от мрежата"
    },
    model: {
      value: (_vm.takerInternal),
      callback: function($$v) {
        _vm.takerInternal = $$v
      },
      expression: "takerInternal"
    }
  })], 1) : _c('div', [_c('f-input', {
    attrs: {
      "cplaceholder": "Въведете име"
    },
    model: {
      value: (_vm.takerExternal),
      callback: function($$v) {
        _vm.takerExternal = $$v
      },
      expression: "takerExternal"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.bookStatus === 'taken') ? _c('div', [_vm._v("\n\t\t\t\t\tПериод, за който искате да дадете книгата:\n\t\t\t\t\t"), _c('div', [_c('f-radio', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "borrowPeriod",
      "radios": _vm.$config.lists.borrowPeriods
    },
    model: {
      value: (_vm.borrowPeriod),
      callback: function($$v) {
        _vm.borrowPeriod = $$v
      },
      expression: "borrowPeriod"
    }
  })], 1)]) : _vm._e()])])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#changeModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" Промени")])
}]}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))])])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "method": "get",
      "action": "/"
    }
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://calendar.google.com/calendar/htmlembed?src=%23contacts%40group.v.calendar.google.com&ctz=Europe/Sofia",
      "width": "100%",
      "height": "600",
      "frameborder": "0",
      "scrolling": "no"
    }
  })])])])])])])])
}]}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('header', {
    staticClass: "navbar navbar-default navbar-static-top",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('h1', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v(_vm._s(_vm.$t("app.title"))), _c('img', {
    attrs: {
      "src": "/network/static/img/sun.png",
      "alt": "FEN",
      "title": "FEN",
      "height": "40"
    }
  })])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "id": "column-left"
    }
  }, [_c('ul', {
    attrs: {
      "id": "menu"
    }
  }, [(_vm.$user.familyUser) ? _vm._l((_vm.$config.basicLists.menuItems), function(menuItem, key) {
    return _c('li', {
      attrs: {
        "id": key
      }
    }, [_c('router-link', {
      staticClass: "text-nowrap",
      attrs: {
        "to": menuItem.link,
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": menuItem.title
      }
    }, [_c('i', {
      staticClass: "fa fa-fw",
      class: menuItem.icon
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(menuItem.title))])])], 1)
  }) : _vm._e(), _vm._v(" "), (_vm.$user.role === 'admin' || _vm.$user.role === 'moderator') ? _c('li', {
    attrs: {
      "id": "admin"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/moderate/registration/list",
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "Регистрации"
    }
  }, [_c('i', {
    staticClass: "fa fa-users fa-fw"
  }), _c('span', [_vm._v("Регистрации")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/moderate/category/list",
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "Категории"
    }
  }, [_c('i', {
    staticClass: "fa fa-tree fa-fw"
  }), _c('span', [_vm._v("Категории")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/moderate/section/list",
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "Секции"
    }
  }, [_c('i', {
    staticClass: "fa fa-list fa-fw"
  }), _c('span', [_vm._v("Секции")])])], 1)])]) : _vm._e(), _vm._v(" "), _c('li', {
    attrs: {
      "id": "exit"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/logout",
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "Изход"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out fa-fw"
  }), _c('span', [_vm._v("Изход")])])], 1)], 2)]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "parent",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "Администрация"
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("Администрация")])])
}]}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [(_vm.pageCount) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 3,
      "click-handler": _vm.onClick,
      "prev-text": "«",
      "next-text": "»",
      "container-class": "pagination justify-content-center",
      "next-class": "page-item",
      "next-link-class": "page-link",
      "prev-class": "page-item",
      "prev-link-class": "page-link",
      "page-class": "page-item",
      "page-link-class": "page-link"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "small text-center"
  }, [_vm._v(_vm._s(_vm.fromItem) + " - " + _vm._s(_vm.toItem) + " от " + _vm._s(_vm.total))])], 1)
},staticRenderFns: []}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": _vm.family && (_vm.link === undefined ? true : _vm.link) ? '/family/' + _vm.family.id : '#'
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "alt": "",
      "src": _vm.image || (_vm.family ? _vm.family.avatar : undefined) || '/network/static/img/default_family.jpg',
      "title": _vm.family && _vm.family.name
    }
  }), _vm._v(" "), (_vm.showName) ? _c('span', [_vm._v(_vm._s(_vm.family && _vm.family.name))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('router-view')], 1)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "navbar navbar-default navbar-static-top",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "navbar-brand"
  }, [_vm._v("\n\t\t\t\tСемейна образователна мрежа "), _c('img', {
    attrs: {
      "src": "/network/static/img/sun.png",
      "alt": "FEN",
      "title": "FEN",
      "height": "40"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "pull-right my-1",
    attrs: {
      "href": "/network/logout"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out fa-fw"
  }), _vm._v(" Изход")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer text-center my-1",
    attrs: {
      "id": "footer"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.homeschoolingbg.com",
      "target": "_blank"
    }
  }, [_vm._v("Асоциация за домашно образование")]), _vm._v(" © 2017 Всички права запазени. Версия 0.0.1\n\t")])
}]}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Добави",
      "to": "/moderate/section/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block row"
  }, [_c('table', {
    staticClass: "table table-striped table-no-bordered table-hover table-responsive",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(section) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('span', {
      staticClass: "cat-badge",
      style: ('background-color:' + (section.color || 'black'))
    }), _vm._v(" "), (section.paid) ? _c('i', {
      staticClass: "fa fa-lock"
    }) : _vm._e(), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/moderate/section/' + section.id + '/edit'
      }
    }, [_vm._v(_vm._s(section.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(section.description))])])
  }))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Име")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Описание")])])])
}]}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Отказ"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Запис"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('f-image', {
    attrs: {
      "src-default": "/network/static/img/default_book.jpg",
      "width": 140,
      "height": 200,
      "avatar": false
    },
    model: {
      value: (_vm.book.image),
      callback: function($$v) {
        _vm.$set(_vm.book, "image", $$v)
      },
      expression: "book.image"
    }
  }), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "book_title",
      "errors": _vm.errorBag.collect('book_title')
    },
    model: {
      value: (_vm.book.title),
      callback: function($$v) {
        _vm.$set(_vm.book, "title", $$v)
      },
      expression: "book.title"
    }
  }), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "book_author",
      "errors": _vm.errorBag.collect('book_author')
    },
    model: {
      value: (_vm.book.author),
      callback: function($$v) {
        _vm.$set(_vm.book, "author", $$v)
      },
      expression: "book.author"
    }
  }), _vm._v(" "), _c('f-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "book_description",
      "errors": _vm.errorBag.collect('book_description'),
      "crows": 15
    },
    model: {
      value: (_vm.book.description),
      callback: function($$v) {
        _vm.$set(_vm.book, "description", $$v)
      },
      expression: "book.description"
    }
  }), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "book_publisher",
      "errors": _vm.errorBag.collect('book_publisher')
    },
    model: {
      value: (_vm.book.publisher),
      callback: function($$v) {
        _vm.$set(_vm.book, "publisher", $$v)
      },
      expression: "book.publisher"
    }
  }), _vm._v(" "), _c('f-category', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "book_categories",
      "errors": _vm.errorBag.collect('book_categories')
    },
    model: {
      value: (_vm.book.categories),
      callback: function($$v) {
        _vm.$set(_vm.book, "categories", $$v)
      },
      expression: "book.categories"
    }
  }), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "book_language",
      "errors": _vm.errorBag.collect('book_language'),
      "values": _vm.$config.lists.languages
    },
    model: {
      value: (_vm.book.language),
      callback: function($$v) {
        _vm.$set(_vm.book, "language", $$v)
      },
      expression: "book.language"
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.name && _vm.hideName === false) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.uniqueId
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('label.' + _vm.name)) + " "), (_vm.crequired) ? _c('small', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.cache.dataReady) ? _c('div', {
    staticClass: "form-inline"
  }, [_vm._l((_vm.selection), function(i, tag) {
    return _c('div', {
      staticClass: "badge badge-primary tag mb-1 text-nowrap"
    }, [_c('div', {
      staticClass: "text-truncate",
      staticStyle: {
        "max-width": "150px",
        "display": "inline-block"
      }
    }, [_vm._v(_vm._s(_vm.categories[tag] ? _vm.categories[tag].name : _vm.$t('status.error')))]), _vm._v(" "), (!_vm.csingle) ? _c('i', {
      staticClass: "fa fa-close btn-tag",
      on: {
        "click": function($event) {
          _vm.setCategory(tag, false)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "col p-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autocompleteStub),
      expression: "autocompleteStub"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.length > 0
    },
    staticStyle: {
      "padding": "2px 0",
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "id": _vm.uniqueId,
      "placeholder": _vm.cplaceholder
    },
    domProps: {
      "value": (_vm.autocompleteStub)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.setCategory(_vm.filteredCategories[0], !_vm.selection[_vm.filteredCategories[0]]);
        _vm.autocompleteStub = '';
        _vm.expanded = false
      },
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key)) { return null; }
        _vm.autocompleteStub == '' && _vm.setCategory(Object.keys(_vm.selection).slice(-1)[0], false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.autocompleteStub = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "view-button-holder"
  }, [_c('button', {
    staticClass: "btn btn-link btn-small m-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down text-muted"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "completions-box card",
    class: {
      'expanded': _vm.autocompleteStub.length !== 0 || _vm.expanded
    }
  }, [_c('category-recursive', {
    attrs: {
      "category-id": 0,
      "only-filtered": !_vm.expanded,
      "filtered-ids": _vm.filteredCategories,
      "selection": _vm.selection
    },
    on: {
      "selected": function($event) {
        _vm.setCategory($event.id, $event.value);
        _vm.autocompleteStub = '';
        _vm.expanded = false
      }
    }
  }), _vm._v(" "), (_vm.filteredCategories.length === 0 && !_vm.expanded) ? _c('div', {
    staticClass: "text-muted text-center font-italic"
  }, [_vm._v("\n\t\t\t\t\t(няма резултати)\n\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.errors), function(error) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.length > 0),
        expression: "errors.length > 0"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  })], 2)], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Отказ"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Запис"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "basic"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('f-image', {
    attrs: {
      "src-default": "/network/static/img/default_family.jpg"
    },
    model: {
      value: (_vm.family.avatar),
      callback: function($$v) {
        _vm.$set(_vm.family, "avatar", $$v)
      },
      expression: "family.avatar"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_name')))]), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "family_name",
      "hide-name": "",
      "errors": _vm.errorBag.collect('family_name'),
      "cplaceholder": "(пример: Иван и Мария Иванови)"
    },
    model: {
      value: (_vm.family.name),
      callback: function($$v) {
        _vm.$set(_vm.family, "name", $$v)
      },
      expression: "family.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_people')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_parents')))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6ex"
    }
  }, [_vm._v("Роля")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_name')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_interests')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_photo')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.$config.lists.familyRoles), function(roleDescription, role) {
    return _c('tr', [_vm._l((_vm.usersByRole[role]), function(user) {
      return [_c('td', {
        staticClass: "vertical-middle"
      }, [_c('span', [_vm._v(_vm._s(roleDescription.text))])]), _vm._v(" "), _c('td', {
        staticClass: "vertical-middle"
      }, [_c('f-input', {
        directives: [{
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        attrs: {
          "name": "person_name",
          "hide-name": "",
          "errors": _vm.errorBag.collect('person_name', 'user.' + user.id),
          "cplaceholder": '(пример: ' + roleDescription.placeholder + ')',
          "data-vv-scope": 'user.' + user.id
        },
        model: {
          value: (user.name),
          callback: function($$v) {
            _vm.$set(user, "name", $$v)
          },
          expression: "user.name"
        }
      })], 1), _vm._v(" "), _c('td', {
        staticClass: "vertical-middle"
      }, [_c('f-input', {
        attrs: {
          "cplaceholder": "(разделени със запетая)"
        },
        model: {
          value: (user.interests),
          callback: function($$v) {
            _vm.$set(user, "interests", $$v)
          },
          expression: "user.interests"
        }
      })], 1), _vm._v(" "), _c('td', [_c('f-image', {
        attrs: {
          "src-default": "/network/static/img/default.jpg"
        },
        model: {
          value: (user.avatar),
          callback: function($$v) {
            _vm.$set(user, "avatar", $$v)
          },
          expression: "user.avatar"
        }
      })], 1)]
    }), _vm._v(" "), (_vm.usersByRole[role].length === 0) ? [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "5"
      }
    }, [_c('button', {
      staticClass: "btn btn-info",
      on: {
        "click": function($event) {
          _vm.addParent(role)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" " + _vm._s(roleDescription.text))])])] : _vm._e()], 2)
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_children')))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6ex"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_name')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_sex')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_birth_year')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.usersByRole.child), function(child, key) {
    return _c('tr', [_c('td', {
      staticClass: "text-center vertical-middle"
    }, [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "name": "person_name",
        "hide-name": "",
        "errors": _vm.errorBag.collect('person_name', 'user.' + child.id),
        "cplaceholder": "Име",
        "data-vv-scope": 'user.' + child.id
      },
      model: {
        value: (child.name),
        callback: function($$v) {
          _vm.$set(child, "name", $$v)
        },
        expression: "child.name"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "name": "person_sex",
        "hide-name": "",
        "errors": _vm.errorBag.collect('person_sex', 'user.' + child.id),
        "values": _vm.$config.lists.childRoles,
        "data-vv-scope": 'user.' + child.id
      },
      model: {
        value: (child.role),
        callback: function($$v) {
          _vm.$set(child, "role", $$v)
        },
        expression: "child.role"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "name": "person_birth_year",
        "hide-name": "",
        "errors": _vm.errorBag.collect('person_birth_year', 'user.' + child.id),
        "data-vv-scope": 'user.' + child.id
      },
      model: {
        value: (child.birthYear),
        callback: function($$v) {
          _vm.$set(child, "birthYear", $$v)
        },
        expression: "child.birthYear"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('button', {
      staticClass: "btn btn-small btn-danger btn-icon remove",
      on: {
        "click": function($event) {
          _vm.removeChild(key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.addChild()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_location')))]), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "values": _vm.$config.lists.countries,
      "name": "family_country",
      "errors": _vm.errorBag.collect('family_country')
    },
    model: {
      value: (_vm.family.country),
      callback: function($$v) {
        _vm.$set(_vm.family, "country", $$v)
      },
      expression: "family.country"
    }
  }), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "values": _vm.$config.lists.states,
      "name": "family_state",
      "errors": _vm.errorBag.collect('family_state')
    },
    model: {
      value: (_vm.family.state),
      callback: function($$v) {
        _vm.$set(_vm.family, "state", $$v)
      },
      expression: "family.state"
    }
  }), _vm._v(" "), _c('f-input', {
    attrs: {
      "name": "family_city",
      "cplaceholder": "(не е задължително)"
    },
    model: {
      value: (_vm.family.city),
      callback: function($$v) {
        _vm.$set(_vm.family, "city", $$v)
      },
      expression: "family.city"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_social')))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.family_social_network')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.family_social_url')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.family.info.social), function(social, key) {
    return _c('tr', [_c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-select', {
      attrs: {
        "values": _vm.$config.lists.socialNetworks
      },
      model: {
        value: (social.name),
        callback: function($$v) {
          _vm.$set(social, "name", $$v)
        },
        expression: "social.name"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-input', {
      attrs: {
        "cplaceholder": "URL адрес"
      },
      model: {
        value: (social.url),
        callback: function($$v) {
          _vm.$set(social, "url", $$v)
        },
        expression: "social.url"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('button', {
      staticClass: "btn btn-small btn-danger btn-icon remove",
      on: {
        "click": function($event) {
          _vm.removeSocial(key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.addSocial()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])], 2)]), _vm._v(" "), _c('br')])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('f-textarea', {
    attrs: {
      "name": "family_about",
      "crows": 20
    },
    model: {
      value: (_vm.family.info.about),
      callback: function($$v) {
        _vm.$set(_vm.family.info, "about", $$v)
      },
      expression: "family.info.about"
    }
  }), _vm._v(" "), _c('f-textarea', {
    attrs: {
      "name": "family_interests",
      "crows": 3
    },
    model: {
      value: (_vm.family.info.interests),
      callback: function($$v) {
        _vm.$set(_vm.family.info, "interests", $$v)
      },
      expression: "family.info.interests"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "hs"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_experience')))]), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    attrs: {
      "name": "family_experience",
      "hide-name": "",
      "errors": _vm.errorBag.collect('family_experience'),
      "cplaceholder": "(пример: 1)"
    },
    model: {
      value: (_vm.family.info.hsExperience),
      callback: function($$v) {
        _vm.$set(_vm.family.info, "hsExperience", $$v)
      },
      expression: "family.info.hsExperience"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_methods')))]), _vm._v(" "), _c('p', [_vm._v("Моля, изберете методите за домашно образование, които използвате във вашето семейство.")]), _vm._v(" "), _vm._l((_vm.$config.lists.hsmethods), function(method, key) {
    return _c('div', {
      staticClass: "row hs_method"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('label', {
      staticClass: "custom-control custom-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.family.info.hsMethods),
        expression: "family.info.hsMethods"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.family.info.hsMethods) ? _vm._i(_vm.family.info.hsMethods, key) > -1 : (_vm.family.info.hsMethods)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.family.info.hsMethods,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.family.info.hsMethods = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.family.info.hsMethods = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.family.info, "hsMethods", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-indicator",
      class: {
        'bg-success': _vm.family.info.hsMethods.indexOf(key) !== -1
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-description"
    }, [_c('strong', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(method.name))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(method.desc) + "\n\t\t\t\t\t\t\t")])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "upimg"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('f-image', {
    attrs: {
      "src-default": "/network/static/img/default_family_photo.jpg",
      "width": 0,
      "height": 300,
      "avatar": false,
      "upload-endpoint": 'backend://family/' + _vm.family.id + '/photo'
    },
    model: {
      value: (_vm.family.photo),
      callback: function($$v) {
        _vm.$set(_vm.family, "photo", $$v)
      },
      expression: "family.photo"
    }
  })], 1)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-pills md-pills",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-toggle": "tab",
      "role": "tab",
      "href": "#basic"
    }
  }, [_vm._v("Профил")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "role": "tab",
      "href": "#about"
    }
  }, [_vm._v("За нас")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "role": "tab",
      "href": "#hs"
    }
  }, [_vm._v("Домашно образование")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "role": "tab",
      "href": "#upimg"
    }
  }, [_vm._v("Снимка")])])])
}]}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.invited_by')) + " " + _vm._s(_vm.invitation.family.name))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.acceptInvitation()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('label.accept')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.declineInvitation()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('label.decline')))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.name && _vm.hideName === false) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.uniqueId
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('label.' + _vm.name)) + " "), (_vm.crequired) ? _c('small', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.internalValue),
      expression: "internalValue"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.length > 0
    },
    style: ({
      height: (_vm.computedRows * 1.5 + 2.7) + 'em'
    }),
    attrs: {
      "placeholder": _vm.placeholder,
      "id": _vm.uniqueId
    },
    domProps: {
      "value": (_vm.internalValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.internalValue = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors), function(error) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.length > 0),
        expression: "errors.length > 0"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))])])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 stats-col"
  }, [_c('div', {
    staticClass: "card sameheight-item stats",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('h4', {
    staticClass: "card-header"
  }, [_vm._v("В мрежата")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row row-sm stats-container"
  }, [_vm._l((_vm.$config.basicLists.dashCounters), function(dashCounter, key) {
    return _c('div', {
      staticClass: "col-12 col-sm-6 stat-col"
    }, [_c('div', {
      staticClass: "stat-icon"
    }, [_c('router-link', {
      attrs: {
        "to": dashCounter.link
      }
    }, [_c('i', {
      staticClass: "fa text-success",
      class: dashCounter.icon
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "stat"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v(" " + _vm._s(_vm.report[key]) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_c('router-link', {
      staticClass: "text-muted",
      attrs: {
        "to": dashCounter.link
      }
    }, [_vm._v(_vm._s(dashCounter.title))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "stat-border"
    })])
  }), _vm._v(" "), _vm._l((_vm.$config.basicLists.resourceTypes), function(resourceType, key) {
    return _c('div', {
      staticClass: "col-12 col-sm-6  stat-col"
    }, [_c('div', {
      staticClass: "stat-icon"
    }, [_c('router-link', {
      attrs: {
        "to": resourceType.link
      }
    }, [_c('i', {
      staticClass: "fa text-success",
      class: resourceType.icon
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "stat"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v(" " + _vm._s(_vm.report.resources[key]) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_c('router-link', {
      staticClass: "text-muted",
      attrs: {
        "to": resourceType.link
      }
    }, [_vm._v(_vm._s(resourceType.title))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "stat-border"
    })])
  })], 2)])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('h4', {
    staticClass: "card-header"
  }, [_vm._v("История")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [(_vm.dataHistoryReady) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('ul', {
    staticClass: "timeline"
  }, _vm._l((_vm.history_records.items), function(item, index) {
    return _c('li', {
      class: {
        'timeline-inverted': index % 2 === 0
      }
    }, [_c('div', {
      staticClass: "timeline-badge",
      class: _vm.$config.basicLists.eventTypes[item.event_type].color
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.$config.basicLists.eventTypes[item.event_type].icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "timeline-panel"
    }, [_c('div', {
      staticClass: "timeline-body"
    }, [_c('p', [_c('c-avatar', {
      staticClass: "float-left",
      attrs: {
        "family": item.family
      }
    }), _vm._v(" "), _c('span', [_vm._v("Семейство " + _vm._s(item.family.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$config.basicLists.eventTypes[item.event_type].text) + "\n\t\t\t\t\t\t\t\t\t\t\t\t"), (item.event_type !== 'new-family') ? _c('router-link', {
      attrs: {
        "to": _vm.$config.basicLists.eventTypes[item.event_type].link + item.target_id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.info.title) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_c('i', {
      staticClass: "fa fa-clock-o",
      attrs: {
        "title": _vm._f("prettyDateTime")(item.createdAt)
      }
    }), _vm._v(" " + _vm._s(_vm._f("fromNowDateTime")(item.createdAt)))])], 1)])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/events"
    }
  }, [_c('button', {
    staticClass: "btn btn-green",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Виж всички")])])], 1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h4', {
    staticClass: "card-header"
  }, [_vm._v("Информация")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n\t\t\t\t\tОписание на менюто:\n\t\t\t\t\t"), _c('table', {
    staticClass: "table table-hover table-responsive"
  }, [_c('tbody', _vm._l((_vm.$config.basicLists.menuItems), function(menuItem, key) {
    return _c('tr', [_c('td', [_c('router-link', {
      staticClass: "text-nowrap",
      attrs: {
        "to": menuItem.link
      }
    }, [_c('i', {
      staticClass: "fa fa-lg text-success",
      class: menuItem.icon
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(menuItem.title))])])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(menuItem.comment))])])
  }))])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-12"
  }, [_c('div', {
    staticClass: "card map-card",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('h4', {
    staticClass: "card-header"
  }, [_vm._v("Семейства в България")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "map",
    attrs: {
      "id": "bgMap"
    }
  })])])])
}]}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Добави",
      "to": "/link/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "md-form form-sm"
  }, [_c('i', {
    staticClass: "fa fa-tag prefix"
  }), _vm._v(" "), _c('f-category', {
    attrs: {
      "cplaceholder": "Търсене по категория"
    },
    on: {
      "input": function($event) {
        _vm.fetchData()
      }
    },
    model: {
      value: (_vm.filter.categories),
      callback: function($$v) {
        _vm.$set(_vm.filter, "categories", $$v)
      },
      expression: "filter.categories"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "md-form form-sm"
  }, [_c('i', {
    staticClass: "fa fa-search prefix"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Търсене по заглавие, връзка, описание"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.fetchData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-no-bordered table-hover table-responsive",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.records.items), function(item) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('a', {
      staticClass: "text-primary text-truncate",
      staticStyle: {
        "display": "block",
        "max-width": "40vw"
      },
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.link) + "\n\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('c-categories', {
      attrs: {
        "value": item.categories
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', _vm._l((item.families), function(family) {
      return _c('c-avatar', {
        staticClass: "float-left",
        attrs: {
          "family": family
        }
      })
    })), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('router-link', {
      staticClass: "btn btn-small btn-primary btn-icon",
      attrs: {
        "to": '/link/' + item.id
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" "), (_vm.canEdit(item)) ? [_c('router-link', {
      staticClass: "btn btn-small btn-warning btn-icon",
      attrs: {
        "to": '/link/' + item.id + '/edit'
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-small btn-danger btn-icon m-0",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.remove(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])] : _vm._e()], 2)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('f-pager', {
    attrs: {
      "total": _vm.records.total,
      "clickhandler": _vm.pageClick
    }
  })], 1)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "sorting_asc",
    staticStyle: {
      "width": "143px"
    }
  }, [_vm._v("Връзка")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "215px"
    }
  }, [_vm._v("Описание")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("Семейство")]), _vm._v(" "), _c('th', {
    staticClass: "disabled-sorting text-right sorting",
    staticStyle: {
      "width": "102px"
    }
  }, [_vm._v("Действия")])])])
}]}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.name && _vm.hideName === false) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.uniqueId
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('label.' + _vm.name)) + " "), (_vm.crequired) ? _c('small', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.length > 0
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.cplaceholder,
      "id": _vm.uniqueId
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors), function(error) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.length > 0),
        expression: "errors.length > 0"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.isPending) ? _c('div', {
    staticClass: "alert alert-success alert-with-icon text-center"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _c('div', {
    staticClass: "alert alert-warning alert-with-icon text-center"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "card wizard-page"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_name')) + " "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("1/5")])]), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "family_name",
      "hide-name": "",
      "errors": _vm.errorBag.collect('family_name'),
      "cplaceholder": "(пример: Иван и Мария Иванови)"
    },
    model: {
      value: (_vm.family.name),
      callback: function($$v) {
        _vm.$set(_vm.family, "name", $$v)
      },
      expression: "family.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card wizard-page"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_people')) + " "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("2/5")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_parents')))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', _vm._l((_vm.$config.lists.familyRoles), function(roleDescription, role) {
    return _c('tr', [_vm._l((_vm.usersByRole[role]), function(user) {
      return [_c('td', {
        staticClass: "vertical-middle"
      }, [_c('label', {
        staticClass: "custom-control custom-radio"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.family.role),
          expression: "family.role"
        }],
        staticClass: "custom-control-input",
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": role,
          "checked": _vm._q(_vm.family.role, role)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.family, "role", role)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "custom-control-indicator",
        class: {
          'bg-success': _vm.family.role === role
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "custom-control-description"
      }, [_vm._v(_vm._s(roleDescription.text))])])]), _vm._v(" "), _c('td', {
        staticClass: "vertical-middle",
        staticStyle: {
          "width": "1px",
          "padding-right": ".4rem !important"
        }
      }, [_c('label', {
        staticClass: "control-label"
      }, [_vm._v(_vm._s(_vm.$t('label.person_name')) + ":")])]), _vm._v(" "), _c('td', {
        staticClass: "vertical-middle"
      }, [_c('f-input', {
        directives: [{
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        attrs: {
          "name": "person_name",
          "hide-name": "",
          "errors": _vm.errorBag.collect('person_name', 'user.' + user.id),
          "cplaceholder": '(пример: ' + roleDescription.placeholder + ')',
          "data-vv-scope": 'user.' + user.id
        },
        model: {
          value: (user.name),
          callback: function($$v) {
            _vm.$set(user, "name", $$v)
          },
          expression: "user.name"
        }
      })], 1), _vm._v(" "), _c('td', {
        staticClass: "vertical-middle",
        staticStyle: {
          "width": "1px",
          "padding-right": ".4rem !important"
        }
      }, [_c('label', {
        staticClass: "control-label"
      }, [_vm._v(_vm._s(_vm.$t('label.person_interests')) + ":")])]), _vm._v(" "), _c('td', {
        staticClass: "vertical-middle"
      }, [_c('f-input', {
        attrs: {
          "name": "person_interests",
          "hide-name": "",
          "cplaceholder": "(разделени със запетая)",
          "data-vv-scope": 'user.' + user.id
        },
        model: {
          value: (user.interests),
          callback: function($$v) {
            _vm.$set(user, "interests", $$v)
          },
          expression: "user.interests"
        }
      })], 1)]
    }), _vm._v(" "), (_vm.usersByRole[role].length === 0) ? [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "5"
      }
    }, [_c('button', {
      staticClass: "btn btn-info",
      on: {
        "click": function($event) {
          _vm.addParent(role)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" " + _vm._s(roleDescription.text))])])] : _vm._e()], 2)
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_children')))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6ex"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_name')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_sex')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.person_birth_year')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.usersByRole.child), function(child, key) {
    return _c('tr', [_c('td', {
      staticClass: "text-center vertical-middle"
    }, [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "name": "person_name",
        "hide-name": "",
        "errors": _vm.errorBag.collect('person_name', 'user.' + child.id),
        "data-vv-scope": 'user.' + child.id,
        "cplaceholder": "Име"
      },
      model: {
        value: (child.name),
        callback: function($$v) {
          _vm.$set(child, "name", $$v)
        },
        expression: "child.name"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "name": "person_sex",
        "hide-name": "",
        "errors": _vm.errorBag.collect('person_sex', 'user.' + child.id),
        "data-vv-scope": 'user.' + child.id,
        "values": _vm.$config.lists.childRoles
      },
      model: {
        value: (child.role),
        callback: function($$v) {
          _vm.$set(child, "role", $$v)
        },
        expression: "child.role"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('f-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "name": "person_birth_year",
        "hide-name": "",
        "errors": _vm.errorBag.collect('person_birth_year', 'user.' + child.id),
        "data-vv-scope": 'user.' + child.id
      },
      model: {
        value: (child.birthYear),
        callback: function($$v) {
          _vm.$set(child, "birthYear", $$v)
        },
        expression: "child.birthYear"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('button', {
      staticClass: "btn btn-small btn-danger btn-icon remove",
      on: {
        "click": function($event) {
          _vm.removeChild(key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.addChild()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])], 2)]), _vm._v(" "), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "card wizard-page"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_location')) + " "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("3/5")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "values": _vm.$config.lists.countries,
      "name": "family_country",
      "errors": _vm.errorBag.collect('family_country')
    },
    model: {
      value: (_vm.family.country),
      callback: function($$v) {
        _vm.$set(_vm.family, "country", $$v)
      },
      expression: "family.country"
    }
  }), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "values": _vm.$config.lists.states,
      "name": "family_state",
      "errors": _vm.errorBag.collect('family_state')
    },
    model: {
      value: (_vm.family.state),
      callback: function($$v) {
        _vm.$set(_vm.family, "state", $$v)
      },
      expression: "family.state"
    }
  }), _vm._v(" "), _c('f-input', {
    attrs: {
      "name": "family_city",
      "cplaceholder": "(не е задължително)"
    },
    model: {
      value: (_vm.family.city),
      callback: function($$v) {
        _vm.$set(_vm.family, "city", $$v)
      },
      expression: "family.city"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card wizard-page"
  }, [_c('div', {
    staticClass: "card-header card-header-text"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_about_us')) + " "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("4/5")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_experience')))]), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    attrs: {
      "name": "family_experience",
      "hide-name": "",
      "errors": _vm.errorBag.collect('family_experience'),
      "cplaceholder": "(пример: 1)"
    },
    model: {
      value: (_vm.family.info.hsExperience),
      callback: function($$v) {
        _vm.$set(_vm.family.info, "hsExperience", $$v)
      },
      expression: "family.info.hsExperience"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "card-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_methods')))]), _vm._v(" "), _c('p', [_vm._v("Моля, изберете методите за домашно образование, които използвате във вашето семейство.")]), _vm._v(" "), _vm._l((_vm.$config.lists.hsmethods), function(method, key) {
    return _c('div', {
      staticClass: "row hs_method"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('label', {
      staticClass: "custom-control custom-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.family.info.hsMethods),
        expression: "family.info.hsMethods"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.family.info.hsMethods) ? _vm._i(_vm.family.info.hsMethods, key) > -1 : (_vm.family.info.hsMethods)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.family.info.hsMethods,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.family.info.hsMethods = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.family.info.hsMethods = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.family.info, "hsMethods", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-indicator",
      class: {
        'bg-success': _vm.family.info.hsMethods.indexOf(key) !== -1
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-description"
    }, [_c('strong', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(method.name))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(method.desc) + "\n\t\t\t\t\t")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card wizard-page"
  }, [_c('div', {
    staticClass: "card-header card-header-text"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_admin_note')) + " "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("5/5")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('p', [_vm._v("\n\t\t\t\t\tМоля, пишете ни от коя среща за домашно образование се познаваме, за да можем да одобрим достъпа ви до мрежата.\n\t\t\t\t")]), _vm._v(" "), _c('f-textarea', {
    attrs: {
      "name": "family_admin_note",
      "hide-name": "",
      "cplaceholder": "",
      "crows": 15
    },
    model: {
      value: (_vm.family.note),
      callback: function($$v) {
        _vm.$set(_vm.family, "note", $$v)
      },
      expression: "family.note"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card wizard-page"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-fill btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_vm._v("Запис")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-bell"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n\t\t\t\tРегистрацията Ви изчаква одобрение от АДО!"), _c('br'), _vm._v("\n\t\t\t\tАко искате може да редактирате детайлите на вашата регистрация.\n\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-bell"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n\t\t\t\tТъй като влизате за първи път в "), _c('strong', [_vm._v("\"Семейна образователна мрежа\"")]), _vm._v(", ще трябва да регистрирате своя семеен профил."), _c('br'), _vm._v("\n\t\t\t\tРегистрацията Ви трябва да бъде одобрена от АДО, за да получите достъп до мрежата.\n\t\t\t")])
}]}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.name && _vm.hideName === false) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.uniqueId
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('label.' + _vm.name)) + " "), (_vm.crequired) ? _c('small', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputFieldValue),
      expression: "inputFieldValue"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.length > 0
    },
    staticStyle: {
      "padding": "2px 0",
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "id": _vm.uniqueId,
      "placeholder": _vm.cplaceholder
    },
    domProps: {
      "value": (_vm.inputFieldValue)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.internalValue = _vm.filteredResults[0]
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputFieldValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "autocompletions-box card",
    class: {
      'expanded': this.autocompleting
    }
  }, [_vm._l((_vm.filteredResults), function(result, i) {
    return _c('a', {
      staticClass: "completion",
      class: {
        highlighted: i == 0
      },
      on: {
        "click": function($event) {
          _vm.internalValue = result
        }
      }
    }, [_c('c-avatar', {
      attrs: {
        "family": result,
        "link": false
      }
    }), _vm._v(" " + _vm._s(result.name) + "\n\t\t\t")], 1)
  }), _vm._v(" "), (_vm.cache.requestRunning) ? _c('div', {
    staticClass: "text-muted text-center font-italic"
  }, [_vm._v("\n\t\t\t\t(...)\n\t\t\t")]) : (_vm.cache.results.length === 0 && _vm.autocompleteStub !== '') ? _c('div', {
    staticClass: "text-muted text-center font-italic"
  }, [_vm._v("\n\t\t\t\t(няма резултати)\n\t\t\t")]) : _vm._e()], 2), _vm._v(" "), _vm._l((_vm.errors), function(error) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.length > 0),
        expression: "errors.length > 0"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container text-center"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/network/static/img/logo.jpg"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Страницата не е намерена")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("към Начална страница")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Отказ"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Запис"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "link_title",
      "errors": _vm.errorBag.collect('link_title')
    },
    model: {
      value: (_vm.link.title),
      callback: function($$v) {
        _vm.$set(_vm.link, "title", $$v)
      },
      expression: "link.title"
    }
  }), _vm._v(" "), _c('f-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "link_description",
      "errors": _vm.errorBag.collect('link_description')
    },
    model: {
      value: (_vm.link.description),
      callback: function($$v) {
        _vm.$set(_vm.link, "description", $$v)
      },
      expression: "link.description"
    }
  }), _vm._v(" "), _c('f-category', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "link_categories",
      "errors": _vm.errorBag.collect('link_categories')
    },
    model: {
      value: (_vm.link.categories),
      callback: function($$v) {
        _vm.$set(_vm.link, "categories", $$v)
      },
      expression: "link.categories"
    }
  }), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "link_language",
      "errors": _vm.errorBag.collect('link_language'),
      "values": _vm.$config.lists.languages
    },
    model: {
      value: (_vm.link.language),
      callback: function($$v) {
        _vm.$set(_vm.link, "language", $$v)
      },
      expression: "link.language"
    }
  }), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "link_link",
      "errors": _vm.errorBag.collect('link_link')
    },
    model: {
      value: (_vm.link.link),
      callback: function($$v) {
        _vm.$set(_vm.link, "link", $$v)
      },
      expression: "link.link"
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block row"
  }, _vm._l((_vm.records.items), function(familyInfo) {
    return _c('div', {
      staticClass: "col-md-6 col-lg-3"
    }, [_c('div', {
      staticClass: "card card-cascade narrower"
    }, [_c('div', {
      staticClass: "view overlay hm-white-slight"
    }, [_c('div', {
      staticClass: "background img-fluid",
      style: ({
        backgroundImage: 'url(\'' + (familyInfo.photo || '/network/static/img/default_family_photo.jpg') + '\')'
      })
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/family/' + familyInfo.id
      }
    }, [_c('div', {
      staticClass: "mask waves-effect waves-light"
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "card-block text-center"
    }, [_c('h4', {
      staticClass: "card-title"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(familyInfo.name) + "\n\t\t\t\t\t\t\t\t"), (familyInfo.paid) ? _c('small', [_c('i', {
      staticClass: "fa fa-star-o"
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "card-text"
    }, [_vm._v(_vm._s(_vm.$config.lists.countries[familyInfo.country].text) + " / " + _vm._s(_vm.$config.lists.states[familyInfo.state].text))])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer text-center"
    }, [_c('p', _vm._l((familyInfo.users), function(child) {
      return _c('span', {
        staticClass: "child-age text-gray",
        attrs: {
          "title": child.name
        }
      }, [_c('i', {
        staticClass: "child-icon fa",
        class: child.role == 'son' ? 'fa-male' : 'fa-female'
      }), _vm._v(" " + _vm._s(_vm.getChildAge(child)) + "г\n\t\t\t\t\t\t\t")])
    }))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('f-pager', {
    attrs: {
      "total": _vm.records.total,
      "clickhandler": _vm.pageClick
    }
  })], 1)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Семействa")])])])])
}]}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-input"
  }, [_c('label', {
    staticClass: "clearfix",
    style: ({
      width: _vm.width ? _vm.width + 'px' : '100%',
      height: _vm.height ? _vm.height + 'px' : 'initial'
    })
  }, [_c('canvas'), _vm._v(" "), (!_vm.srcDefault) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.preview),
      expression: "!preview"
    }],
    staticClass: "icon fa fa-picture-o"
  }) : _vm._e(), _vm._v(" "), (_vm.srcDefault) ? _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.preview),
      expression: "!preview"
    }],
    class: {
      avatar: _vm.avatar
    },
    attrs: {
      "src": _vm.srcDefault
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.preview),
      expression: "preview"
    }],
    class: {
      avatar: _vm.avatar
    },
    attrs: {
      "src": _vm.preview
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input",
    attrs: {
      "name": "image",
      "type": "file"
    },
    on: {
      "change": _vm.imageChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-load fa fa-upload"
  })])])
},staticRenderFns: []}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(_vm.canDeleteTopic()) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Изтриване"
    },
    on: {
      "click": function($event) {
        _vm.deleteTopic()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Назад"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.error) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "comments col-md-12",
    attrs: {
      "id": "comments"
    }
  }, [_c('div', {
    staticClass: "topic-title"
  }, [_c('h3', {
    staticClass: "clearfix"
  }, [_vm._v(_vm._s(_vm.topic.title))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "cat-badge",
    style: ('background-color:' + (_vm.topic.section.color || 'black'))
  }), _vm._v(" " + _vm._s(_vm.topic.section.name))])]), _vm._v(" "), _vm._l((_vm.topic.posts), function(item, i) {
    return _c('div', {
      staticClass: "comment mt-10 mb-2 row"
    }, [_c('div', {
      staticClass: "comment-avatar col-md-1 col-sm-2 text-right pr-1"
    }, [_c('c-uavatar', {
      attrs: {
        "familyuser": item.author,
        "show-name": false
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "comment-content col-md-11 col-sm-10"
    }, [_c('h6', {
      staticClass: "comment-meta"
    }, [_c('router-link', {
      staticClass: "text-secondary",
      attrs: {
        "to": item.author ? '/family/' + item.author.family : '#',
        "title": item.author.name
      }
    }, [_vm._v(_vm._s(item.author.name))]), _vm._v(" "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("▪")]), _vm._v(" "), _c('small', {
      staticClass: "text-muted",
      attrs: {
        "title": _vm._f("prettyDateTime")(item.createdAt)
      }
    }, [_vm._v(_vm._s(_vm._f("fromNowDateTime")(item.createdAt)))]), _vm._v(" "), (item.updatedAt != item.createdAt) ? _c('small', {
      staticClass: "text-muted",
      attrs: {
        "title": _vm._f("fromNowDateTime")(item.updatedAt)
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "comment-body"
    }, [(item.editing && item.text != item.originalText) ? _c('div', {
      staticClass: "alert alert-danger",
      attrs: {
        "role": "alert"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tТова е само преглед; редактирания коментар все още не е записан.\n\t\t\t\t\t\t\t\t\t\t\t"), _c('a', {
      staticClass: "alert-link",
      on: {
        "click": function($event) {
          _vm.sendEdit(item)
        }
      }
    }, [_c('u', [_vm._v("Натиснете тук за да запишете.")])])]) : _vm._e(), _vm._v(" "), _c('vue-markdown', {
      attrs: {
        "source": item.text,
        "html": false
      }
    }), _vm._v(" "), (item.editing) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('label.forum_edit')))]), _vm._v(" "), _c('f-textarea', {
      attrs: {
        "placeholder": "Редактирайте вашия отговор",
        "crows": 10
      },
      model: {
        value: (item.text),
        callback: function($$v) {
          _vm.$set(item, "text", $$v)
        },
        expression: "item.text"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tМоже да форматирате съобщението си като използвате "), _c('a', {
      attrs: {
        "href": "http://commonmark.org/help/",
        "target": "_blank"
      }
    }, [_vm._v("markdown")]), _vm._v(".\n\t\t\t\t\t\t\t\t\t\t\t"), _c('div', {
      staticClass: "text-right"
    }, [_c('button', {
      staticClass: "btn btn-primary mt-0",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toggleEdit(item)
        }
      }
    }, [_vm._v("Отмяна")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary mt-0",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.sendEdit(item)
        }
      }
    }, [_vm._v("Запис")])])], 1) : _vm._e(), _vm._v(" "), _c('section', {
      staticClass: "post-menu-area clearfix"
    }, [_c('nav', {
      staticClass: "post-controls clearfix"
    }, [_c('div', {
      staticClass: "actions"
    }, [(i != 0 && _vm.canDelete(item)) ? _c('button', {
      staticClass: "widget-button btn-flat btn-danger",
      on: {
        "click": function($event) {
          _vm.deletePost(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.canEdit(item)) ? _c('button', {
      staticClass: "widget-button btn-flat btn-primary",
      on: {
        "click": function($event) {
          _vm.toggleEdit(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "widget-button btn-flat btn-info",
      on: {
        "click": function($event) {
          _vm.addQuote(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-reply",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])], 1)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row pt-2"
  }, [_c('div', {
    staticClass: "col-md-1 col-sm-2 text-center pr-1"
  }, [_c('c-uavatar', {
    staticClass: "float-right",
    attrs: {
      "familyuser": _vm.$user.familyUser,
      "show-name": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-11 col-sm-10"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('label.forum_reply')))]), _vm._v(" "), _c('f-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "placeholder": "Напишете вашия отговор",
      "crows": 10,
      "errors": _vm.errorBag.collect('forum_reply')
    },
    model: {
      value: (_vm.pending.text),
      callback: function($$v) {
        _vm.$set(_vm.pending, "text", $$v)
      },
      expression: "pending.text"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\tМоже да форматирате съобщението си като използвате "), _c('a', {
    attrs: {
      "href": "http://commonmark.org/help/",
      "target": "_blank"
    }
  }, [_vm._v("markdown")]), _vm._v(".\n\t\t\t\t\t\t\t\t\t"), _c('button', {
    staticClass: "btn btn btn-primary pull-right mt-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendReply
    }
  }, [_vm._v("Отговор")])], 1)])], 2)])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-danger alert-with-icon text-center"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-bell"
  })]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tНямате достъп до тази тема!\n\t\t\t\t")])])
}]}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    class: {
      'modal-dialog': true, 'modal-lg': _vm.large, 'modal-sm': _vm.small
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._t("title", [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t\t\t")])], 2), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._t("modal-body", [_c('div', {
    staticClass: "modal-body"
  })]), _vm._v(" "), _vm._t("modal-footer", [_c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.onOK
    }
  }, [_vm._v(_vm._s(_vm.okText))])])])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio form-inline"
  }, [_vm._l((_vm.radios), function(radio, index) {
    return _c('div', [_c('label', {
      staticStyle: {
        "padding-right": "10px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedItem),
        expression: "selectedItem"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ((index == 0) ? 'required' : ''),
        expression: "(index == 0) ? 'required': ''"
      }],
      attrs: {
        "type": "radio",
        "name": _vm.name,
        "id": _vm.name + '_' + index,
        "disabled": radio.disabled === true
      },
      domProps: {
        "value": radio.value,
        "checked": _vm._q(_vm.selectedItem, radio.value)
      },
      on: {
        "change": [function($event) {
          _vm.selectedItem = radio.value
        }, _vm.onChange]
      }
    }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(radio.label) + "\n\t\t\t\t")])])
  }), _vm._v(" "), _vm._l((_vm.errors), function(error) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.length > 0),
        expression: "errors.length > 0"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Добави",
      "to": "/book/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "md-form form-sm"
  }, [_c('i', {
    staticClass: "fa fa-tag prefix"
  }), _vm._v(" "), _c('f-category', {
    attrs: {
      "cplaceholder": "Търсене по категория"
    },
    on: {
      "input": function($event) {
        _vm.fetchData()
      }
    },
    model: {
      value: (_vm.filter.categories),
      callback: function($$v) {
        _vm.$set(_vm.filter, "categories", $$v)
      },
      expression: "filter.categories"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "md-form form-sm"
  }, [_c('i', {
    staticClass: "fa fa-search prefix"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Търсене по заглавие, автор, издателство, описание"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.fetchData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "md-form form-sm"
  }, [_c('i', {
    staticClass: "fa fa-search prefix"
  }), _vm._v(" "), _c('f-family', {
    attrs: {
      "cplaceholder": "Търсене по семейство"
    },
    on: {
      "input": function($event) {
        _vm.fetchData()
      }
    },
    model: {
      value: (_vm.filter.family),
      callback: function($$v) {
        _vm.$set(_vm.filter, "family", $$v)
      },
      expression: "filter.family"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('f-select', {
    attrs: {
      "values": _vm.$config.lists.bookStatuses,
      "hide-name": true,
      "allow-none": "",
      "cplaceholder": "Търсене по статус"
    },
    on: {
      "input": function($event) {
        _vm.fetchData()
      }
    },
    model: {
      value: (_vm.filter.status),
      callback: function($$v) {
        _vm.$set(_vm.filter, "status", $$v)
      },
      expression: "filter.status"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('table', {
    staticClass: "table table-striped table-no-bordered table-hover table-responsive",
    attrs: {
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.records.items), function(item) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "vertical-middle"
    }, [_c('img', {
      staticStyle: {
        "width": "50px",
        "float": "left",
        "margin": "5px"
      },
      attrs: {
        "alt": "",
        "src": item.image || '/network/static/img/default_book.jpg'
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_vm._v(_vm._s(item.title)), _c('br'), _vm._v(" "), _c('c-categories', {
      attrs: {
        "value": item.categories
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_vm._v(_vm._s(item.author))]), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_vm._v(_vm._s(item.publisher))]), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('span', {
      class: 'tag badge badge-' + _vm.$config.lists.bookStatuses[item.status].style
    }, [_vm._v(_vm._s(_vm.$t('status.book_' + item.status)))])]), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('div', {
      staticClass: "text-center float-left"
    }, [(item.taker) ? _c('span', [_vm._v("на")]) : _vm._e(), _c('br'), _vm._v(" "), _c('c-avatar', {
      staticClass: "float-left",
      attrs: {
        "family": item.family
      }
    })], 1), _vm._v(" "), (item.taker) ? _c('div', {
      staticClass: "text-center float-left"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tпри"), _c('br'), _vm._v(" "), _c('c-avatar', {
      attrs: {
        "family": item.taker
      }
    }), _vm._v(" "), _c('br'), _vm._v("до"), _c('br'), _vm._v("  " + _vm._s(_vm._f("prettyDate")(item.takerDueDate)) + "\n\t\t\t\t\t\t\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (item.takerExternal) ? _c('div', {
      staticClass: "text-center float-left",
      staticStyle: {
        "max-width": "100px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tпри"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t[" + _vm._s(item.takerExternal) + "]\n\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("до"), _c('br'), _vm._v("  " + _vm._s(_vm._f("prettyDate")(item.takerDueDate)) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle text-right text-nowrap"
    }, [_c('router-link', {
      staticClass: "btn btn-small btn-primary btn-icon",
      attrs: {
        "to": '/book/' + item.id
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" "), (_vm.canEdit(item)) ? [_c('router-link', {
      staticClass: "btn btn-small btn-warning btn-icon",
      attrs: {
        "to": '/book/' + item.id + '/edit'
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-small btn-danger btn-icon m-0",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.remove(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])] : _vm._e()], 2)])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('f-pager', {
    attrs: {
      "total": _vm.records.total,
      "clickhandler": _vm.pageClick
    }
  })], 1)])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "60px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Заглавие")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Автор")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Издателство")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Статус")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Семейство")]), _vm._v(" "), _c('th', {
    staticClass: "disabled-sorting text-right sorting",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Действие")])])])
}]}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Добави",
      "to": "/discussion/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "md-form form-sm"
  }, [_c('i', {
    staticClass: "fa fa-search prefix"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.search),
      expression: "filter.search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Търсене по тема"
    },
    domProps: {
      "value": (_vm.filter.search)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.fetchData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('f-select', {
    attrs: {
      "values": _vm.sectionValues,
      "hide-name": true,
      "allow-none": "",
      "cplaceholder": "Търсене по секция"
    },
    on: {
      "input": function($event) {
        _vm.fetchData()
      }
    },
    model: {
      value: (_vm.filter.section),
      callback: function($$v) {
        _vm.$set(_vm.filter, "section", $$v)
      },
      expression: "filter.section"
    }
  })], 1)]), _vm._v(" "), _c('table', {
    staticClass: "table table-no-bordered table-hover table-responsive",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.records.items), function(item) {
    return _c('tr', {
      attrs: {
        "role": "row",
        "tabindex": (item.section.paid || 0) > (_vm.$user.familyUser.family.paid || 0) ? -1 : 0
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
          _vm.$router.push('/discussion/' + item.id)
        },
        "click": function($event) {
          ((item.section.paid || 0) > (_vm.$user.familyUser.family.paid || 0)) || _vm.$router.push('/discussion/' + item.id)
        }
      }
    }, [_c('td', [((item.section.paid || 0) > (_vm.$user.familyUser.family.paid || 0)) ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(item.title))]) : _c('span', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "cat-badge",
      style: ('background-color:' + (item.section.color || 'black'))
    }), _vm._v(" "), ((item.section.paid || 0) > (_vm.$user.familyUser.family.paid || 0)) ? _c('i', {
      staticClass: "fa fa-lock"
    }) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.section.name) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.postCount))]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      attrs: {
        "title": _vm._f("prettyDateTime")(item.updatedAt)
      }
    }, [_vm._v(_vm._s(_vm._f("fromNowDateTime")(item.updatedAt)))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('f-pager', {
    attrs: {
      "total": _vm.records.total,
      "clickhandler": _vm.pageClick
    }
  })], 1)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "sorting_asc",
    staticStyle: {
      "width": "143px"
    }
  }, [_vm._v("Тема")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "215px"
    }
  }, [_vm._v("Секция")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "20px"
    }
  }, [_vm._v("Отговори")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Последно")])])])
}]}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category"
  }, [(_vm.cache.categories[_vm.categoryId]) ? _c('label', {
    staticClass: "custom-control custom-checkbox category-name",
    class: {
      highlighted: _vm.filteredIds[0] === _vm.categoryId
    }
  }, [_c('input', {
    staticClass: "custom-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.selection[_vm.categoryId]
    },
    on: {
      "click": function($event) {
        _vm.$emit('selected', {
          id: _vm.categoryId,
          value: $event.target.checked
        })
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-control-indicator"
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-control-description"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.cache.categories[_vm.categoryId].name) + "\n\t\t")])]) : _vm._e(), _vm._v(" "), ((_vm.childrenToShow.length || !this.expanded) && _vm.cache.categories[_vm.categoryId]) ? _c('button', {
    staticClass: "category-button pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.expanded = !_vm.expanded
      }
    }
  }, [_c('i', {
    class: 'fa-fw fa fa-chevron-' + (_vm.expanded ? 'down' : 'right') + ' text-muted'
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.childrenToShow), function(category) {
    return [_c('category-recursive', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.expanded),
        expression: "expanded"
      }],
      attrs: {
        "category-id": category.id,
        "filtered-ids": _vm.filteredIds,
        "only-filtered": _vm.onlyFiltered,
        "selection": _vm.selection
      },
      on: {
        "selected": function($event) {
          _vm.$emit('selected', $event)
        }
      }
    })]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container "
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container card-login-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-10 col-md-offset-1"
  }, [_c('form', {
    attrs: {
      "method": "#",
      "action": "#"
    }
  }, [_c('div', {
    staticClass: "card card-login"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/network/static/img/logo.jpg"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block\ttext-center"
  }, [(_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', [_vm._v(_vm._s(_vm.response))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "social-line"
  }, [_c('button', {
    staticClass: "loginBtn loginBtn--google",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.login('google')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tВлезте с Google акаунт\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Семейна образователна мрежа")])])
}]}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('ul', {
    staticClass: "timeline"
  }, _vm._l((_vm.records.items), function(item, index) {
    return (_vm.$config.basicLists.eventTypes[item.event_type]) ? _c('li', {
      class: {
        'timeline-inverted': index % 2 === 0
      }
    }, [_c('div', {
      staticClass: "timeline-badge",
      class: _vm.$config.basicLists.eventTypes[item.event_type].color
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.$config.basicLists.eventTypes[item.event_type].icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "timeline-panel"
    }, [_c('div', {
      staticClass: "timeline-body"
    }, [_c('p', [_c('c-avatar', {
      staticClass: "float-left",
      attrs: {
        "family": item.family
      }
    }), _vm._v(" "), _c('span', [_vm._v("Семейство " + _vm._s(item.family.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$config.basicLists.eventTypes[item.event_type].text) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), (item.event_type !== 'new-family') ? _c('router-link', {
      attrs: {
        "to": _vm.$config.basicLists.eventTypes[item.event_type].link + item.target_id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.info.title) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_c('i', {
      staticClass: "fa fa-clock-o",
      attrs: {
        "title": _vm._f("prettyDateTime")(item.createdAt)
      }
    }), _vm._v(" " + _vm._s(_vm._f("fromNowDateTime")(item.createdAt)))])], 1)])])]) : _vm._e()
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('f-pager', {
    attrs: {
      "total": _vm.records.total,
      "clickhandler": _vm.pageClick
    }
  })], 1)])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "text-secondary",
    attrs: {
      "to": _vm.familyuser ? '/family/' + (typeof _vm.familyuser.family === 'object' ? _vm.familyuser.family : _vm.familyuser.family.id) : '#'
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "alt": "",
      "src": _vm.image || (_vm.familyuser ? _vm.familyuser.avatar : undefined) || '/network/static/img/default.jpg',
      "title": _vm.familyuser && _vm.familyuser.name
    }
  }), _vm._v(" "), (_vm.showName) ? _c('span', [_vm._v(_vm._s(_vm.familyuser && _vm.familyuser.name))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Добави",
      "to": "/material/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "md-form form-sm"
  }, [_c('i', {
    staticClass: "fa fa-tag prefix"
  }), _vm._v(" "), _c('f-category', {
    attrs: {
      "cplaceholder": "Търсене по категория"
    },
    on: {
      "input": function($event) {
        _vm.fetchData()
      }
    },
    model: {
      value: (_vm.filter.categories),
      callback: function($$v) {
        _vm.$set(_vm.filter, "categories", $$v)
      },
      expression: "filter.categories"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "md-form form-sm"
  }, [_c('i', {
    staticClass: "fa fa-search prefix"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Търсене по заглавие, връзка, описание"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.fetchData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-no-bordered table-hover table-responsive",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.records.items), function(item) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1",
      attrs: {
        "tabindex": "0"
      }
    }, [_c('router-link', {
      staticClass: "text-primary",
      attrs: {
        "to": '/material/' + item.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t\t\t\t")]), _c('br'), _vm._v(" "), _c('c-categories', {
      attrs: {
        "value": item.categories
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-truncate",
      staticStyle: {
        "max-width": "300px"
      }
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', _vm._l((item.families), function(family) {
      return _c('c-avatar', {
        staticClass: "float-left",
        attrs: {
          "family": family
        }
      })
    })), _vm._v(" "), _c('td', {
      staticClass: "text-right pr-3"
    }, [_c('a', {
      staticClass: "btn btn-small btn-primary btn-icon",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text"
    })]), _vm._v(" "), (_vm.canEdit(item)) ? [_c('router-link', {
      staticClass: "btn btn-small btn-warning btn-icon",
      attrs: {
        "to": '/material/' + item.id + '/edit'
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-small btn-danger btn-icon m-0",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.remove(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])] : _vm._e()], 2)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('f-pager', {
    attrs: {
      "total": _vm.records.total,
      "clickhandler": _vm.pageClick
    }
  })], 1)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "sorting_asc",
    staticStyle: {
      "width": "143px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Заглавие")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "215px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Описание")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "10px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Семейства")]), _vm._v(" "), _c('th', {
    staticClass: "disabled-sorting text-right sorting",
    staticStyle: {
      "width": "102px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Действия")])])])
}]}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataReady) ? _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header my-2"
  }, [_c('c-avatar', {
    staticStyle: {
      "position": "relative",
      "top": "-5px"
    },
    attrs: {
      "image": _vm.family.avatar || '/network/static/img/default_family.jpg',
      "title": _vm.family.name
    }
  }), _vm._v(" "), _c('h1', [_vm._v("\n\t\t\t\t\tСемейство: " + _vm._s(_vm.family.name) + "\n\t\t\t\t\t"), (_vm.family.paid) ? _c('small', [_c('i', {
    staticClass: "fa fa-star-o"
  })]) : _vm._e()]), _vm._v(" "), (_vm.family.id === _vm.$user.familyUser.family.id) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/family/me/edit",
      "data-toggle": "tooltip",
      "title": "Редактирай"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "basic"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "p-10"
  }, [_c('h4', [_vm._v("Родители")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [_vm._l((_vm.$config.lists.familyRoles), function(roleDescription, role) {
    return _vm._l((_vm.usersByRole[role]), function(user) {
      return _c('tr', [_c('td', {
        staticClass: "align-middle text-nowrap w-25"
      }, [_c('c-avatar', {
        staticStyle: {
          "display": "inline-block"
        },
        attrs: {
          "image": user.avatar || '/network/static/img/default.jpg',
          "title": user.name
        }
      }), _c('strong', [_vm._v(_vm._s(roleDescription.text))])], 1), _vm._v(" "), _c('td', {
        staticClass: "align-middle text-nowrap"
      }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
        staticClass: "align-middle"
      }, [_vm._v(_vm._s(user.interests))]), _vm._v(" "), (_vm.family.id === _vm.$user.familyUser.family.id) ? _c('td', {
        staticClass: "align-middle text-center",
        staticStyle: {
          "width": "1px"
        }
      }, [(!user.user) ? [_c('button', {
        staticClass: "btn btn-sm btn-success",
        attrs: {
          "title": "Покани",
          "data-toggle": "modal",
          "data-target": "#inviteUserModal"
        },
        on: {
          "click": function($event) {
            _vm.inviteUser(user)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-plus"
      })])] : (_vm.$user.familyUser.id === user.id) ? [_c('i', {
        staticClass: "fa fa-star",
        attrs: {
          "title": "Това сте вие"
        }
      })] : _vm._e()], 2) : _vm._e()])
    })
  })], 2)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Деца")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', _vm._l((_vm.usersByRole.child), function(child) {
    return _c('tr', [_c('td', {
      staticClass: "w-25"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$config.lists.childRoles[child.role].text))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(child.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getChildAge(child)))])])
  }))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-10"
  }, [_c('h4', [_vm._v("Контакти")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w-25"
  }, [_vm._v("Адрес")]), _vm._v(" "), (_vm.dataReady) ? _c('td', [_vm._v(_vm._s(_vm.$config.lists.countries[_vm.family.country].text) + " / " + _vm._s(_vm.$config.lists.states[_vm.family.state].text) + " " + _vm._s(_vm.family.city ? '/ ' + _vm.family.city : ''))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("E-mail")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.family.email
    }
  }, [_vm._v(_vm._s(_vm.family.email))])])])])])]), _vm._v(" "), (_vm.family.info.social && _vm.family.info.social.length !== 0) ? _c('h5', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('label.family_social')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.family.info.social), function(social) {
    return _c('a', {
      staticClass: "btn btn-blue btn-tag",
      attrs: {
        "href": social.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.$config.lists.socialNetworks[social.name].text))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "card-img"
  }, [_c('img', {
    staticClass: "img-thumbnail",
    staticStyle: {
      "max-height": "300px"
    },
    attrs: {
      "src": _vm.family.photo || '/network/static/img/default_family_photo.jpg'
    }
  })]), _vm._v(" "), (_vm.family.info.interests) ? _c('div', {
    staticClass: "mt-1"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Интереси")]), _vm._v(" "), _vm._l((_vm.family.info.interests.split(',')), function(interest) {
    return _c('button', {
      staticClass: "btn btn-light-green btn-tag"
    }, [_vm._v(_vm._s(interest))])
  })], 2) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Накратко за нашето семейство")]), _vm._v(" "), _c('div', {
    staticClass: "p-10 about-text"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(this.family.info.about || 'Скоро ще напишем нещо за нас...') + "\n\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "hs"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Опит")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.family.info.hsExperience) + " години")]), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Методи")]), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive"
  }, [_c('tbody', _vm._l((_vm.family.info.hsMethods), function(method) {
    return _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$config.lists.hsmethods[method].name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$config.lists.hsmethods[method].desc))])])
  }))])])])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "inviteUserModal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), (_vm.invitedUser) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("За да добавите " + _vm._s(_vm.invitedUser.name) + " към мрежата, отворете този линк с неговия/нейния акаунт:")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "word-break": "break-all"
    },
    attrs: {
      "href": _vm.invitedUser.invitationLink
    }
  }, [_vm._v(_vm._s(_vm.invitedUser.invitationLink))])]) : _c('div', {
    staticClass: "modal-body"
  }), _vm._v(" "), _vm._m(3)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-pills md-pills",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-toggle": "tab",
      "role": "tab",
      "href": "#basic"
    }
  }, [_vm._v("Профил")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "role": "tab",
      "href": "#about"
    }
  }, [_vm._v("За нас")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "role": "tab",
      "href": "#hs"
    }
  }, [_vm._v("Домашно образование")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "role": "tab",
      "href": "#shared"
    }
  }, [_vm._v("Споделено")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "shared"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Споделени ресурси")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('table', {
    staticClass: "table table-responsive"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("Книги")])]), _vm._v(" "), _c('td', [_vm._v("0 (заети: 0)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Учебни материали")])]), _vm._v(" "), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Връзки")])]), _vm._v(" "), _c('td', [_vm._v("0")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('table', {
    staticClass: "table table-responsive"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("Форум съобщения")])]), _vm._v(" "), _c('td', [_vm._v("0 (този месец: 0)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Форум нови теми")])]), _vm._v(" "), _c('td', [_vm._v("0")])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Покана за Семейна Образователна Мрежа")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Затвори")])])
}]}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(295);
module.exports = __webpack_require__(294);


/***/ })
]),[683]);


// WEBPACK FOOTER //
// static/js/app.a95098c417c7a02601ba.js